import {
  Component,
  HostListener,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { ChatbotService } from './../../common/services/chatbot.service';
import {
  AlertMessageModel,
  InsightsModel,
  results,
} from 'src/app/common/models/common.model';
import { CrosstabService } from '../../common/services/crosstab.service';
import { LoaderService } from 'src/app/common/services/loader.service';
import { ExportDownloadServices } from 'src/app/common/services/exports-downloads.service';
import { SharedChatService } from 'src/app/common/services/shared-chat.service';
import {
  ExcelExportReport,
  ExcelExportReportInputs,
} from 'src/app/common/models/excel-export-report.model';
import { filter, Subscription, switchMap, take, tap, firstValueFrom, forkJoin } from 'rxjs';
import {
  DataObject,
  checkboxSelection,
  checkboxSelectionWithParent,
  Level,
  OutputDataObject,
  OutputSelection,
  OutPutSelectionWithParent,
  CrossTabOutputItem,
  ExcelDataModel,
  Data,
  Child,
  Entry,
  DataEntry,
  SelectionObject,
  StackChart,
  LineChart,
  GroupBarChart,
  CancelEntryPointItem,
} from 'src/app/common/models/crosstab.model';
import { Feature } from 'src/app/common/models/usermanagement.model';
import { InsightspopupService } from 'src/app/common/services/insightspopup.service';
import { Status } from 'src/app/common/models/enum/status.enum';
import { set } from 'lodash';
import {
  fomData,
  GetDataArray,
  StudyData,
  ChartDetails,
  DiagnosticData,
  ChatListDocument,
  ChatHistoryDocument,
  ChatAnswerDocument,
  UserIdentityDocument,
  ChatHistoryResponse,
  SaveChatResponseRequest,
} from 'src/app/common/models/chatbotexpand.model';
import { UserProjectManagementService } from 'src/app/common/services/user-project-management.service';
import {
  BUTTON_HOVER_NAMES,
  COMMON_CONSTANTS,
} from 'src/app/common/constants/common-constants';

import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { CustomsnapshotService } from '../snapshot/Services/customsnapshot.service';
import { SnapshotService } from '../snapshot/Services/snapshot.service';
import { CommonChartmoduleService } from '../snapshot/Services/common-chartmodule.service';
import { ConfigurationService } from 'src/app/common/services/configuration.service';
import { FilesWithIdentifiers } from 'src/app/common/models/configurations.model';
import { exceptionMessage } from 'src/app/common/constants/common-constants';
import { of } from 'rxjs';
interface Config {
  key: string;
  value: boolean;
}
interface VariableList {
  Level0: string;
  isEntryPoint: boolean;
  hasOnlyBrandIndependentChildren: boolean;
  hasOnlyBrandDependentChildren: boolean;
  hasSomeBrandDependentChildrenNotAll: boolean;
  Level1: {
    Level1_value: string;
    is_derived: string;
    is_brand_analysis: number;
    calc_type: string;
    tooltip: string;
    hasNextLevel: boolean;
    data_variable_code: string;
    response_code: string;
    sort_id: string;
    is_multi_punch: string;
    date: string;
    year_code: string;
    is_dimension: string;
    isCustomGrpPresent: string;
    isCustomCalcPresent: string;
    kibanaFilterScript: string;
    customGroupId: string;
    customCalculationId: string;
    dataYearCode: string;
    is_time_Period_Present: string;
    //isCustomCalcPresent: string;
    //customCalculationId: string;
  }[];
}
@Component({
  selector: 'app-chatbotexpand',
  templateUrl: './chatbotexpand.component.html',
  styleUrls: ['./chatbotexpand.component.css'],
})
export class ChatbotexpandComponent implements OnInit {
  goToWelcomeSection(): void {
    this.currentView = 'landing';
  }

  // Tooltip handlers for chart icons
  onChartIconMouseOver(tooltipType: 'stack' | 'line' | 'bar', event: MouseEvent): void {
    // Set the specific tooltip flag
    if (tooltipType === 'stack') this.showStackTooltip = true;
    if (tooltipType === 'line') this.showLineTooltip = true;
    if (tooltipType === 'bar') this.showBarTooltip = true;

    // In Sig mode, hide parent tooltip and stop propagation
    // In Index mode, allow event to bubble to show parent tooltip
    if (!this.isIndex) {
      this.showMainTooltip = false;
      event.stopPropagation();
    }
  }

  onChartIconMouseLeave(tooltipType: 'stack' | 'line' | 'bar'): void {
    if (tooltipType === 'stack') this.showStackTooltip = false;
    if (tooltipType === 'line') this.showLineTooltip = false;
    if (tooltipType === 'bar') this.showBarTooltip = false;
  }

  logo_url: string = '';
  IndexData: any;
  isTranspose: boolean = false;
  isTotalBase: boolean = false;
  isTotalBaseFromPrompt: string = 'false';
  isAnswerBase: boolean = false;
  selectedWeight: string = '';
  selectedIndex: string = '';
  insightsVal: any = '';
  InsightsResponse: any = '';
  // insufficientBase: string = '';
  insufficientBase: any;

  DefaultConfidenceLevel: string = 'None';
  isSampleSize: boolean = false;
  isWeightedLabel: boolean = false;
  // LowBase: string = '';
  LowBase: any;

  isPairWise: boolean = false;
  DefaultSampleSize: string = 'None';
  @Input() exportDownloads: boolean = true;
  @Input() pptExport: boolean = true;
  threshold: string = '';

  isQuestionBrowserOpen: boolean = false;
  questionBrowserSearchText: string = '';
  matchedQuestions: any[] = [];
  isTotal: boolean = false;
  displayTable: boolean = false;
  confidenceLevelDropDown: boolean = false;
  referenceLevelDropDown: boolean = false;
  is_Time_Period_Present: boolean = true;
  sampleSizeDropdown: boolean = false;
  isSignificanceContainerDisabled: boolean = false; // to disable significance container
  isReferenceSig: boolean = false;
  isReference: boolean = false;
  isDisablePairWise: boolean = true;
  isDisableReference: boolean = true;
  isDemoStudy: boolean = false;
  isDocumentRepositoryClick: boolean = false;
  mandatoryVariableMapping: any;
  Widget_Id: any;
  guidChatId: string = '';
  userId: string = '';

  chartType = this.isTranspose == true ? 'bar' : 'column';
  inputValue: any = '';
  existingquery: any = '';
  // inputValueShow: string[] = [];
  // Default QuestionAnswer response for display (HTML format)
  defaultQuestionAnswer: string = `<h2>Brand Analysis & Cross-Tab Summary</h2>
<ul>
  <li>Brand positioning, target market, and key differentiators</li>
  <li>Customer perception and brand strengths/weaknesses</li>
  <li>Cross-tab analysis comparing key demographic and behavior variables</li>
  <li>Major patterns and correlations identified</li>
  <li>Strategic insights and actionable recommendations</li>
</ul>`;

  // For chat preview Q&A blocks (UI only)
  chatPreviewBlocks: {
    question: string;
    response: string;
    messageId?: string;
    isStarred?: boolean;
    isLiked?: boolean | null;  // null = no feedback, true = liked, false = disliked
    feedbackSaved?: boolean;   // tracks if feedback has been saved to DB
    showDislikeInput?: boolean; // show dislike reason input box
    dislikeReason?: string;     // the dislike reason text
    QuestionAnswer?: string;  // markdown formatted response from AI
  }[] = [];
  
  // Toast notification properties
  toastMessage: string = '';
  toastType: 'success' | 'error' | 'info' = 'success';
  showToastNotification: boolean = false;
  
  isNewChatSession: boolean = false; // Flag to track if user started a new chat
  isInsightspopupOpen: boolean = false;
  OutputData: any;
  selected_study: any;
  selected_client: any;
  isVerticalBarChartClick: boolean = false;
  isTableView: boolean = false;
  isChartView: boolean = true;
  isTableClick: boolean = false;
  isLineChartClick: boolean = false;
  isVerticalStackChartClick: boolean = false;
  isVerticalGroupBarChartClick: boolean = false;
  isSaveSelectionClick = false;
  isSaveCustomGroupSelectionClick = false;
  isSaveCustomCalculationSelectionClick = false;
  disableStackChart: boolean = false;
  disableLineChart: boolean = false;
  SampleSizeList: any = [];
  isCreateBtnClick: boolean = false;
  showBarTooltip: boolean = false;
  searchTextLevel1: string = '';
  is_confidenceLevel: any = [];
  showStackTooltip: boolean = false;
  SignificanceVsReference: string = '';
  is_TransposeBtn: boolean = false;
  showMainTooltip: boolean = false;
  showLineTooltip: boolean = false;
  dataDropDown: boolean = false;
  is_chart_visualization: boolean = false;
  DefaultDataDropDown: string = 'Data';
  is_indexing: boolean = false;
  isSig: boolean = true;
  @Input() isIndex: boolean = false;
  is_sigtesting: boolean = false;
  DefaultReferenceLevel: string = 'None';
  SampleSizeContainer: boolean = false;
  isSampleSizeBlock: boolean = false;


  dataDropDownList: string[] = [
    'Data',
    'Sample Size',
    'Weighted Sample',
    'Weighted Numerator',
    'Unweighted Numerator',
  ];
  @ViewChild('summaryText') summaryText: ElementRef | undefined;
  @ViewChild('SidePanel') SidePanel: ElementRef | undefined;
  @ViewChild('inforRibbon', { static: false }) inforRibbon:
    | ElementRef
    | undefined;
  @ViewChild('chatHistoryScroll') chatHistoryScroll: ElementRef | undefined;
  @ViewChild('insightsContainer') insightsContainer: ElementRef | undefined;
  GeneralToolTip: string[] = [
    'Charting Option to be disabled when using Indexation.',
    'Charting Option to be disabled when anything is selected <br> in Row Nesting.',
    'Charting Option to be disabled when more than one metric <br> is selected in Rows.',
    'Charting Option to be disabled when anything is selected <br> in Column Nesting.',
  ];

  StackChartToolTip: string[] = [
    'This option is disabled for multipunch variables when<br>selected in the Rows.',
    'This will be enabled only when all the options within the<br>selected metric are chosen in the Rows.',
    'You can select a maximum of 15 options in the Rows.<br>If you select more than 15 options,charting options <br> will be disabled.',
    'Charting Option to be disabled when anything is<br>selected in Row Nesting.',
    'Charting Option to be disabled when more than one<br>metric is selected in Rows.',
    'Charting Option to be disabled when anything is<br>selected in Column Nesting.',
  ];

  LineChartToolTip: string[] = [
    'Trend will be available only when a single<br>Time Period Group is selected in the columns.',
    'There will be one trend line for each option<br>selected in the Rows.',
    'You can select a maximum of 15 options in the Rows.<br> If you select more than 15 options,charting<br>options will be disabled.',
    'Charting Option to be disabled when anything<br>is selected in Row Nesting.',
    'Charting Option to be disabled when more<br>than one metric is selected in Rows.',
    'Charting Option to be disabled when anything<br>is selected in Column Nesting.',
  ];

  BarChartToolTip: string[] = [
    'You can select a maximum of 15 options in the Rows. If you select more than 15 options, charting options will be disabled.',
    'Charting Option to be disabled when anything is selected <br> in Row Nesting.',
    'Charting Option to be disabled when more than one metric <br> is selected in Rows.',
    'Charting Option to be disabled when anything is selected <br> in Column Nesting.',
  ];
  variableTabData: any;
  StackFlag: boolean = false;
  isData: boolean = true;
  is_brand_analysis: boolean = false;
  isWeightedNumerator: boolean = false;
  isUnWeightedNumerator: boolean = false;
  isBrandAnalysis: boolean = false;
  $unSubscribeSubmitData1!: Subscription;
  $unSubscribeSubmitData2!: Subscription;
  $unSubscribeSubmitData3!: Subscription;
  $unSubscribeSubmitData4!: Subscription;
  $unSubscribeSubmitData5!: Subscription;
  $unSubscribeSubmitData6!: Subscription;
  $unSubscribeSubmitData7!: Subscription;
  $unSubscribeSubmitData8!: Subscription;
  $unSubscribeSubmitData9!: Subscription;
  receivedData: StudyData[] = [];
  clientcode: any;
  is_sticky_selection: boolean = false;
  is_reset_selection: any;
  excelExport: boolean = false;
  is_Transpose: any;
  is_ranking: any;
  isFilterToggle: any;
  isAnswerToggle: any;
  comparisionpoint: any;
  confidenceLevel: any;
  repository: any;
  lowBaseIdentifier: any;
  is_AI_Integration: any;
  is_StoryBoard: any;
  is_Column_Row_Percentage: any;
  insufficentBase: any;
  lowBase: any;
  configweights: any;
  iscustomgrp: any;
  iscustomCalc: any;
  iscustomreport: any;
  changeEntryPoint: any;
  isWeightedBase: boolean = false;
  aggregatedVariables: any = [];
  isSelectAllMetrics: any;
  isWeightedSampleBlock: boolean = false;
  filteringAnsBlock: boolean = false;
  AnsBaseBlock: boolean = false;
  isRowNesting: boolean = false;
  isColumnNesting: boolean = false;
  isSelectAllMetricsLevel: boolean = false;
  sidePanelDisplay: boolean = false;
  sidePanelNestingDisplay: boolean = false;
  columnPanelDisplay: boolean = false;
  columnNestingPanelDispaly: boolean = false;
  filterPanelDisplay: boolean = false;
  isSelectionSummary: boolean = false;
  weightDropDown: boolean = false;
  showCustomMetricsPopup: boolean = false;
  dataArray: any[] = [];
  fomDataArray: any[] = [];
  isAggregatedData: boolean = false;
  isSemiAggregatedData: boolean = false;
  columnLength: number = 0;
  listBItemsList: {
    Level0: string;
    Level1: string;
    tooltip: string;
    has_nextLevel: boolean;
    sortId: number;
    is_Derived: string;
    is_calc_type: string;
    data_variable_code: string;
    data_response_code: string;
    data_sort_id: string;
    data_is_multi_punch: string;
    data_date: string;
    data_year_code: string;
    is_dimension: boolean;
    is_custmGrpPresent: boolean;
    is_custmCalcPresent: boolean;
    kibanaFilterScript: string;
    customGroupId: string;
    customCalculationId: string;
    dataYearCode: string;
    isSelectAllMetrics: boolean;
    isSelectAllMetricsCount: number;
  }[] = [];
  listDItemsList: {
    Level0: string;
    Level1: string;
    tooltip: string;
    has_nextLevel: boolean;
    sortId: number;
    is_Derived: string;
    is_calc_type: string;
    data_variable_code: string;
    data_response_code: string;
    data_sort_id: string;
    data_is_multi_punch: string;
    data_date: string;
    data_year_code: string;
    is_dimension: boolean;
    is_custmGrpPresent: boolean;
    is_custmCalcPresent: boolean;
    kibanaFilterScript: string;
    customGroupId: string;
    customCalculationId: string;
    dataYearCode: string;
    isSelectAllMetrics: boolean;
    isSelectAllMetricsCount: number;
  }[] = [];
  selectedDataFormat: string = '';
  DefaultWeight: string = '';
  selectionSummary: string = '';
  selectionSummaryTitle: string = '';
  isFilteringActive: boolean = true;
  leftpanelDataArray: any[] = [];
  FooterNote: boolean = false;
  filteredlist: StudyData | undefined;
  isExistingDataPresent: boolean = false;
  dataexists: any;
  newdataexists: any;
  listCItemsList: {
    Level0: string;
    Level1: string;
    tooltip: string;
    has_nextLevel: boolean;
    sortId: number;
    is_Derived: string;
    is_calc_type: string;
    data_variable_code: string;
    data_response_code: string;
    data_sort_id: string;
    data_is_multi_punch: string;
    data_date: string;
    data_year_code: string;
    is_dimension: boolean;
    is_custmGrpPresent: boolean;
    is_custmCalcPresent: boolean;
    kibanaFilterScript: string;
    customGroupId: string;
    customCalculationId: string;
    dataYearCode: string;
    isSelectAllMetrics: boolean;
    isSelectAllMetricsCount: number;
    is_entrypoint: boolean;
  }[] = [];
  listEItemsList: {
    Level0: string;
    Level1: string;
    tooltip: string;
    has_nextLevel: boolean;
    sortId: number;
    is_Derived: string;
    is_calc_type: string;
    data_variable_code: string;
    data_response_code: string;
    data_sort_id: string;
    data_is_multi_punch: string;
    data_date: string;
    data_year_code: string;
    is_dimension: boolean;
    is_custmGrpPresent: boolean;
    is_custmCalcPresent: boolean;
    kibanaFilterScript: string;
    customGroupId: string;
    customCalculationId: string;
    dataYearCode: string;
    isSelectAllMetrics: boolean;
    isSelectAllMetricsCount: number;
    is_entrypoint: boolean;
  }[] = [];
  listAItemsList: {
    Level0: string;
    Level1: string;
    tooltip: string;
    has_nextLevel: boolean;
    sortId: number;
    is_Derived: string;
    is_calc_type: string;
    data_variable_code: string;
    data_response_code: string;
    data_sort_id: string;
    data_is_multi_punch: string;
    data_date: string;
    data_year_code: string;
    is_dimension: boolean;
    is_custmGrpPresent: boolean;
    is_custmCalcPresent: boolean;
    kibanaFilterScript: string;
    customGroupId: string;
    customCalculationId: string;
    dataYearCode: string;
    isSelectAllMetrics: boolean;
    isSelectAllMetricsCount: number;
    is_entrypoint: boolean;
  }[] = [];
  entryList: any[] = [];
  public previewDataObject: DataObject = {
    Row: [],
    Column: [],
    RowNesting: [],
    ColNesting: [],
    Filter: [],
    CustomGroup: [],
    CustomCalculation: [],
  };
  public FinalOutputdataObject: OutputDataObject = {
    Row: [],
    Column: [],
  };
  WeightDropDownList: {
    Label: string;
    responseCode: string;
    tooltip: string;
  }[] = [];
  is_dimension_Present: boolean = false;
  is_indexingShow: boolean = false;
  isRespondentLevel: boolean = true;
  strdata: any;
  arktabaccess: boolean = false;
  selectedData!: string;
  isDiagnostic: boolean = false;
  showDropdown: boolean = false;
  summaryTitle: any;
  //  isSelectionSummary: boolean = false;
  serviceVariable: any;
  @Input() landingdata: any;

  studyname: string = '';
  entryPanel: {
    Level1: string;
  }[] = [];
  variableList: VariableList[] = [];
  filteredStudies: string[] = [];

  showSnapshot: boolean = false;
  showExtraSelections: boolean = false;
  moduleseSelections = [
    {
      key: 'Snapshot',
      value: true,
      isSelected: true,
    },
    {
      key: 'Crosstab',
      value: true,
      isSelected: false,
    },
  ];
  displayModuleSelected = 'Snapshot';
  showModuleDropdown: boolean = true;
  mcode: any;
  promptData: any;
  isInsightsBtnEnabled: boolean = false;
  askMeLanding: boolean = true
  isselectionsummarycollapse: boolean = false;
  isselectionsummarycollapse2: boolean = false;
  issavedselectionblock: boolean = false;
  Columnselections: any = [];
  Rowselections: any = [];
  AllSelections: any = [];
  SaveSelectiontext: string = '';
  isselectionHeader: string = '';
  isExportspopup: boolean = false;
  ShareColumn: any;
  BaseColumn: any;
  widget_Id: any;
  weightFilter: { [key: string]: string } = {};
  isHidden = true;
  selectedChatId: string | null = null;
  newChatId: any;
  chatList: ChatListDocument[] = [];
  allChatList: ChatListDocument[] = [];
  chatSearchText: string = '';
  recentChats: ChatListDocument[] = [];
  olderChats: ChatListDocument[] = [];
  chatHistory: ChatHistoryDocument[] = [];
  // ...existing code...
  // Removed duplicate chatHistory property (now only ChatHistoryDocument[] remains)
  chatResponse: { [key: string]: string }[] = [];
  private subscriptions: Subscription = new Subscription();
  loadData: any[] = [];
  leftPanelData: any = {};
  configWeights: any;

  // New design properties from askme-flat
  currentView: 'landing' | 'chat' | 'loading' = 'loading'; // Start with loading state, determine view after checking chats
  isChatHistoryOpen = false;
  isSavedQuestionsOpen = false;
  isChatAreaVisible = true;
  searchText = '';
  searchForm!: FormGroup;
  isListView = true;
  questions = [
    'What is the awareness of bacardi?',
    'What was the consideration for Sproutvest Finance among male respondents in Market 01?',
    'Show the imagery data for Whitmore Capital and VaultQuest in Market 01 for 2023, segmented by, demographics with a gender breakdown.',
    'What is the awareness of  Sproutvest Finance?',
    'What was the consideration for Sproutvest Finance among male respondents in Market 01?',
    'Imagery data for Whitmore Capital and VaultQuest segmented by, demographics with a gender breakdown.'
  ];
  isClosing = false;
  chatAccordions: any[] = [];

  // Saved Questions (Starred Messages)
  starredMessages: { MessageId: string; Question: string; ChatId: string; CreatedAt?: string }[] = [];
  filteredStarredMessages: { MessageId: string; Question: string; ChatId: string; CreatedAt?: string }[] = [];
  starredSearchText = '';
  isLoadingStarredMessages = false;

  fallbackMessage(): string {
    const clientName = this.selected_client || 'Unknown Client';
    const studyName = this.selected_study || 'Unknown Study';

    return exceptionMessage
      .replace(/{{client}}/g, clientName)
      .replace(/{{study}}/g, studyName);
  }

  diagnosticIcon = 'assets/imageChatbot/Diagnostic_Left_Icon_Normal.svg';

  onHover(isHovering: boolean): void {
    this.diagnosticIcon = isHovering
      ? 'assets/imageChatbot/Diagnostic_Left_Icon_Hover.svg'
      : 'assets/imageChatbot/Diagnostic_Left_Icon_Normal.svg';
  }

  toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;
  }

  // Close dropdown
  closeDropdown(): void {
    this.showDropdown = false;
  }

  // Handle "View Online" click with loader
  isDiagnosticAnimating: boolean = false;
  viewOnline(): void {
    this.isDiagnosticAnimating = true;

    const animationPromise = new Promise(resolve => setTimeout(resolve, 1000));
    const diagnosticPromise = Promise.resolve(this.fetchDiagnostic()).catch(e => console.error(e));

    Promise.all([animationPromise, diagnosticPromise])
      .finally(() => {
        this.isDiagnosticAnimating = false;
        this._loaderService.hideLoader();
        this.closeDropdown();
      });
  }


  // Handle "Excel" click
  exportToExcel(): void {
    this.apiService.downloadDiagnosticsExcel().subscribe((blob: Blob) => {
      const today = new Date();
      const formattedDate = today.toISOString().split('T')[0].replace(/-/g, '');

      const client = this.selected_client && this.selected_client.trim() !== '' ? this.selected_client : 'Diagnostics';
      const snapshot = this.snapshotName && this.snapshotName.trim() !== '' ? this.snapshotName : 'Excel';

      const fileName = `${client}-${snapshot}-${formattedDate}.xlsx`;

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
      this.closeDropdown();
    });
  }

  handleConfig(eventData: any): void {
    if (eventData.configweights && eventData.configweights.length > 0) {
      this.configWeights = eventData.configweights;

      if (this.variableTabData && this.variableTabData.length > 0) {
        this.populateWeightDropdown();
      }
    }
  }

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private _loaderService: LoaderService,
    private _exportDownloads: ExportDownloadServices,
    private apiService: ChatbotService,
    private crossTabService: CrosstabService,
    private _insightsSerive: InsightspopupService,
    private _usermanagementService: UserProjectManagementService,
    private _configCustomService: CustomsnapshotService,
    public _configService: SnapshotService,
    private _configurationService: ConfigurationService,
    private sharedChatService: SharedChatService,
    private commonchartmodules: CommonChartmoduleService,
  ) {
    this.landingdata = this.router.getCurrentNavigation()?.extras.state;
    if (this.landingdata == undefined) {
      this.router.navigateByUrl('landing');
    }
    // Initialize searchForm for new design
    this.searchForm = this.fb.group({
      query: ['']
    });

    const fromLandingPage = this.landingdata?.fromLandingPage === true || sessionStorage.getItem('fromLanding') === 'true';
    if (fromLandingPage) {
      this.currentView = 'chat';
    }
  }
  CrossTabOutPutData: any;
  Snapshotdataforexport: any;
  CrossTabOutPutEntireData: any;
  moduleSelectionToggle: boolean = false;
  failedCase: boolean = false;
  formatMarkdown(text: string): string {
    if (!text) return '';

    // Replace bold markdown **...** with <strong>...</strong>
    let formatted = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

    // Replace italic markdown *...* with <em>...</em>
    formatted = formatted.replace(/\*(.*?)\*/g, '<em>$1</em>');

    // Remove all underscores (_) from the string
    formatted = formatted.replace(/_/g, '');
    this.arktabaccess = false;
    return formatted;
  }

  subscribeToVariableData(): void {
    this.$unSubscribeSubmitData3 =
      this.crossTabService.variableTabData$.subscribe(({ data }) => {
        if (data !== null && data !== undefined) {
          this.variableTabData = data;

          if (this.configWeights && this.configWeights.length > 0) {
            this.populateWeightDropdown();
          }
        }
      });
  }

  async ngOnInit(): Promise<void> {
    this.askMeLanding = true;
    this.arktabaccess = true;
    this.selected_study = this.landingdata?.study || null;
    this.selected_client = this.landingdata?.client_code || null;
    this.commonchartmodules.colortemplate(this.selected_client);
    this.ShareColumn = this.landingdata?.shareColumn || null;
    this.BaseColumn = this.landingdata?.baseColumn || null;
    this.displayTable = false;
    this.subscribeToVariableData();

    // Load chat list on page refresh/init (call immediately, don't wait for user identity)
    this.getChatListData();

    // Initialize user identity - get existing or create new (runs in background)
    this.initializeUserIdentity();

    const fromLandingPage = this.landingdata?.fromLandingPage === true || sessionStorage.getItem('fromLanding') === 'true';

    // Validate study and client
    if (!this.selected_study || !this.selected_client) {
      console.warn('Missing study or client, redirecting to landing page');
      this.arktabaccess = false;
      this.router.navigateByUrl('/landing');
      return;
    }

    const result: results = await firstValueFrom(
      this.crossTabService.getClientStudyData(
        {
          client_code: this.selected_client,
          study: this.selected_study,
        },
        this.isBrandAnalysis
      )
    );

    if (result.HasValidData) {
      const studyData: StudyData = {
        study: this.selected_study,
        client_name: this.selected_client,
        url_logo: this.filteredlist?.url_logo || '',
      };
      this.receivedData = JSON.parse(result.Data);
      this.clientcode = this.selected_client;
      this.filteredlist = this.receivedData.find(
        (u: StudyData) =>
          u.study === this.selected_study &&
          u.client_name === this.selected_client
      );

      // Prefer the special askme logo when available. Call backend to list logo files and pick *_askme.png.
      this.logo_url = this.filteredlist?.url_logo || '';
      try {
          this._configurationService.getLogoFiles(this.selected_client).subscribe((files: FilesWithIdentifiers[]) => {
            if (files && files.length > 0) {
              const askme = files.find((f: FilesWithIdentifiers) => f.fileName && f.fileName.toLowerCase().endsWith('_askme.png'));
              const normal = files.find((f: FilesWithIdentifiers) => f.fileName && !f.fileName.toLowerCase().endsWith('_askme.png'));
              this.logo_url = askme?.url || normal?.url || this.logo_url;
            }
          }, (err: any) => {
            // fallback to existing value on error
            console.warn('Could not fetch logo files list, using default url_logo', err);
          });
      } catch (e) {
        // swallow and leave logo_url as-is
      }

      if (this.selected_client === 'PMI') {
        this.configChanges(this.receivedData, this.selected_study);
      }

      // await this.getVariableData(this.filteredlist);
      // Handle navigation
      if (fromLandingPage) {
        this.processSendMessageRequest();
      } else {
        // Check if there are existing chats and load the latest one
        // Keep loader running - it will be stopped inside loadLatestChatIfExists
        this.loadLatestChatIfExists();
      }
    } else {
      console.warn('No valid data received, redirecting to landing page');
      this.arktabaccess = false;
      this.router.navigateByUrl('/landing');
    }

    this.summaryTitle = this.Summary();
    // this.arktabaccess = false; // Removed to keep loader active for fromLandingPage flow

  }

  /**
   * Initialize user identity - tries to get existing user, if not found creates new one
   */
  async initializeUserIdentity(): Promise<void> {
    try {
      // First try to get userId from sessionStorage
      const storedUserId = sessionStorage.getItem('arkUserId');

      if (storedUserId) {
        // Try to get user identity from backend
        const response = await firstValueFrom(this.apiService.getUserIdentity(storedUserId));
        const apiResponse = JSON.parse(response);

        if (apiResponse.HasValidData && apiResponse.Data) {
          const userData = JSON.parse(apiResponse.Data);
          this.userId = userData.UserId;
          console.log('User identity retrieved successfully:', this.userId);
          return;
        }
      }

      // User not found or no stored userId, create new user identity
      await this.createNewUserIdentity();

    } catch (error) {
      console.error('Error getting user identity, creating new one:', error);
      await this.createNewUserIdentity();
    }
  }

  /**
   * Create a new user identity
   */
  async createNewUserIdentity(): Promise<void> {
    try {
      const userDoc: UserIdentityDocument = {
        UserId: '', // Will be generated by backend
      };

      const response = await firstValueFrom(this.apiService.saveUserIdentity(userDoc));
      const apiResponse = JSON.parse(response);

      if (apiResponse.HasValidData && apiResponse.Data) {
        this.userId = apiResponse.Data;
        // Store userId in sessionStorage for future use
        sessionStorage.setItem('arkUserId', this.userId);
        console.log('New user identity created:', this.userId);
      } else {
        console.error('Failed to create user identity:', apiResponse.ExceptionMessage);
      }
    } catch (error) {
      console.error('Error creating user identity:', error);
    }
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes['filteredWidgetData'] || changes['filteredWidgetID']) {
  //     this.refreshSnapshot(); // your method to draw or update the chart
  //   }
  // }

  processSendMessageRequest(): void {
    this.subscriptions.add(
      this.sharedChatService.sendMessageRequest$.pipe(take(1)).subscribe(payload => {
        if (payload && payload.inputValue && payload.inputValue.trim() !== '') {
          console.log('Processing send message request with input:', payload.inputValue);
          this.inputValue = payload.inputValue.trim();
          this.sendInputMessage();
          this.sharedChatService.clearRequest();
        } else {
          // Fallback to original logic if no question is present
          if (payload) {
            this.landingdata = {
              ...this.landingdata,
              client_code: payload.clientCode,
              study: payload.study,
              dataArray: payload.dataArray || [],
              landingData: payload.landingData || {}
            };
            this.selected_study = payload.study;
            this.selected_client = payload.clientCode;
            this.loadData = payload.dataArray || [];
            this.leftPanelData = payload.landingData || {};
          }
          console.log('Skipping empty or invalid payload:', payload);
          this.arktabaccess = false;
          
          // No message to send, so load the latest chat if available
          console.log('No message payload - loading latest chat');
          this.loadLatestChatIfExists();
        }
      })
    );
  }


  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    if (this.$unSubscribeSubmitData1) {
      this.$unSubscribeSubmitData1.unsubscribe();
    }
    if (this.$unSubscribeSubmitData2) {
      this.$unSubscribeSubmitData2.unsubscribe();
    }
    if (this.$unSubscribeSubmitData3) {
      this.$unSubscribeSubmitData3.unsubscribe();
    }
    if (this.$unSubscribeSubmitData4) {
      this.$unSubscribeSubmitData4.unsubscribe();
    }
    if (this.$unSubscribeSubmitData5) {
      this.$unSubscribeSubmitData5.unsubscribe();
    }
    if (this.$unSubscribeSubmitData6) {
      this.$unSubscribeSubmitData6.unsubscribe();
    }
    // if (this.$unSubscribeSubmitData7) {
    //   this.$unSubscribeSubmitData7.unsubscribe();
    // }
    if (this.$unSubscribeSubmitData8) {
      this.$unSubscribeSubmitData8.unsubscribe();
    }
    if (this.$unSubscribeSubmitData9) {
      this.$unSubscribeSubmitData9.unsubscribe();
    }
    sessionStorage.removeItem('isarkTabAccessed');
  }

  toggleChatHistory(): void {
    if (this.currentView === 'landing') {
      this.navigateToChat();
    }
    if (this.isSavedQuestionsOpen) {
      this.isSavedQuestionsOpen = false;
    }
    if (this.isQuestionBrowserOpen) {
      this.isQuestionBrowserOpen = false;
    }
    this.isChatHistoryOpen = !this.isChatHistoryOpen;
  }

  toggleSavedSelections(): void {
    if (this.currentView === 'landing') {
      this.navigateToChat();
    }
    if (this.isChatHistoryOpen) {
      this.isChatHistoryOpen = false;
    }
    if (this.isQuestionBrowserOpen) {
      this.isQuestionBrowserOpen = false;
    }
    this.isSavedQuestionsOpen = !this.isSavedQuestionsOpen;

    // Fetch starred messages when opening the panel
    if (this.isSavedQuestionsOpen) {
      this.loadStarredMessages();
    }
  }

  loadStarredMessages(): void {
    this.isLoadingStarredMessages = true;
    this.apiService.getStarredMessages().subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData && apiResponse.Data) {
          this.starredMessages = JSON.parse(apiResponse.Data);
          this.filteredStarredMessages = [...this.starredMessages];
        } else {
          this.starredMessages = [];
          this.filteredStarredMessages = [];
        }
        this.isLoadingStarredMessages = false;
      },
      error: (err) => {
        console.error('Error fetching starred messages:', err);
        this.starredMessages = [];
        this.filteredStarredMessages = [];
        this.isLoadingStarredMessages = false;
      }
    });
  }

  onStarredSearch(): void {
    const searchText = this.starredSearchText.toLowerCase().trim();
    if (!searchText) {
      this.filteredStarredMessages = [...this.starredMessages];
      return;
    }

    const searchTokens = searchText.split(/\s+/).filter(token => token.length > 0);
    this.filteredStarredMessages = this.starredMessages.filter(msg => {
      const questionText = (msg.Question || '').toLowerCase();
      return searchTokens.every(token => questionText.includes(token));
    });
  }

  onStarredQuestionClick(message: { MessageId: string; Question: string; ChatId: string }): void {
    // Close the saved questions panel
    this.isSavedQuestionsOpen = false;

    // Find the chat that contains this message to get full message details
    const chat = this.allChatList.find(c => c.ChatHistory && c.ChatHistory.some(h => h.MessageId === message.MessageId));
    
    if (chat) {
      const specificMsg = chat.ChatHistory?.find(h => h.MessageId === message.MessageId);
      
      if (specificMsg) {
        // Show only this specific question in chat-content
        this.chatPreviewBlocks = [{
          question: specificMsg.Question || '',
          response: '',
          messageId: specificMsg.MessageId,
          isStarred: specificMsg.IsStarred || false,
          QuestionAnswer: specificMsg.QuestionAnswer || this.defaultQuestionAnswer
        }];
        
        this.newChatId = chat.ChatId || null;
        this.guidChatId = chat.ChatId || ''; // Set guidChatId to preserve chat session
        this.selectedChatId = chat.ChatId || null;
        this.currentView = 'chat';
      }
    }

    // Load the chat response for output area
    this.getChatResponse(message.MessageId, true);
  }

  onQuestionBrowserClick(question: { question: string; messageId: string; chatTitle: string }): void {
    // Close the question browser panel
    this.isQuestionBrowserOpen = false;

    // Find the chat that contains this message to get full message details
    const chat = this.allChatList.find(c => c.ChatHistory && c.ChatHistory.some(h => h.MessageId === question.messageId));
    
    if (chat) {
      const specificMsg = chat.ChatHistory?.find(h => h.MessageId === question.messageId);
      
      if (specificMsg) {
        // Show only this specific question in chat-content
        this.chatPreviewBlocks = [{
          question: specificMsg.Question || '',
          response: '',
          messageId: specificMsg.MessageId,
          isStarred: specificMsg.IsStarred || false,
          QuestionAnswer: specificMsg.QuestionAnswer || this.defaultQuestionAnswer
        }];
        
        this.newChatId = chat.ChatId || null;
        this.guidChatId = chat.ChatId || ''; // Set guidChatId to preserve chat session
        this.selectedChatId = chat.ChatId || null;
        this.currentView = 'chat';
      }
    }

    // Load the chat response for output area
    this.getChatResponse(question.messageId, true);
  }

  toggleQuestionBrowser(): void {
    if (this.currentView === 'landing') {
      this.navigateToChat();
    }
    if (this.isChatHistoryOpen) {
      this.isChatHistoryOpen = false;
    }
    if (this.isSavedQuestionsOpen) {
      this.isSavedQuestionsOpen = false;
    }
    this.isQuestionBrowserOpen = !this.isQuestionBrowserOpen;

    if (this.isQuestionBrowserOpen) {
      this.onQuestionBrowserSearch();
    }
  }

  onQuestionBrowserSearch(): void {
    this.matchedQuestions = [];
    const searchText = (this.questionBrowserSearchText || '').toLowerCase().trim();
    const searchTokens = searchText.split(/\s+/).filter(token => token.length > 0);

    if (searchTokens.length === 0) {
      // If no search, maybe show nothing or all questions? 
      // Showing all might be too much, let's show all for now or empty?
      // User asked to "search for all questions", implying a list.
      // Let's populate with all questions from all chats.
      this.allChatList.forEach(chat => {
        if (chat.ChatHistory) {
          chat.ChatHistory.forEach(h => {
            if (h.Question) {
              this.matchedQuestions.push({
                question: h.Question,
                messageId: h.MessageId,
                chatTitle: chat.ChatTitle,
                createdAt: h.CreatedAt
              });
            }
          });
        }
      });
    } else {
      this.allChatList.forEach(chat => {
        if (chat.ChatHistory) {
          chat.ChatHistory.forEach(h => {
            const questionText = (h.Question || '').toLowerCase();
            // Check if EVERY token exists in the question text.
            if (searchTokens.every(token => questionText.includes(token))) {
              this.matchedQuestions.push({
                question: h.Question,
                messageId: h.MessageId,
                chatTitle: chat.ChatTitle,
                createdAt: h.CreatedAt
              });
            }
          });
        }
      });
    }

    // Sort by date desc if needed, or leave as is (usually chat list is already sorted)
  }

  closeChatHistory(): void {
    this.isChatHistoryOpen = false;
  }

  closeSavedQuestions(): void {
    this.isSavedQuestionsOpen = false;
  }

  toggleChatArea(): void {
    this.isChatAreaVisible = !this.isChatAreaVisible;
  }

  onSendMessage(): void {
    if (this.searchText && this.searchText.trim()) {
      this.inputValue = this.searchText.trim();
      this.isNewChatSession = false; // Reset flag when user sends a message
      this.sendInputMessage();
      this.searchText = '';
      
      // Scroll to the bottom to show the new question
      this.scrollToBottom();
    }
  }

  scrollToBottom(): void {
    // Use setTimeout to wait for the DOM to update
    setTimeout(() => {
      if (this.chatHistoryScroll && this.chatHistoryScroll.nativeElement) {
        const element = this.chatHistoryScroll.nativeElement;
        element.scrollTop = element.scrollHeight;
      }
    }, 100);
  }

  toggleView(): void {
    this.isListView = !this.isListView;
  }

  trackByIndex(index: number): number {
    return index;
  }

  getGridImage(index: number): string {
    const imageNumber = (index % 6) + 1;
    return `url('/assets/ImagesAskme/Grid_${String(imageNumber).padStart(2, '0')}.jpg')`;
  }

  truncateText(text: string, maxLength: number = 150): string {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength).trim() + '...';
  }

  navigateToChat(): void {
    this.currentView = 'chat';
    this.isNewChatSession = false; // Reset flag when explicitly navigating to chat
  }

  navigateToLanding(): void {
    // Reset chat state for new conversation
    this.currentView = 'landing';
    this.chatPreviewBlocks = [];
    this.guidChatId = this.generateGuid(); // Generate new chat ID
    this.newChatId = null;
    this.selectedChatId = null;
    this.inputValue = '';
    this.searchText = '';
    this.isNewChatSession = true; // Flag to prevent auto-loading latest chat
    
    console.log('New chat started with ID:', this.guidChatId);
  }

  onCloseChatHistory(): void {
    this.isClosing = true;

    setTimeout(() => {
      this.closeChatHistory();
      this.isClosing = false;
    }, 300);
  }

  onBackClickChatHistory(): void {
    this.onCloseChatHistory();
  }

  toggleAccordion(item: any): void {
    item.isExpanded = !item.isExpanded;
  }

  onChatHeaderQuestionClick(item: any): void {
    // Close the chat history panel
    this.isChatHistoryOpen = false;

    if (item.mainQuestionMessageId) {
      // Load the chat response - this will show ALL questions from that chat
      // Same behavior as clicking sub-questions
      this.getChatResponse(item.mainQuestionMessageId);
    }
  }

  onCloseSavedQuestions(): void {
    this.isClosing = true;

    setTimeout(() => {
      this.closeSavedQuestions();
      this.isClosing = false;
    }, 300);
  }

  onBackClickSavedQuestions(): void {
    this.onCloseSavedQuestions();
  }

  onSearchSubmit(): void {
    const searchQuery = this.searchForm.get('query')?.value;
    if (searchQuery && searchQuery.trim()) {
      this.inputValue = searchQuery.trim();
      this.currentView = 'chat';
      this.sendInputMessage();
      // Reset the form after submission
      this.searchForm.patchValue({ query: '' });
    }
  }

  configChanges(data: any, study: any) {
    let comparisionpoint;
    let confidenceLevel;
    let weights;
    let dataFormat;
    data = data.filter((a: any) => a.study == study);
    if (data.length > 0) {
      if (data[0].comparison_point.length > 0) {
        // Check if "None" key is already present
        const isNoneKeyPresent = data[0].comparison_point.some(
          (itemConst: any) => itemConst.key === 'None'
        );
        // If the key is not present, add it
        if (!isNoneKeyPresent) {
          data[0].comparison_point.unshift({ key: 'None', value: true });
        }
        comparisionpoint = data[0].comparison_point.filter(
          (a: Config) => a.value == true
        );
        // Push other objects where value is true to comparison_point array
      }

      if (data[0].confidence_level.length > 0) {
        confidenceLevel = data[0].confidence_level.filter(
          (a: Config) => a.value == true
        );
      }

      if (data[0].weight.length > 0) {
        weights = data[0].weight.filter((a: any) => a.is_selected == true);
      }

      if (data[0].dataformat.length > 0) {
        dataFormat = data[0].dataformat.filter((a: any) => a.value == true);
      }

      //  this.selectedConfig.emit({
      //    RowNestSelection: data[0].nesting[0].is_selected,
      //    ColNestSelection: data[0].nesting[1].is_selected,
      //    is_brand_analysis: data[0].is_brand_analysis,
      //    is_chart_visualization: data[0].is_chart_visualization,
      //    is_sticky_selection: data[0].is_sticky_selection,
      //    is_reset_selection: data[0].is_reset_selection,
      //    is_Transpose: data[0].output_page[0].value,
      //    is_indexing: data[0].output_page[1].value,
      //    is_sigtesting: data[0].output_page[2].value,
      //    is_ranking: data[0].output_page[3].value,
      //    isFilterToggle: data[0].filter_function[0].value,
      //    isAnswerToggle: data[0].filter_function[1].value,
      //    comparisionpoint: comparisionpoint,
      //    confidenceLevel: confidenceLevel,
      //    excelExport: data[0].export_download[0].value,
      //    pptExport: data[0].export_download[1].value,
      //    repository: data[0].export_download[2].value,
      //    lowBaseIdentifier: data[0].export_download[3].value,
      //    is_AI_Integration: data[0].is_AI_Integration,
      //    is_StoryBoard: data[0].is_StoryBoard,
      //    is_Column_Row_Percentage: data[0].is_Column_Row_Percentage,
      //    insufficentBase: data[0].low_base_identifier[0].data_value,
      //    lowBase: data[0].low_base_identifier[1].data_value,
      //    threshold: data[0].threshold_identifier[0].data_value,
      //    configweights: weights,
      //    iscustomgrp: data[0].custom_content[0].value,
      //    iscustomCalc: data[0].custom_content[1].value,
      //    iscustomreport: data[0].custom_content[2].value,
      //    changeEntryPoint: data[0].save_selection[1].value,
      //    dataFormat: dataFormat.length > 0 ? dataFormat[0].key : '',
      //    isWeightedBase:
      //      data[0].aggregatedvariables[1].data_value == '' ? false : true,
      //    isSampleSize:
      //      data[0].aggregatedvariables[2].data_value == '' ? false : true,
      //    aggregatedVariables: data[0].aggregatedvariables,
      //    mandatoryVariableMapping: data[0].mandatory_variable_mapping,
      //    isSelectAllMetrics: data[0].is_SelectAll_Metrics,
      //  });
      //  this.dataFormat = dataFormat.length > 0 ? dataFormat[0].key : '';
      //  this.sendHelpGuide.emit(data[0].help_guide);
      //  this.custom_calculation = data[0].custom_calculation;
      //  this.custom_group = data[0].custom_group;
      //  this.custom_report = data[0].custom_report;
      //  this.export_download = data[0].export_download;
      //  this.isconfigCustomGrpPresent =
      //    data[0].custom_content[0].value == true ? true : false;
      //  this.isconfigCustomCalcPresent =
      //    data[0].custom_content[1].value == true ? true : false;
      //  this.isSelectAllMetrics = data[0].is_SelectAll_Metrics;
      this.aggregatedVariables = data[0].aggregatedvariables;
    }
  }

  BindEntryData(
    data: any,
    selectedStudy: string,
    ClientCode: string,
    ZeroEntryPoint: boolean
  ) {
    this.studyname = selectedStudy;
    this.entryPanel = [];
    this.variableList = [];
    this.filteredStudies = _.uniq(
      _.map(
        _.filter(
          data,
          (item) =>
            item.study !== null &&
            item.study !== '' &&
            item.client_name == ClientCode
        ),
        'study'
      )
    );
    const Leve1 = _.uniq(
      _.map(
        _.filter(
          data,
          (item) =>
            item.Level1 !== null &&
            item.Level2 !== '' &&
            item.study == selectedStudy
        ),
        'Level1'
      )
    );
    for (const element of Leve1) {
      this.entryPanel.push({
        Level1: element,
      });
    }
    if (ZeroEntryPoint && this.entryPanel.length == 0) {
      this.dataArray = [];
      const clientStudyInfo = {
        clientName: this.selected_client,
        studyName: this.selected_study,
      };
      this.dataArray.push(clientStudyInfo);
      // this.loadBtnClick(false);
    }
    // if (this.moduleName == 'Custom SnapShot') {
    //   this.loadBtnClick(true);
    // }
    // if (this.moduleName == 'Brand Analysis' && this.isLoadSelected) {
    //   this.loadBtnClick(true);
    // }
  }
  Summary() {
    const content =
      this.inforRibbon != undefined
        ? this.inforRibbon.nativeElement.textContent
        : '';
    return content;
  }

  populateWeightDropdown(): void {
    this.WeightDropDownList = [];
    this.weightFilter = {};

    this.configWeights?.forEach((x: any) => {
      let WeightedData = this.variableTabData.filter(
        (a: any) => a.data_variable_code === x.variable_code
      );

      if (x.variable_label == 'Unweighted') {
        this.WeightDropDownList.push({
          Label: x.variable_label,
          responseCode: x.variable_label,
          tooltip: x.variable_label,
        });

        this.weightFilter[x.variable_label] = x.variable_label;

      } else if (x.variable_label.trim() == 'Boost Factor') {
        this.WeightDropDownList.push({
          Label: x.variable_label,
          responseCode: x.variable_code,
          tooltip: x.variable_label,
        });

        this.weightFilter[x.variable_label] = x.variable_code;

      } else {
        if (WeightedData.length > 0) {
          this.WeightDropDownList.push({
            Label: WeightedData[0].Level1,
            responseCode: WeightedData[0].data_variable_code,
            tooltip: WeightedData[0].tooltip,
          });
          this.weightFilter[WeightedData[0].Level1] = WeightedData[0].data_variable_code;
        }
      }
    });

    if (this.WeightDropDownList.length > 0 && this.DefaultWeight == '') {
      this.DefaultWeight = this.WeightDropDownList[0].Label;
      this.selectedWeight = this.WeightDropDownList[0].responseCode;
    }
  }

  async getVariableData(receivedData: any): Promise<void> {
    // debugger
    this.arktabaccess = true;
    const getdata: GetDataArray = {
      EntryPoint1: {
        Level1: receivedData.Level1,
        Level2: [
          {
            Parent: receivedData.Level2,
            MetricOptions: [
              {
                Name: receivedData.MetricOption,
                responseCode: receivedData.ResponseCode,
                isActive: true,
                Dependency_e1: receivedData.e1_variable_code,
                Dependency_e2: receivedData.e2_variable_code,
              },
            ],
          },
        ],
        variableCode: receivedData.VariableCode,
      },
      clientName: receivedData.client_name,
      studyName: receivedData.study,
      mandatory_variable_mapping: receivedData.mandatory_variable_mapping,
      dimension: receivedData.dimension,
      // isMandatoryLoadClicked:false,
      // snapshotType: "Single Brand"
    };
    this.dataArray.push(getdata);

    try {
      const [crosstabResult, brandResult]: any = await firstValueFrom(
        // this.crossTabService.getVariableData(this.dataArray, this.isBrandAnalysis)
        forkJoin([
          this.apiService.getLoadData(this.dataArray),
          this.apiService.getLoadDataBrandAnalysis(this.dataArray)
        ])
      );
      const result = this.isBrandAnalysis ? brandResult : crosstabResult;

      // Response is valid
      this.arktabaccess = false;
      if (result.HasValidData) {
        let JsonData = JSON.parse(result.Data);
        this.fomDataArray = JSON.parse(result.Data);


        if (this.isBrandAnalysis) {
          JsonData.forEach((x: any) => {
            const is_multi_punch = x.is_multi_punch > 0 ? true : false;
            if (is_multi_punch) {
              x.MetricOption = '';
            }
            //   x.Level2 = '';
            switch (x.is_brandanalysis) {
              case 1:
                x.Level2 = x.Level3;
                x.Level3 = x.Level4;
                x.Level4 = x.Level5;
                // if (is_multi_punch && x.Level3 == '') {
                //   x.MetricOption = '';
                //   x.Level2 = '';
                // } else if (is_multi_punch && x.Level3 !== '') {
                //   x.Level2 = x.Level3;
                //   x.Level3 = '';
                //   // x.MetricOption = x.Level3;
                //   // x.Level2 = '';
                // } else if (is_multi_punch && x.Level4 !== '') {
                //   x.MetricOption = x.Level4;
                //   x.Level2 = x.Level3;
                // } else if (is_multi_punch && x.Level5 !== '') {
                //   x.MetricOption = x.Level5;
                //   x.Level3 = x.Level4;
                //   x.Level2 = x.Level3;
                // } else if (is_multi_punch && x.Level6 !== '') {
                //   x.MetricOption = x.Level6;
                //   x.Level4 = x.Level5;
                //   x.Level3 = x.Level4;
                //   x.Level2 = x.Level3;
                // } else {
                //   x.Level2 = x.Level3;
                //   x.Level3 = x.Level4;
                //   x.Level4 = x.Level5;
                // }
                break;
              case 2:
                x.Level3 = x.Level4;
                x.Level4 = x.Level5;
                // if (is_multi_punch && x.Level4 == '') {
                //   x.MetricOption = '';
                //   x.Level3 = '';
                // } else if (is_multi_punch && x.Level4 !== '') {
                //   x.MetricOption = x.Level4;
                //   x.Level3 = '';
                // } else if (is_multi_punch && x.Level5 !== '') {
                //   x.MetricOption = x.Level5;
                //   x.Level3 = x.Level4;
                // } else if (is_multi_punch && x.Level6 !== '') {
                //   x.MetricOption = x.Level6;
                //   x.Level4 = x.Level5;
                //   x.Level3 = x.Level4;
                // } else {
                //   x.Level3 = x.Level4;
                //   x.Level4 = x.Level5;
                // }
                break;
              case 3:
                x.Level4 = x.Level5;
                // if (is_multi_punch && x.Level5 == '') {
                //   x.MetricOption = '';
                //   x.Level4 = '';
                // } else if (is_multi_punch && x.Level5 !== '') {
                //   x.MetricOption = x.Level5;
                //   x.Level4 = '';
                // } else if (is_multi_punch && x.Level6 !== '') {
                //   x.MetricOption = x.Level6;
                //   x.Level4 = x.Level5;
                // } else {
                //   x.Level4 = x.Level5;
                // }
                break;
              case 4:
                x.Level5 = '';
                // if (is_multi_punch && x.Level6 == '') {
                //   x.MetricOption = '';
                //   x.Level6 = '';
                // } else if (is_multi_punch && x.Level6 !== '') {
                //   x.MetricOption = x.Level6;
                //   x.Level6 = '';
                // } else {
                //   x.Level5 = '';
                // }
                break;
              case 5:
                x.Level6 = '';
                break;
              case 6:
                x.MetricOption = '';
                break;
            }
          });
        }
        //   console.log(JsonData);

        //Originlly Commented

        this.variableTabData = JsonData;
        if (this.configWeights && this.configWeights.length > 0) {
          this.populateWeightDropdown();
        }
        // this.arktabaccess = true;
        if (this.variableTabData.length > 0) {
          this.isAggregatedData =
            this.variableTabData[0].is_aggregated_data == 1 ? true : false;
          this.isSemiAggregatedData =
            this.variableTabData[0].is_semi_aggregated_data == 1
              ? true
              : false;
          //this.BindVariableDataLeftPanel(this.variableTabData);
          this.crossTabService.setVariableTabData(this.variableTabData);
        }
      } else {
        // this.errorPopup(result.ExceptionMessage);
        this.arktabaccess = false;
      }
      //hide the loader
      // this.arktabaccess = false;
    } catch (error) {
      // this.errorPopup(result.ExceptionMessage);
      this.arktabaccess = false;
    } finally {
      this.arktabaccess = false;
    }
  }
  public OutputdataObject: OutputDataObject = {
    Row: [],
    Column: [],
  };
  public fomData: fomData = {
    Header: '',
    Level1: '',
    Level2: '',
    MetricOption: '',
    data_variable_code: '',
    response_code: '',
    derived_metric_calculation: '',
    Level0: '',
    Level3: '',
    Level4: '',
    Level5: '',
    Level6: '',
    sort_id: 0,
    level1_sort_id: 0,
    is_multi_punch: 0,
    is_derived_variable: false,
    is_dimension: false,
    calculation_type: '',
    url_logo: '',
    tooltip: '',
    year_code: '',
    year_label: '',
    date: '',
    isActive: false,
    is_CustomGroup: false,
    customGroupQuery: '',
    is_CustomCalculation: false,
    customCalculationQuery: '',
    dataYearCode: '',
    is_time_Period_Present: false,
    is_dimension_Present: false,
    is_shared: false,
    user_name: '',
    customGroupId: '',
    customCalculationId: '',
    is_brandanalysis: 0,
    variable_code: '',
    is_aggregated_data: 0,
    is_semi_aggregated_data: 0,
    is_snapshot: 0,
    sequence: 0,
  };
  public LineChart: LineChart = {
    title: '',
    Data: [],
    Properties: [],
  };
  public StackChart: StackChart = {
    title: '',
    Data: [],
    Properties: [],
  };
  public BarChart: GroupBarChart = {
    title: '',
    Data: [],
    Properties: [],
  };

  public dataObject: DataObject = {
    Row: [],
    Column: [],
    RowNesting: [],
    ColNesting: [],
    Filter: [],
    CustomGroup: [],
    CustomCalculation: [],
  };
  isSelected(SelectedValue: string): boolean {
    return this.selectedIndex === SelectedValue;
  }
  isSelectedSignificance(SelectedValue: string): boolean {
    return this.SignificanceVsReference === SelectedValue;
  }
  BindTableOutput(CrossTabOuputData: any) {
    // Iterate through CrossTabOutPutData and structure the data
    this.CrossTabOutPutData = this.CrossTabOutPutData.filter(
      (a: CrossTabOutputItem) => a.colChild !== null
    );
    this.CrossTabOutPutData.forEach((item: CrossTabOutputItem) => {
      // Create OutputSelection objects for row and column

      const nestLevel2Selection: OutputSelection = {
        Child: item.Level2ColChild,
        variablecode: item.Level2NestColVariableCode,
        responsecode: item.Level2ColResponseCode,
        NestedArray: [],
        isDerived: item.isDerived,
        customGroupId: item.customGroupId,
        isCustomGroup: item.isCustomGroup,
        CalculationType: item.CalculationType,
        isCustomCalculation: false,
      };

      const nestRowLevel2Selection: OutputSelection = {
        Child: item.Level2RowChild,
        variablecode: item.Level2NestRowVariableCode,
        responsecode: item.Level2RowResponseCode,
        NestedArray: [],
        isDerived: item.isDerived,
        customGroupId: item.customGroupId,
        isCustomGroup: item.isCustomGroup,
        CalculationType: item.CalculationType,
        isCustomCalculation: false,
      };

      const NestedRowSelection: OutputSelection = {
        Child: item.Level1RowChild,
        variablecode: item.Level1NestRowVariableCode,
        responsecode: item.Level1RowResponseCode,
        NestedArray: item.Level2RowChild ? [nestRowLevel2Selection] : [],
        isDerived: item.isDerived,
        customGroupId: item.customGroupId,
        isCustomGroup: item.isCustomGroup,
        CalculationType: item.CalculationType,
        isCustomCalculation: false,
      };

      const NestedColumnSelection: OutputSelection = {
        Child: item.Level1ColChild,
        variablecode: item.Level1NestColVariableCode,
        responsecode: item.Level1ColResponseCode,
        NestedArray: item.Level2ColChild ? [nestLevel2Selection] : [],
        isDerived: item.isDerived,
        customGroupId: item.customGroupId,
        isCustomGroup: item.isCustomGroup,
        CalculationType: item.CalculationType,
        isCustomCalculation: false,
      };

      const rowSelection: OutputSelection = {
        Child: item.rowChild,
        variablecode: item.rowVariableCode,
        responsecode: item.rowResponseCode,
        NestedArray: item.Level1RowChild ? [NestedRowSelection] : [],
        isDerived: item.isDerived,
        customGroupId: item.customGroupId,
        isCustomGroup: item.isCustomGroup,
        CalculationType: item.CalculationType,
        isCustomCalculation: false,
      };

      const colSelection: OutputSelection = {
        Child: item.colChild,
        variablecode: item.colVariableCode,
        responsecode: item.colResponseCode,
        NestedArray: item.Level1ColChild ? [NestedColumnSelection] : [],
        isDerived: item.isDerived,
        customGroupId: item.customGroupId,
        isCustomGroup: item.isCustomGroup,
        CalculationType: item.CalculationType,
        isCustomCalculation: false,
      };

      // Create OutPutSelectionWithParent objects
      const rowWithParent: OutPutSelectionWithParent = {
        Parent:
          item.rowChild.indexOf('Custom Group-User Defined') > -1 ||
            item.rowChild.indexOf('Custom Group - Shared With Me') > -1
            ? item.rowChild.split('|')[1]
            : item.rowChild.split('|')[0],
        Data: [rowSelection],
        isCustomGroup: item.isCustomGroup,
        customGroupId: item.customGroupId,
        isCustomCalculation: false,
      };

      const colWithParent: OutPutSelectionWithParent = {
        Parent:
          item.colChild.indexOf('Custom Group-User Defined') > -1 ||
            item.colChild.indexOf('Custom Group - Shared With Me') > -1
            ? item.colChild.split('|')[1]
            : item.colChild.split('|')[0],
        Data: [colSelection],
        isCustomGroup: item.isCustomGroup,
        customGroupId: item.customGroupId,
        isCustomCalculation: false,
      };

      // Check if the same parent and data combination already exists in the Row array
      const existingRowWithParent = this.OutputdataObject.Row.find(
        (existingItem) => {
          if (
            rowWithParent.isCustomGroup &&
            (rowWithParent.Parent === 'Custom Group-User Defined' ||
              rowWithParent.Parent === 'Custom Group - Shared With Me')
          ) {
            return (
              existingItem.Parent === rowWithParent.Parent &&
              existingItem.customGroupId === rowWithParent.customGroupId
            );
          } else {
            return existingItem.Parent === rowWithParent.Parent;
          }
        }
      );

      // If it doesn't exist, push the new object
      if (!existingRowWithParent) {
        this.OutputdataObject.Row.push(rowWithParent);
      } else {
        // If it exists, append the new data to the existing object

        const existingRowWithChild = existingRowWithParent.Data.find(
          (existingItem) => {
            if (
              existingItem.Child === rowSelection.Child &&
              existingItem.variablecode === rowSelection.variablecode
            ) {
              if (
                existingItem.isDerived &&
                existingItem.CalculationType.toLowerCase() == 'mean'
              ) {
                // When isDerviedVariable is true, don't consider existingItem.responsecode === rowSelection.responsecode
                return true;
              } else {
                // When isDerviedVariable is false, consider existingItem.responsecode === rowSelection.responsecode
                return existingItem.responsecode === rowSelection.responsecode;
              }
            }
            return false;
          }
        );

        if (!existingRowWithChild) {
          existingRowWithParent.Data.push(rowSelection);
        }

        if (existingRowWithChild) {
          const existsInNestedArray = existingRowWithChild?.NestedArray?.some(
            (existingNestedItem) =>
              rowSelection?.NestedArray?.some(
                (nestedArrayItem) =>
                  nestedArrayItem.Child === existingNestedItem.Child
              )
          );
          if (!existsInNestedArray && NestedRowSelection.Child != null) {
            existingRowWithChild.NestedArray.push(NestedRowSelection);
          }

          const existsInNestLeveledArray =
            existingRowWithChild?.NestedArray?.some(
              (existingNestedItem) =>
                existingNestedItem.NestedArray?.length === 0 ||
                existingNestedItem.NestedArray?.some(
                  (existingChildItem) =>
                    rowSelection?.NestedArray?.length === 0 ||
                    rowSelection?.NestedArray?.some(
                      (nestedArrayItem) =>
                        nestedArrayItem.NestedArray?.length === 0 ||
                        nestedArrayItem.NestedArray?.some(
                          (childItem) =>
                            childItem.Child === existingChildItem.Child &&
                            existingNestedItem.Child == nestedArrayItem.Child
                        )
                    )
                )
            );
          if (
            !existsInNestLeveledArray &&
            nestRowLevel2Selection.Child != null
          ) {
            if (existingRowWithChild.NestedArray.length > 0) {
              existingRowWithChild.NestedArray.forEach(
                (existingNestedItem: any, index: number) => {
                  rowSelection.NestedArray.forEach((colItem: any) => {
                    if (existingNestedItem.Child === colItem.Child) {
                      existingRowWithChild.NestedArray[index].NestedArray.push(
                        nestRowLevel2Selection
                      );
                    }
                  });
                }
              );
            }
          }
        }
      }

      // Perform a similar check for the Column array
      //const existingColWithParent = this.OutputdataObject.Column.find(
      //  (existingItem) => existingItem.Parent === colWithParent.Parent
      //);

      const existingColWithParent = this.OutputdataObject.Column.find(
        (existingItem) => {
          if (
            colWithParent.isCustomGroup &&
            (colWithParent.Parent === 'Custom Group-User Defined' ||
              colWithParent.Parent === 'Custom Group - Shared With Me')
          ) {
            return (
              existingItem.Parent === colWithParent.Parent &&
              existingItem.customGroupId === colWithParent.customGroupId
            );
          } else {
            return existingItem.Parent === colWithParent.Parent;
          }
        }
      );

      if (!existingColWithParent) {
        this.OutputdataObject.Column.push(colWithParent);
      } else {
        const existingColumnWithChild = existingColWithParent.Data.find(
          (existingItem) =>
            existingItem.Child === colSelection.Child &&
            existingItem.responsecode === colSelection.responsecode &&
            existingItem.variablecode === colSelection.variablecode
        );

        if (!existingColumnWithChild) {
          existingColWithParent.Data.push(colSelection);
        }
        // Check if the same NestedArray of Child already exists
        if (existingColumnWithChild) {
          const existsInNestedArray =
            existingColumnWithChild?.NestedArray?.some((existingNestedItem) =>
              colSelection?.NestedArray?.some(
                (nestedArrayItem) =>
                  nestedArrayItem.Child === existingNestedItem.Child
              )
            );
          if (!existsInNestedArray && NestedColumnSelection.Child != null) {
            existingColumnWithChild.NestedArray.push(NestedColumnSelection);
          }
          const existsInNestLeveledArray =
            existingColumnWithChild?.NestedArray?.some(
              (existingNestedItem) =>
                existingNestedItem.NestedArray?.length === 0 ||
                existingNestedItem.NestedArray?.some(
                  (existingChildItem) =>
                    colSelection?.NestedArray?.length === 0 ||
                    colSelection?.NestedArray?.some(
                      (nestedArrayItem) =>
                        nestedArrayItem.NestedArray?.length === 0 ||
                        nestedArrayItem.NestedArray?.some(
                          (childItem) =>
                            childItem.Child === existingChildItem.Child &&
                            existingNestedItem.Child == nestedArrayItem.Child
                        )
                    )
                )
            );
          if (!existsInNestLeveledArray && nestLevel2Selection.Child != null) {
            if (existingColumnWithChild.NestedArray.length > 0) {
              existingColumnWithChild.NestedArray.forEach(
                (existingNestedItem: any, index: number) => {
                  colSelection.NestedArray.forEach((colItem: any) => {
                    if (existingNestedItem.Child === colItem.Child) {
                      existingColumnWithChild.NestedArray[
                        index
                      ].NestedArray.push(nestLevel2Selection);
                    }
                  });
                }
              );
            }
          }
        }
      }
    });
    console.log(this.OutputdataObject);
  }
  replacePipe(input: string): string {
    return input.replace(/\|/g, ' : ');
  }
  onTableIconClick() {
    this.displayTable = true;
    this.isTableClick = true;
    this.isVerticalBarChartClick = false;
    this.isVerticalGroupBarChartClick = false;
    this.isLineChartClick = false;
    this.createTable(false, Feature.CrosstabOutput, false);
    // this.is_Time_Period_Present = true;
  }
  sortOutputData() {
    this.OutputdataObject.Row.sort((a, b) => {
      const indexA = this.dataObject.Row.findIndex(
        (item) => item.Parent === a.Parent
      );
      const indexB = this.dataObject.Row.findIndex(
        (item) => item.Parent === b.Parent
      );
      return indexA - indexB;
    });

    this.OutputdataObject.Column.sort((a, b) => {
      const indexA = this.dataObject.Column.findIndex(
        (item) => item.Parent === a.Parent
      );
      const indexB = this.dataObject.Column.findIndex(
        (item) => item.Parent === b.Parent
      );
      return indexA - indexB;
    });

    this.OutputdataObject.Row.forEach((row) => {
      const parentData = this.dataObject.Row.find(
        (item) => item.Parent === row.Parent
      );
      if (parentData) {
        row.Data.sort((a, b) => {
          const indexA = parentData.Data.findIndex(
            (data) => data.Child === a.Child
          );
          const indexB = parentData.Data.findIndex(
            (data) => data.Child === b.Child
          );
          return indexA - indexB;
        });
      }
    });

    this.OutputdataObject.Row.forEach((row) => {
      row.Data.forEach((outputSelection) => {
        this.dataObject.RowNesting.forEach((rowNest) => {
          outputSelection.NestedArray.sort((a, b) => {
            const indexA = rowNest.Data.findIndex(
              (data) => data.Child === a.Child
            );
            const indexB = rowNest.Data.findIndex(
              (data) => data.Child === b.Child
            );
            return indexA - indexB;
          });
        });
      });
    });

    this.OutputdataObject.Row.forEach((row) => {
      row.Data.forEach((outputSelection) => {
        outputSelection.NestedArray.forEach((rowNest1) => {
          this.dataObject.RowNesting.forEach((rowNest) => {
            rowNest1.NestedArray.sort((a, b) => {
              const indexA = rowNest.Data.findIndex(
                (data) => data.Child === a.Child
              );
              const indexB = rowNest.Data.findIndex(
                (data) => data.Child === b.Child
              );
              return indexA - indexB;
            });
          });
        });
      });
    });

    this.OutputdataObject.Column.forEach((column) => {
      const parentData = this.dataObject.Column.find(
        (item) => item.Parent === column.Parent
      );
      if (parentData) {
        column.Data.sort((a, b) => {
          const indexA = parentData.Data.findIndex(
            (data) => data.Child === a.Child
          );
          const indexB = parentData.Data.findIndex(
            (data) => data.Child === b.Child
          );
          return indexA - indexB;
        });
      }
    });

    this.OutputdataObject.Column.forEach((column) => {
      column.Data.forEach((outputSelection) => {
        this.dataObject.ColNesting.forEach((colNest) => {
          outputSelection.NestedArray.sort((a, b) => {
            const indexA = colNest.Data.findIndex(
              (data) => data.Child === a.Child
            );
            const indexB = colNest.Data.findIndex(
              (data) => data.Child === b.Child
            );
            return indexA - indexB;
          });
        });
      });
    });

    this.OutputdataObject.Column.forEach((column) => {
      column.Data.forEach((outputSelection) => {
        outputSelection.NestedArray.forEach((colNest1) => {
          this.dataObject.ColNesting.forEach((colNest) => {
            colNest1.NestedArray.sort((a, b) => {
              const indexA = colNest.Data.findIndex(
                (data) => data.Child === a.Child
              );
              const indexB = colNest.Data.findIndex(
                (data) => data.Child === b.Child
              );
              return indexA - indexB;
            });
          });
        });
      });
    });
    //If object modified then update the object
    this.OutputdataObject = JSON.parse(JSON.stringify(this.OutputdataObject));
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    // debugger
    //Check if the click event occurred outside the <div> block.
    //document.addEventListener('mousemove', () => this._authenticateService.resetSessionTimeoutTimer());
    //document.addEventListener('keydown', () => this._authenticateService.resetSessionTimeoutTimer());

    if (this.isExportspopup) {
      const targetElement = event.target as HTMLElement;


      const popupElement = document.querySelector('.setting-container');
      const buttonElement = document.querySelector('.exports-popup-container-img-block');

      // Close popup if clicked outside both popup and button
      if (
        popupElement && !popupElement.contains(targetElement) &&
        buttonElement && !buttonElement.contains(targetElement)
      ) {
        this.isExportspopup = false;
      }
    }

    if (this.sidePanelDisplay == true) {
      if (!this.isClickInside(event, '.RowPanel')) {
        this.sidePanelDisplay = false;
      }
    }
    if (this.sidePanelNestingDisplay == true) {
      if (!this.isClickInside(event, '.RowNestPanel')) {
        this.sidePanelNestingDisplay = false;
      }
    }
    if (this.columnPanelDisplay == true) {
      if (!this.isClickInside(event, '.ColPanel')) {
        this.columnPanelDisplay = false;
      }
    }
    if (this.columnNestingPanelDispaly == true) {
      if (!this.isClickInside(event, '.ColNestPanel')) {
        this.columnNestingPanelDispaly = false;
      }
    }
    if (this.filterPanelDisplay == true) {
      if (!this.isClickInside(event, '.FilterPanel')) {
        this.filterPanelDisplay = false;
      }
    }
    if (this.isSelectionSummary == true) {
      if (!this.isClickInside(event, '.summaryPanel')) {
        this.isSelectionSummary = false;
      }
    }
    if (this.sampleSizeDropdown == true) {
      if (!this.isClickInside(event, '.significance')) {
        this.sampleSizeDropdown = false;
        this.isReference = false;
      }
    }
    if (this.dataDropDown == true) {
      if (!this.isClickInside(event, '.dataDropdown')) {
        this.dataDropDown = false;
      }
    }
    if (this.confidenceLevelDropDown == true) {
      if (!this.isClickInside(event, '.confidance')) {
        this.confidenceLevelDropDown = false;
      }
    }
    if (this.referenceLevelDropDown) {
      if (!this.isClickInside(event, '.reference')) {
        this.referenceLevelDropDown = false;
      }
    }
    if (this.weightDropDown) {
      if (!this.isClickInside(event, '.weight')) {
        this.weightDropDown = false;
      }
    }
    if (this.showCustomMetricsPopup) {
      if (!this.isClickInside(event, '.customMetric')) {
        this.showCustomMetricsPopup = false;
      }
    }
    //if (this.handleLeftPanel != "" && this.entryFlag == true) {
    //  if (!this.isClickInside(event, ".leftPanelLvl0")) {
    //    this.handleLeftPanel = "";
    //  }
    //}
  }
  private downloadFile(data: Blob, filename: string) {
    const blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;

    // Trigger download
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  private downloadPPTFile(data: Blob, filename: string) {
    const blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation', // MIME type for PPTX
    });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;

    // Trigger download
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
  getCurrentDateTime() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    const formattedDateTime = `${year}-${month}-${day}-${hours}-${minutes}-${seconds}`;
    return formattedDateTime;
  }
  private isClickInside(event: Event, className: string): boolean {
    const elements = document.querySelectorAll(className);
    for (let i = 0; i < elements.length; i++) {
      const container = elements[i];
      if (container.contains(event.target as Node)) {
        return true;
      }
    }
    return false;
  }
  OnTotalClick() {
    this.isTotal = !this.isTotal;
    if (this.isTotal) this.CrossTabOutPutData = this.CrossTabOutPutEntireData;
    else
      this.CrossTabOutPutData = this.CrossTabOutPutEntireData.filter(
        (x: any) => {
          return !x.isTotal;
        }
      );

    this.OutputdataObject = {
      Row: [],
      Column: [],
    };
    if (this.isIndex && this.selectedIndex != '') {
      this.manipulateIndexData();
    }
    this.BindTableOutput(this.CrossTabOutPutData);
    this.sortOutputData();
    this.crossTabService.setCrossTabOuputData(this.CrossTabOutPutData);
  }
  toggleDataBlock(block: string): void {
    this.isTableClick = false;
    this.isLineChartClick = false;
    this.displayTable = true;
    this.isVerticalBarChartClick = false;
    this.isVerticalStackChartClick = false;
    this.isVerticalGroupBarChartClick = false;
    if (!this.isVerticalGroupBarChartClick) {
      this.disableStackChart = true;
    }

    const rowdata = this.dataObject['Row'];
    const columndata = this.dataObject['Column'];
    const TimePeriodinColumn = columndata.filter((parent) => {
      return parent.Data.some((child) => child.isTimePeriod === true);
    });
    const rowDataLength: number =
      rowdata.length > 0 ? rowdata[0].Data.length : 0;
    this.isChartView =
      this.listBItemsList.length > 0 ||
        this.listDItemsList.length > 0 ||
        rowdata.length < 1 ||
        rowDataLength > 15
        ? false
        : true;
    if (this.isChartView) {
      const isMultiPunchRow = rowdata.filter((parent) => {
        return parent.Data.some(
          (child) => child.isMultiPunch === Status.MultiPunchDisableChart
        );
      });
      const isMultiPunchColumn = columndata.filter((parent) => {
        return parent.Data.some(
          (child) => child.isMultiPunch === Status.MultiPunchDisableChart
        );
      });

      const isDefaultRespGrp = rowdata.filter((parent) => {
        return parent.Data.some(
          (child) =>
            child.CalculationType === 'RespGrp' &&
            child.isDerviedVariable == true
        );
      });

      const isMeanMetric = rowdata.filter((parent) => {
        return parent.Data.some(
          (child) =>
            child.CalculationType.toLowerCase() === 'mean' &&
            child.isDerviedVariable == true
        );
      });

      if (this.isChartView) {
        this.disableLineChart = TimePeriodinColumn.length == 1 ? true : false;

        if (rowdata.length == 1) {
          let filteredData: any = [];
          const disctinctRowValues = this.getDistinctChildValues(
            this.dataObject.Row
          );

          let distinctFirstParts = this.getDistinctValuesByPipeCount(
            disctinctRowValues,
            0
          );
          let distinctSecondParts = this.getDistinctValuesByPipeCount(
            disctinctRowValues,
            1
          );
          let distinctThirdParts = this.getDistinctValuesByPipeCount(
            disctinctRowValues,
            2
          );
          let distinctFourthParts = this.getDistinctValuesByPipeCount(
            disctinctRowValues,
            3
          );
          let distinctFifthParts = this.getDistinctValuesByPipeCount(
            disctinctRowValues,
            4
          );

          if (
            distinctFifthParts.length > 0 &&
            distinctFourthParts.length == 1 &&
            distinctThirdParts.length == 1 &&
            distinctSecondParts.length == 1 &&
            distinctFirstParts.length == 1
          ) {
            this.StackFlag = true;
          } else if (
            distinctFourthParts.length > 0 &&
            distinctThirdParts.length == 1 &&
            distinctSecondParts.length == 1 &&
            distinctFirstParts.length == 1
          ) {
            this.StackFlag = true;
          } else if (
            distinctFourthParts.length > 0 &&
            distinctThirdParts.length > 0 &&
            distinctSecondParts.length == 1 &&
            distinctFirstParts.length == 1
          ) {
            this.StackFlag = false;
          } else if (
            distinctThirdParts.length > 0 &&
            distinctSecondParts.length == 1 &&
            distinctFirstParts.length == 1
          ) {
            this.StackFlag = true;
          } else if (
            distinctThirdParts.length > 0 &&
            distinctSecondParts.length > 0 &&
            distinctFirstParts.length == 1
          ) {
            this.StackFlag = false;
          } else if (
            distinctSecondParts.length > 0 &&
            distinctFirstParts.length == 1
          ) {
            this.StackFlag = true;
          }

          if (this.StackFlag) {
            rowdata[0].Data.forEach((item) => {
              const pipeCount = (item.Child.match(/\|/g) || []).length;
              if (pipeCount === 1) {
                const [level1] = item.Child.split('|');
                filteredData = this.variableTabData.filter(
                  (x: any) => x.Level1 === level1 && x.Header == 'VariableList'
                );
              } else if (pipeCount === 2) {
                const [level1, level2] = item.Child.split('|');
                filteredData = this.variableTabData.filter(
                  (x: any) =>
                    x.Level1 === level1 &&
                    x.Level2 === level2 &&
                    x.Header == 'VariableList'
                );
              } else if (pipeCount === 3) {
                const [level1, level2, level3] = item.Child.split('|');
                filteredData = this.variableTabData.filter(
                  (x: any) =>
                    x.Level1 === level1 &&
                    x.Level2 === level2 &&
                    x.level3 === level3 &&
                    x.Header == 'VariableList'
                );
              } else if (pipeCount === 4) {
                const [level1, level2, level3, level4] = item.Child.split('|');
                filteredData = this.variableTabData.filter(
                  (x: any) =>
                    x.Level1 === level1 &&
                    x.Level2 === level2 &&
                    x.level3 === level3 &&
                    x.level4 == level4 &&
                    x.Header == 'VariableList'
                );
              } else if (pipeCount === 5) {
                const [level1, level2, level3, level4, level5] =
                  item.Child.split('|');
                filteredData = this.variableTabData.filter(
                  (x: any) =>
                    x.Level1 === level1 &&
                    x.Level2 === level2 &&
                    x.level3 === level3 &&
                    x.level4 == level4 &&
                    x.level5 == level5 &&
                    x.Header == 'VariableList'
                );
              }
            });
          } else {
            this.StackFlag = false;
          }
          this.disableStackChart =
            isMultiPunchRow.length > 0 ||
              isMultiPunchColumn.length > 0 ||
              isDefaultRespGrp.length > 0 ||
              isMeanMetric.length > 0
              ? false
              : rowdata[0].Data.length == filteredData.length
                ? true
                : false;
        }
      }
    }
    this.DefaultDataDropDown = block;
    if (block === 'Data') {
      this.isData = true;
      this.isSampleSize = false;
      this.isWeightedLabel = false;
      this.isWeightedNumerator = false;
      this.isUnWeightedNumerator = false;
      this.disableLineChart = TimePeriodinColumn.length == 1 ? true : false;
    } else if (block === 'Sample Size') {
      this.isData = false;
      this.isSampleSize = true;
      this.isWeightedLabel = false;
      this.isWeightedNumerator = false;
      this.isUnWeightedNumerator = false;
    } else if (block === 'Weighted Sample') {
      this.isData = false;
      this.isSampleSize = false;
      this.isWeightedLabel = true;
      this.isWeightedNumerator = false;
      this.isUnWeightedNumerator = false;
    } else if (block == 'Weighted Numerator') {
      this.isData = false;
      this.isSampleSize = false;
      this.isWeightedLabel = false;
      this.isWeightedNumerator = true;
      this.isUnWeightedNumerator = false;
    } else if (block == 'Unweighted Numerator') {
      this.isData = false;
      this.isSampleSize = false;
      this.isWeightedLabel = false;
      this.isWeightedNumerator = false;
      this.isUnWeightedNumerator = true;
    }

    if (this.isIndex) {
      this.isChartView = false;
    }
  }

  toggleSigBlockbkp(block: string): void {
    if (block === 'Sig') {
      // debugger
      this.isSig = true;
      this.isIndex = false;
      this.isChartView = true;
      this.isSampleSize = false;
      this.isWeightedLabel = false;
      this.isWeightedNumerator = false;
      this.isUnWeightedNumerator = false;
      this.isCreateBtnClick = true;
      // this.sendInputMessage();
      // this.createTable(false, Feature.CrosstabOutput, false);
    } else if (block === 'Index') {
      this.displayTable = true;
      this.isData = true;
      this.isWeightedNumerator = false;
      this.isUnWeightedNumerator = false;
      this.DefaultDataDropDown = 'Data';
      this.isVerticalGroupBarChartClick = false;
      this.isVerticalBarChartClick = false;
      this.isVerticalStackChartClick = false;
      this.isLineChartClick = false;
      this.isSig = false;
      this.isIndex = true;
      this.isChartView = false;
      this.DefaultReferenceLevel = 'None';
      this.DefaultSampleSize = 'None';
      this.DefaultConfidenceLevel = 'None';
      this.SignificanceVsReference = '';
      this.isReference = false;
      this.selectedIndex = '';
      this.isPairWise = false;
      if (this.isTranspose) {
        this.isTranspose = false;
        this.reverseTranspose();
      }
      this.IndexData = this.getLastLevelColumnNestingValues();
      //this.SelectionSummary();
      // if (this.OutputdataObject.Column.length > 0) {
      //   if (this.OutputdataObject['Column'][0]['Data'].length > 0) {
      //     let firstLevelLength =
      //       this.OutputdataObject['Column'][0]['Data'].length;

      //     if (firstLevelLength > 0) {
      //       let level0 =
      //         this.OutputdataObject['Column'][0]['Data'][firstLevelLength - 1];
      //       if (level0.NestedArray.length > 0) {
      //         let secondLevelLength = level0.NestedArray.length;
      //         if (secondLevelLength > 0) {
      //           let level1 = level0.NestedArray[secondLevelLength - 1];

      //           if (level1.NestedArray.length > 0) {
      //             let finalData =
      //               this.OutputdataObject['Column'][0]['Data'][
      //                 firstLevelLength - 1
      //               ].NestedArray[secondLevelLength - 1].NestedArray;
      //             this.IndexData = finalData;
      //           } else {
      //             this.IndexData = level0.NestedArray;
      //           }
      //         }
      //       } else {
      //         this.IndexData = this.OutputdataObject['Column'][0]['Data'];
      //       }
      //     }
      //   }
      // }
    }
  }
  toggleSigBlock(block: string): void {
    if (block === 'Sig') {
      this.isSig = true;
      this.isIndex = false;
      this.isChartView = true;
      this.isSampleSize = false;
      this.isWeightedLabel = false;
      this.isWeightedNumerator = false;
      this.isUnWeightedNumerator = false;
      this.createTable(false, Feature.CrosstabOutput, false);
      // this.sampleSizeDropdown=true;
      this.is_Time_Period_Present = true;
    } else if (block === 'Index') {
      this.displayTable = true;
      this.isData = true;
      this.isWeightedNumerator = false;
      this.isUnWeightedNumerator = false;
      this.DefaultDataDropDown = 'Data';
      this.isVerticalGroupBarChartClick = false;
      this.isVerticalBarChartClick = false;
      this.isVerticalStackChartClick = false;
      this.isLineChartClick = false;
      this.isSig = false;
      this.isIndex = true;
      this.isChartView = false;
      this.DefaultReferenceLevel = 'None';
      this.DefaultSampleSize = 'None';
      this.DefaultConfidenceLevel = 'None';
      this.SignificanceVsReference = '';
      this.isReference = false;
      this.selectedIndex = '';
      this.isPairWise = false;
      if (this.isTranspose) {
        this.isTranspose = false;
        this.reverseTranspose();
      }
      this.IndexData = this.getLastLevelColumnNestingValues();
      // this.SelectionSummary();
      // if (this.OutputdataObject.Column.length > 0) {
      //   if (this.OutputdataObject['Column'][0]['Data'].length > 0) {
      //     let firstLevelLength =
      //       this.OutputdataObject['Column'][0]['Data'].length;

      //     if (firstLevelLength > 0) {
      //       let level0 =
      //         this.OutputdataObject['Column'][0]['Data'][firstLevelLength - 1];
      //       if (level0.NestedArray.length > 0) {
      //         let secondLevelLength = level0.NestedArray.length;
      //         if (secondLevelLength > 0) {
      //           let level1 = level0.NestedArray[secondLevelLength - 1];

      //           if (level1.NestedArray.length > 0) {
      //             let finalData =
      //               this.OutputdataObject['Column'][0]['Data'][
      //                 firstLevelLength - 1
      //               ].NestedArray[secondLevelLength - 1].NestedArray;
      //             this.IndexData = finalData;
      //           } else {
      //             this.IndexData = level0.NestedArray;
      //           }
      //         }
      //       } else {
      //         this.IndexData = this.OutputdataObject['Column'][0]['Data'];
      //       }
      //     }
      //   }
      // }
    }
  }
  createTable(
    isSampleSize: boolean,
    feature: string = Feature.CrosstabOutput,
    isIndexing: boolean
  ) {
    // this.hidePanel = !this.hidePanel;
    // this.getVariableData()
    // this.isLineChartClick = false;

    this.variableTabData = this.crossTabService.getVarTabData;
    this.displayTable = true;
    this.isDemoStudy = false;
    this.isSig = isIndexing ? false : true;
    this.isIndex = isIndexing ? true : false;
    this.referenceLevelDropDown = false; //isIndexing ? true : false;
    this.DefaultReferenceLevel = isIndexing
      ? this.DefaultReferenceLevel
      : 'None';
    this.selectedIndex = isIndexing ? this.selectedIndex : '';
    const rowdata = this.dataObject['Row'];
    const RowNesting = this.dataObject['RowNesting'];
    const columndata = this.dataObject['Column'];
    const ColNesting = this.dataObject['ColNesting'];
    const Filter = this.dataObject['Filter'];
    let isTimePeriodPresent = this.variableTabData.filter(
      (a: any) => a.is_time_Period_Present === true
    );
    const columnDataLength: number =
      columndata.length > 0 ? columndata.length : 0;
    let isDimensionPresent = this.variableTabData.filter(
      (a: any) => a.is_dimension_Present === true
    );

    this.is_Time_Period_Present =
      isTimePeriodPresent.length == 0 ? false : true;
    this.is_dimension_Present = isDimensionPresent.length == 0 ? false : true;
    this.is_indexingShow =
      this.selectedDataFormat == 'Respondent Level' && this.is_indexing
        ? columnDataLength > 1
          ? false
          : true
        : false;
    this.isDisableReference = columnDataLength > 1 ? true : false;
    const TimePeriodinColumn = columndata.filter((parent) => {
      return parent.Data.some((child) => child.isTimePeriod === true);
    });

    const isDefaultRespGrp = rowdata.filter((parent) => {
      return parent.Data.some(
        (child) =>
          child.CalculationType === 'RespGrp' && child.isDerviedVariable == true
      );
    });

    const isMeanMetric = rowdata.filter((parent) => {
      return parent.Data.some(
        (child) =>
          child.CalculationType.toLowerCase() === 'mean' &&
          child.isDerviedVariable == true
      );
    });

    const isMultiPunchRow = rowdata.filter((parent) => {
      return parent.Data.some(
        (child) => child.isMultiPunch === Status.MultiPunchDisableChart
      );
    });
    const isMultiPunchColumn = columndata.filter((parent) => {
      return parent.Data.some(
        (child) => child.isMultiPunch === Status.MultiPunchDisableChart
      );
    });
    const rowDataLength: number =
      rowdata.length > 0 ? rowdata[0].Data.length : 0;
    const rowNestDataLength: number =
      RowNesting.length > 0 ? RowNesting[0].Data.length : 0;
    const colNestDataLength: number =
      ColNesting.length > 0 ? ColNesting[0].Data.length : 0;
    // this.isChartView =
    //   this.listBItemsList.length > 0 ||
    //   this.listDItemsList.length > 0 ||
    //   rowdata.length < 1 ||
    //   rowDataLength > 15
    //     ? false
    //     : true;
    this.isChartView =
      rowNestDataLength > 0 ||
        colNestDataLength > 0 ||
        rowdata.length < 1 ||
        rowDataLength > 15
        ? false
        : true;
    if (this.isChartView) {
      this.disableLineChart = TimePeriodinColumn.length == 1 ? true : false;

      if (rowdata.length == 1) {
        let filteredData: any = [];
        const disctinctRowValues = this.getDistinctChildValues(
          this.dataObject.Row
        );

        let distinctFirstParts = this.getDistinctValuesByPipeCount(
          disctinctRowValues,
          0
        );
        let distinctSecondParts = this.getDistinctValuesByPipeCount(
          disctinctRowValues,
          1
        );
        let distinctThirdParts = this.getDistinctValuesByPipeCount(
          disctinctRowValues,
          2
        );
        let distinctFourthParts = this.getDistinctValuesByPipeCount(
          disctinctRowValues,
          3
        );
        let distinctFifthParts = this.getDistinctValuesByPipeCount(
          disctinctRowValues,
          4
        );

        if (
          distinctFifthParts.length > 0 &&
          distinctFourthParts.length == 1 &&
          distinctThirdParts.length == 1 &&
          distinctSecondParts.length == 1 &&
          distinctFirstParts.length == 1
        ) {
          this.StackFlag = true;
        } else if (
          distinctFourthParts.length > 0 &&
          distinctThirdParts.length == 1 &&
          distinctSecondParts.length == 1 &&
          distinctFirstParts.length == 1
        ) {
          this.StackFlag = true;
        } else if (
          distinctFourthParts.length > 0 &&
          distinctThirdParts.length > 0 &&
          distinctSecondParts.length == 1 &&
          distinctFirstParts.length == 1
        ) {
          this.StackFlag = false;
        } else if (
          distinctThirdParts.length > 0 &&
          distinctSecondParts.length == 1 &&
          distinctFirstParts.length == 1
        ) {
          this.StackFlag = true;
        } else if (
          distinctThirdParts.length > 0 &&
          distinctSecondParts.length > 0 &&
          distinctFirstParts.length == 1
        ) {
          this.StackFlag = false;
        } else if (
          distinctSecondParts.length > 0 &&
          distinctFirstParts.length == 1
        ) {
          this.StackFlag = true;
        }

        if (this.StackFlag) {
          rowdata[0].Data.forEach((item) => {
            const pipeCount = (item.Child.match(/\|/g) || []).length;
            if (pipeCount === 1) {
              const [level1] = item.Child.split('|');
              filteredData = this.variableTabData.filter(
                (x: any) => x.Level1 === level1 && x.Header == 'VariableList'
              );
            } else if (pipeCount === 2) {
              const [level1, level2] = item.Child.split('|');
              filteredData = this.variableTabData.filter(
                (x: any) =>
                  x.Level1 === level1 &&
                  x.Level2 === level2 &&
                  x.Header == 'VariableList'
              );
            } else if (pipeCount === 3) {
              const [level1, level2, level3] = item.Child.split('|');
              filteredData = this.variableTabData.filter(
                (x: any) =>
                  x.Level1 === level1 &&
                  x.Level2 === level2 &&
                  x.level3 === level3 &&
                  x.Header == 'VariableList'
              );
            } else if (pipeCount === 4) {
              const [level1, level2, level3, level4] = item.Child.split('|');
              filteredData = this.variableTabData.filter(
                (x: any) =>
                  x.Level1 === level1 &&
                  x.Level2 === level2 &&
                  x.level3 === level3 &&
                  x.level4 == level4 &&
                  x.Header == 'VariableList'
              );
            } else if (pipeCount === 5) {
              const [level1, level2, level3, level4, level5] =
                item.Child.split('|');
              filteredData = this.variableTabData.filter(
                (x: any) =>
                  x.Level1 === level1 &&
                  x.Level2 === level2 &&
                  x.level3 === level3 &&
                  x.level4 == level4 &&
                  x.level5 == level5 &&
                  x.Header == 'VariableList'
              );
            }
          });
        } else {
          this.StackFlag = false;
        }
        this.disableStackChart =
          isMultiPunchRow.length > 0 ||
            isMultiPunchColumn.length > 0 ||
            isDefaultRespGrp.length > 0 ||
            isMeanMetric.length > 0
            ? false
            : rowdata[0].Data.length == filteredData.length
              ? true
              : false;
      }
    }
    if (isSampleSize) {
      this.isLineChartClick = this.isLineChartClick || this.isTableClick;
      this.isVerticalGroupBarChartClick =
        this.isVerticalGroupBarChartClick || this.isTableClick;
      this.isVerticalBarChartClick =
        this.isVerticalBarChartClick || this.isTableClick;
      this.isVerticalStackChartClick =
        this.isVerticalStackChartClick || this.isTableClick;
      this.isTableClick = false;
      this.displayTable =
        this.isLineChartClick ||
          this.isVerticalGroupBarChartClick ||
          this.isVerticalStackChartClick
          ? false
          : true;
      this.isData =
        this.isLineChartClick ||
          this.isVerticalGroupBarChartClick ||
          this.isVerticalStackChartClick
          ? false
          : true;
    } else {
      this.isTableClick = false;
      this.isLineChartClick = false;
      this.isVerticalGroupBarChartClick = false;
      this.isVerticalBarChartClick = false;
      this.isVerticalStackChartClick = false;
      this.isData = true;
      this.DefaultDataDropDown = 'Data';
      this.isTranspose = false;
      this.displayTable = true;
      this.isTotal = this.isIndex ? this.isTotal : false;
      if (
        this.dataObject.ColNesting.length == 0 &&
        this.dataObject.Column.length == 1 &&
        this.dataObject.Column[0].Data.length <= 10
      )
        this.isDisablePairWise = false;
    }
    this.isSampleSize = false;
    this.isWeightedLabel = false;
    this.sampleSizeDropdown = false;
    this.confidenceLevelDropDown = false;
    //this.DefaultSampleSize = isSampleSize ? this.DefaultSampleSize : 'None';
    //this.DefaultConfidenceLevel = isSampleSize ? this.DefaultConfidenceLevel : 'None';
    const matchColumnFound = this.isLevel1TimePeriodPresent(
      this.listCItemsList
    );
    const matchColumnNestFound = this.isLevel1TimePeriodPresent(
      this.listDItemsList
    );
    const matchFilterNestFound = this.isLevel1TimePeriodPresent(
      this.listEItemsList
    );

    const matchColumnDimension = this.isDimensionPresent(this.listCItemsList);

    const matchColumnNestDimension = this.isDimensionPresent(
      this.listDItemsList
    );

    const matchFilterDimension = this.isDimensionPresent(this.listEItemsList);

    const distinctValuesForListA = this.getDistinctLevel0Values(
      this.listAItemsList
    );

    const distinctValuesForListC = this.getDistinctLevel0Values(
      this.listCItemsList
    );
    const distinctValuesForListD = this.getDistinctLevel0Values(
      this.listDItemsList
    );
    const distinctValuesForListE = this.getDistinctLevel0Values(
      this.listEItemsList
    );

    const allDistinctValues = [
      ...distinctValuesForListC,
      ...distinctValuesForListD,
      ...distinctValuesForListE,
    ];

    const allDistinctValueAggregated = [
      ...distinctValuesForListA,
      ...distinctValuesForListC,
      ...distinctValuesForListD,
      ...distinctValuesForListE,
    ];

    const distinctEntryList = this.getDistinctENtryList(this.entryList);

    const distinctAggregatedMetric = this.getDistinctAggregaredMetrics(
      this.variableTabData
    );

    const allEntryListPresent = distinctEntryList.every((entry) =>
      allDistinctValues.includes(entry)
    );

    const allEntryListPresentAggregated = distinctAggregatedMetric.every(
      (entry) => allDistinctValueAggregated.includes(entry)
    );

    const matchingCount = distinctEntryList.filter((entry) =>
      allDistinctValues.includes(entry)
    ).length;
    // let Isshowpopup = this.ShowCustomValidationPopUp(
    //   rowdata,
    //   columndata,
    //   RowNesting,
    //   ColNesting,
    //   Filter,
    //   matchingCount,
    //   matchColumnDimension,
    //   matchColumnNestDimension,
    //   matchFilterDimension,
    //   matchColumnFound,
    //   matchColumnNestFound,
    //   matchFilterNestFound,
    //   distinctEntryList,
    //   allEntryListPresent,
    //   allEntryListPresentAggregated,
    //   allDistinctValueAggregated
    // );
    let Isshowpopup = false;

    // if (this.listAItemsList.length == 0 || this.listCItemsList.length == 0) {
    //   this.getValidation('createtable', 'Rows/Columns', '');
    // }else if (matchingCount != this.entryList.length && this.entryList.length > 0) {
    //   this.getValidation('entry', 'entrypoints', '');
    // }else if (!(matchColumnFound || matchColumnNestFound || matchFilterNestFound)) {
    //   this.getValidation('missingtimeperiod', 'Rows/Columns/Filters', '');
    // }else if (distinctEntryList.length == 0 && !(matchColumnDimension || matchColumnNestDimension || matchFilterDimension)) {
    //   this.getValidation('dimension', 'output', '');
    // } else if (this.listAItemsList.length > 0 || this.listCItemsList.length > 0) {
    // show messages for the not selected option list in selection panel

    // }
    // this.getValidation('MetricSelection', 'Rows/Columns', '');
    // } else if (this.listBItemsList.length != RowNesting.length) {
    //   this.getValidation('MetricSelection', 'Rows/Columns', '');
    // } else if (this.listCItemsList.length != columndata.length) {
    //   this.getValidation('MetricSelection', 'Rows/Columns', '');
    // } else if (this.listDItemsList.length != ColNesting.length) {
    //   this.getValidation('MetricSelection', 'Rows/Columns', '');
    // } else if (this.listEItemsList.length != Filter.length) {
    //   this.getValidation('MetricSelection', 'Rows/Columns', '');
    // }
    //  else if (allEntryListPresent == false) {
    //   this.getValidation('missingentry', 'Rows/Columns/Filters', '');
    // }
    if (Isshowpopup == false) {
      //const disctinctRowValues = this.getDistinctChildValues(
      //  this.dataObject.Row
      //);
      //const disctinctRowNestingValues = this.getDistinctChildValues(
      //  this.dataObject.RowNesting
      //);
      //const disctinctColumnValues = this.getDistinctChildValues(
      //  this.dataObject.Column
      //);
      //const disctinctColumnNestingValues = this.getDistinctChildValues(
      //  this.dataObject.ColNesting
      //);
      //const FilterValues = this.getDistinctChildValues(this.dataObject.Filter);

      //const RowValues = this.transformData(disctinctRowValues);
      //const RowNestingValues = this.transformData(disctinctRowNestingValues);
      //const ColumnValues = this.transformData(disctinctColumnValues);
      //const ColumnNestingValues = this.transformData(
      //  disctinctColumnNestingValues
      //);
      //const FilterData = this.transformData(FilterValues);
      //this.BindSelectionSummary(
      //  RowValues,
      //  RowNestingValues,
      //  ColumnValues,
      //  ColumnNestingValues,
      //  FilterData,
      //  false
      //);
      this.SelectionSummary();
      this.isCreateBtnClick = true;
      this.clearOutputDataObject();
      this._loaderService.showLoader();

      // Corrected variable declarations
      var weightColumnName: string = '';
      var isBoostFactor: boolean = false;

      //if boost factor is selected in weights dropdown then send default weight column
      if (this.DefaultWeight.trim() == 'Boost Factor') {
        //consider first weight as the default weight
        weightColumnName = this.WeightDropDownList[0].responseCode;
        isBoostFactor = true;
      }

      var istimePeriodWave = this.isWaveTimePeriod();
      //this.mandatoryVariableMapping;
      // debugger
      this.AssignDataToPreviousDataObject(this.dataObject);

      this.$unSubscribeSubmitData4 = this.crossTabService
        .getOutPutData(
          this.previewDataObject,
          this.selected_client,
          this.selected_study,
          this.DefaultSampleSize,
          this.isFilteringActive,
          this.DefaultConfidenceLevel,
          this.isTotalBase,
          this.selectedWeight,
          weightColumnName,
          isBoostFactor,
          this.SignificanceVsReference,
          this.columnLength,
          this.dataArray,
          this.isBrandAnalysis,//(this.mcode === 2) ? true : false,
          this.isAggregatedData,
          this.isSemiAggregatedData,
          this.isRespondentLevel,
          this.aggregatedVariables,
          istimePeriodWave,
          this.isTotal
        )
        .subscribe((result: results) => {
          // Response is valid
          if (result.HasValidData) {
            let JsonData = JSON.parse(result.Data);
            // this.CrossTabOutPutData = JsonData;
            this.isReference = false;
            this.CrossTabOutPutEntireData = JsonData;
            let chartType = 'column';
            chartType = this.isTranspose ? 'column' : 'bar';
            if (this.CrossTabOutPutEntireData.length > 0) {
              this.CrossTabOutPutData = this.CrossTabOutPutEntireData;
              if (!this.isTotal)
                this.CrossTabOutPutData = this.CrossTabOutPutEntireData.filter(
                  (x: any) => {
                    return !x.isTotal;
                  }
                );
              if (this.isIndex && this.selectedIndex != '') {
                this.manipulateIndexData();
              }
              // this.sampleSizeDropdown=true;
              this.BindTableOutput(this.CrossTabOutPutData);
              this.sortOutputData();

              //this.LimitDataForOutput();
              // Check if the 'isTranspose' flag is set to true
              if (this.isTranspose) {
                // If 'isTranspose' is true, call a function to modify row column based on transpose selection
                this.handleOutputdataObjectOnTransposeSelect();
              }
              this.crossTabService.setCrossTabOuputData(
                this.CrossTabOutPutData
              );

              if (this.isLineChartClick) {
                this.onTrendChartIconClick();
              } else if (
                this.isVerticalGroupBarChartClick ||
                this.isVerticalBarChartClick
              ) {
                this.VerticalChartClick(chartType);
              } else if (this.isVerticalStackChartClick) {
                this.onVerticalStackBarChartIconClick(chartType);
              }
            }
          }
          // For usage log
          this.usageDataLog(feature);
          //hide the loader
          this._loaderService.hideLoader();
        });
    }

    if (columnDataLength > 1) this.isDisableReference = true;
    else this.isDisableReference = false;
  }
  usageDataLog(feature: string) {
    let summarytext = '';
    if (this.summaryText != undefined && this.summaryText != null)
      summarytext = this.summaryText?.nativeElement.innerText;
    else summarytext = this.selectionSummary.replace(/<[^>]*>/g, '');
    this._usermanagementService.UsageData(
      COMMON_CONSTANTS.DataExplorerModuleId.toString(),
      this.selected_client,
      this.selected_study,
      feature,
      summarytext,
      ''
    );
  }
  AssignDataToPreviousDataObject(dataObject: DataObject) {
    // debugger
    this.previewDataObject.Row = dataObject.Row;
    this.previewDataObject.Column = dataObject.Column;
    this.previewDataObject.ColNesting = dataObject.ColNesting;
    this.previewDataObject.RowNesting = dataObject.RowNesting;
    this.previewDataObject.Filter = dataObject.Filter;
  }

  private isWaveTimePeriod() {
    if (
      this.mandatoryVariableMapping == undefined ||
      this.mandatoryVariableMapping == null
    )
      return false;
    else {
      let timePeriodEntries: any = this.mandatoryVariableMapping.filter(
        (entry: any) =>
          entry.variable_label === 'Time Period' &&
          entry.variable_code &&
          entry.variable_code.trim() !== ''
      );

      let isWaveTimePeriod =
        timePeriodEntries.length === 0 ||
        timePeriodEntries.every(
          (entry: any) =>
            entry.variable_code === timePeriodEntries[0].variable_code
        );

      return isWaveTimePeriod;
    }
  }
  clearOutputDataObject(): void {
    this.OutputdataObject = {
      Row: [],
      Column: [],
    };
    this.FinalOutputdataObject = {
      Row: [],
      Column: [],
    };
  }
  getDistinctAggregaredMetrics(list: any[]) {
    const distinctLevel0Values = [...new Set(list.map((item) => item.Level0))];
    return distinctLevel0Values;
  }
  getDistinctENtryList(list: any[]) {
    const distinctLevel0Values = [...new Set(list.map((item) => item.Level1))];
    return distinctLevel0Values;
  }
  getDistinctLevel0Values(list: any[]) {
    const distinctLevel0Values = [...new Set(list.map((item) => item.Level0))];
    return distinctLevel0Values;
  }
  isDimensionPresent(list: any[]): boolean {
    return list.some((entry) => entry.is_dimension === true);
  }

  isLevel1TimePeriodPresent(list: any[]): boolean {
    return list.some((entry) => entry.Level0 === 'Time Period');
  }
  getLastLevelColumnNestingValues() {
    var indexData;
    if (this.OutputdataObject.Column.length > 0) {
      if (this.OutputdataObject['Column'][0]['Data'].length > 0) {
        let firstLevelLength =
          this.OutputdataObject['Column'][0]['Data'].length;

        if (firstLevelLength > 0) {
          let level0 =
            this.OutputdataObject['Column'][0]['Data'][firstLevelLength - 1];
          if (level0.NestedArray.length > 0) {
            let secondLevelLength = level0.NestedArray.length;
            if (secondLevelLength > 0) {
              let level1 = level0.NestedArray[secondLevelLength - 1];

              if (level1.NestedArray.length > 0) {
                let finalData =
                  this.OutputdataObject['Column'][0]['Data'][
                    firstLevelLength - 1
                  ].NestedArray[secondLevelLength - 1].NestedArray;
                indexData = finalData;
                this.columnLength = 2;
              } else {
                indexData = level0.NestedArray;
                this.columnLength = 1;
              }
            }
          } else {
            indexData = this.OutputdataObject['Column'][0]['Data'];
            this.columnLength = 0;
          }
        }
      }
    }

    return indexData;
  }
  SelectionSummary() {
    const disctinctRowValues = this.getDistinctChildValues(this.dataObject.Row);
    const disctinctRowNestingValues = this.getDistinctChildValues(
      this.dataObject.RowNesting
    );
    const disctinctColumnValues = this.getDistinctChildValues(
      this.dataObject.Column
    );
    const disctinctColumnNestingValues = this.getDistinctChildValues(
      this.dataObject.ColNesting
    );
    const FilterValues = this.getDistinctChildValues(this.dataObject.Filter);

    const RowValues = this.transformData(disctinctRowValues);
    const RowNestingValues = this.transformData(disctinctRowNestingValues);
    const ColumnValues = this.transformData(disctinctColumnValues);
    const ColumnNestingValues = this.transformData(
      disctinctColumnNestingValues
    );
    const FilterData = this.transformData(FilterValues);
    this.BindSelectionSummary(
      RowValues,
      RowNestingValues,
      ColumnValues,
      ColumnNestingValues,
      FilterData,
      false
    );
  }
  BindSelectionSummary(
    RowValues: string[],
    RowNestingValues: string[],
    ColumnValues: string[],
    ColumnNestingValues: string[],
    FilterData: string[],
    isSavedSelection: boolean
  ) {
    let rowNestingSection = '';
    let colNestSection = '';
    let FiltersSection = '';
    let significanceSection = '';
    let confidenceSection = '';
    let Reference = '';
    let Weight = '';
    let Base = '';
    let study = '';
    if (RowNestingValues.length > 0) {
      rowNestingSection = ` <span class="grey-separator"> || </span> <span class="summary-label">Row Nesting:</span> ${RowNestingValues.join(
        '&nbsp;,&nbsp;'
      )}`;
    }
    if (ColumnNestingValues.length > 0) {
      colNestSection = ` <span class="grey-separator"> || </span> <span class="summary-label">Column Nesting:</span> ${ColumnNestingValues.join(
        '&nbsp;,&nbsp;'
      )}`;
    }
    if (FilterData.length > 0) {
      FiltersSection = `  <span class="summary-label">Filters:</span> ${FilterData.join(
        '&nbsp;,&nbsp;'
      )} <span class="grey-separator"> || </span> `;
    }
    if (!isSavedSelection && this.selectedDataFormat == 'Respondent Level') {
      if (this.SignificanceVsReference != '') {
        significanceSection = `  <span class="summary-label">Significance:</span> ${this.DefaultSampleSize
          } : ${this.replacePipe(
            this.SignificanceVsReference
          )} <span class="grey-separator"> || </span> `;
      } else {
        significanceSection = `  <span class="summary-label">Significance:</span> ${this.DefaultSampleSize} <span class="grey-separator"> || </span> `;
      }
      confidenceSection = `  <span class="summary-label">Confidence Level:</span> ${this.DefaultConfidenceLevel} <span class="grey-separator"> || </span> `;
    }
    if (
      this.selectedIndex != '' &&
      this.isIndex &&
      this.selectedDataFormat == 'Respondent Level'
    ) {
      Reference = `  <span class="summary-label">Reference:</span> ${this.replacePipe(
        this.selectedIndex
      )} <span class="grey-separator"> || </span> `;
    }
    if (
      this.DefaultWeight != '' &&
      this.selectedDataFormat == 'Respondent Level'
    ) {
      Weight = `  <span class="summary-label">Calculation Weight:</span> ${this.DefaultWeight} <span class="grey-separator"> || </span> `;
    }
    if (this.selectedDataFormat == 'Respondent Level') {
      Base = `<span class="summary-label">Calculation Base:</span> ${this.isTotalBase ? 'Total Base' : 'Answer Base'
        } <span class="grey-separator"> || </span> `;
    }
    study = `<span class="summary-label">Study Type:</span> ${this.selected_study} <span class="grey-separator"> || </span> `;

    this.selectionSummary = `${study}  ${Base} <span class="summary-label">Nesting Type:</span> ${this.isFilteringActive ? 'Filtering' : 'Profiling'
      } <span class="grey-separator"> || </span> ${Weight} ${significanceSection} ${confidenceSection} ${Reference}  ${FiltersSection} <span class="summary-label">Row:</span> ${RowValues.join(
        '&nbsp;,&nbsp;'
      )}
    ${rowNestingSection} <span class="grey-separator"> || </span> <span class="summary-label">Column:</span> ${ColumnValues.join(
        '&nbsp;,&nbsp;'
      )} ${colNestSection}`;

    this.selectionSummary = this.selectionSummary
      .replaceAll('@', ' , ')
      .replace(/<[^>]*>/g, '')           // Remove all HTML tags
      .replace(/&nbsp;/g, ' ')          // Replace &nbsp; with regular spaces
      .replace(/\s+/g, ' ')             // Replace multiple spaces with single space
      .replace(/\s*\|\|\s*/g, ' || ')   // Clean spacing around || separators
      .replace(/^\s*\|\|\s*/, '')       // Remove leading separator
      .replace(/\s*\|\|\s*$/, '')       // Remove trailing separator
      .trim();                          // Remove leading/trailing whitespace
  }

  transformData(dataList: string[]): string[] {
    const transformedData: { [key: string]: { [subKey: string]: string[] } } =
      {};

    dataList.forEach((item) => {
      const parts = item.split('|');
      const mainKey = parts[0];

      if (parts.length > 1) {
        const subKey = parts.slice(1, -1).join('|');
        const value = parts.slice(-1)[0];

        if (!transformedData[mainKey]) {
          transformedData[mainKey] = {};
        }

        if (!transformedData[mainKey][subKey]) {
          transformedData[mainKey][subKey] = [];
        }

        transformedData[mainKey][subKey].push(value);
      } else {
        // Handle single-value case
        if (!transformedData[mainKey]) {
          transformedData[mainKey] = { '': [] };
        }

        transformedData[mainKey][''].push(parts[0]);
      }
    });

    return Object.keys(transformedData).map((mainKey) => {
      const subKeys = Object.keys(transformedData[mainKey]);
      const subStrings = subKeys.map((subKey) => {
        const subString =
          subKey === ''
            ? transformedData[mainKey][subKey]
            : `${subKey}: ${transformedData[mainKey][subKey].join(',')}`;
        return subString;
      });
      // return `${mainKey}: ${subStrings.join(' , ')}`;
      return `${mainKey}: ${subStrings.join(',').replace(/,/g, ' , ')}`; // Add space before and after the comma
    });
  }
  reverseTranspose() {
    if (
      this.OutputdataObject != null &&
      (this.OutputdataObject['Row'].length > 0 ||
        this.OutputdataObject['Column'].length > 0)
    ) {
      // Create copies of rows and columns arrays to preserve the original data
      let tempRow = [...this.OutputdataObject.Column];
      let tempColumn = [...this.OutputdataObject.Row];

      // Swap rows and columns to transpose the data
      this.OutputdataObject.Row = [...tempRow];
      this.OutputdataObject.Column = [...tempColumn];
    }
  }
  SampleSizeDropDownClick(SelectedValue: string) {
    this.isPairWise = false;
    this.isReference = false;
    // this.SignificanceVsReference = "";

    if (SelectedValue == 'Reference') {
      this.isReference = true;

      this.IndexData = this.getLastLevelColumnNestingValues();
    } else {
      this.SignificanceVsReference = '';
      this.isReference = false;
      this.DefaultDataDropDown = 'Data';
      this.DefaultSampleSize = SelectedValue;
      if (SelectedValue == 'None') {
        this.DefaultConfidenceLevel = 'None';
      } else if (SelectedValue == 'Pairwise') {
        this.DefaultConfidenceLevel =
          this.is_confidenceLevel.length > 0
            ? this.is_confidenceLevel[0]['key']
            : '95%';
        this.isPairWise = true;
      } else {
        this.DefaultConfidenceLevel =
          this.is_confidenceLevel.length > 0
            ? this.is_confidenceLevel[0]['key']
            : '95%';
      }
      this.sampleSizeDropdown = false;
      // this.createTable(true, false);
      // this.sampleSizeDropdown=true;
      this.createTable(true, Feature.Significance, false);

      // this.is_Time_Period_Present = true;
    }
  }
  confidenceDropDownClick(SelectedValue: string) {
    this.DefaultConfidenceLevel = SelectedValue;
    this.confidenceLevelDropDown = false;
    this.DefaultDataDropDown = 'Data';
    this.createTable(true, Feature.ConfidenceLevel, false);
    // this.is_Time_Period_Present = true;
  }

  referenceDropDownClickIndexSignificance(SelectedValue: string) {
    this.SignificanceVsReference = SelectedValue;
    this.DefaultConfidenceLevel =
      this.is_confidenceLevel.length > 0
        ? this.is_confidenceLevel[0]['key']
        : '95%';
    this.DefaultSampleSize = 'Reference';
    this.DefaultDataDropDown = 'Data';
    this.createTable(true, Feature.Significance, false);
    // this.is_Time_Period_Present = true;
    // this.sampleSizeDropdown=true;
  }

  referenceDropDownClick(SelectedValue: string) {
    this.DefaultReferenceLevel = this.replacePipe(SelectedValue);
    this.selectedIndex = SelectedValue;
    this.createTable(false, Feature.Index, true);

    //let data = this.CrossTabOutPutData;
    //this.CrossTabOutPutData = [];
    //this.CrossTabOutPutData = data;
    //if (this.CrossTabOutPutData.length > 0) {
    //  this.crossTabService.setCrossTabOuputData(this.CrossTabOutPutData);
    //}
    //this.referenceLevelDropDown = false;
    //this.createTable(true, Feature.ConfidenceLevel);
  }

  togglePanel(SelectedDropDown: string) {
    if (SelectedDropDown == 'significance') {
      this.sampleSizeDropdown = !this.sampleSizeDropdown;
      this.isReference = false;
    } else if (SelectedDropDown == 'confidence') {
      this.confidenceLevelDropDown = !this.confidenceLevelDropDown;
    } else if (SelectedDropDown == 'reference') {
      this.referenceLevelDropDown = !this.referenceLevelDropDown;
    } else if (SelectedDropDown == 'weight') {
      this.weightDropDown = !this.weightDropDown;
    } else if (SelectedDropDown == 'datadropdown') {
      this.dataDropDown = !this.dataDropDown;
    }
  }
  handleExportClick() {
    if (this.mcode == 2 || this.mcode == 3) {
      const FilterValues = this.getDistinctChildValues(this.dataObject.Filter);
      const FilterData = this.transformData(FilterValues);
      let excelinputs: ExcelDataModel = {
        significance: this.DefaultSampleSize,
        isTranspose: this.isTranspose,
        baseType: this.isTotalBase,
        confidenceLevel: this.DefaultConfidenceLevel,
        output: '', //JSON.stringify(this.CrossTabOutPutData),
        studyName: this.selected_study,
        clientName: this.selected_client,
        filters: FilterData.join(','),
        nestingType: this.isFilteringActive ? 'Filtering' : 'Profiling',
        isFiltering: this.isFilteringActive,
        selectionInput: this.dataObject,
        // selectionSummary: this.summaryText==undefined?"":this.summaryText?.nativeElement.innerText,
        selectionSummary: JSON.stringify(this.insightsVal),
        failedComments: '',
        isTotal: this.isTotal,
        lowBase: this.LowBase == '' ? 0 : Number(this.LowBase),
        InsufficientBase:
          this.insufficientBase == '' ? 0 : Number(this.insufficientBase),
        threshold: this.threshold == '' ? 0 : Number(this.threshold),
        selectedIndex: this.selectedIndex,
        selectedWeight: this.selectedWeight,
        DefaultWeight: this.DefaultWeight,
        isBrandAnalysis: this.mcode == 2,
        SignificanceVsReference: this.replacePipe(this.SignificanceVsReference),
        DataFormat: this.selectedDataFormat,
        isSampleSizeBlock: this.isSampleSizeBlock,
        isWeightedSampleBlock: this.isWeightedSampleBlock,
        query: this.chatPreviewBlocks.length > 0 ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question : this.inputValue,
      };
      if (!this.FooterNote) {
        this._loaderService.showLoader();
        excelinputs.output = JSON.stringify(this.CrossTabOutPutData);
        this.$unSubscribeSubmitData5 = this.apiService
          .exportToExcelARK(excelinputs)
          .subscribe(
            (excelBlob: Blob) => {
              let datetimeFormat = this.getCurrentDateTime();
              let fileName =
                'KantarXTab_' +
                excelinputs.clientName +
                '_' +
                excelinputs.studyName +
                '_' +
                datetimeFormat +
                '.xlsx';
              // Trigger file download
              this.downloadFile(excelBlob, fileName);
              this._loaderService.hideLoader();
              // this.usageDataLog(Feature.ExportExcel);
            },
            (error) => {
              console.error('Error exporting to Excel', error);
              // this.errorPopup('Something went wrong, please try again');
              this._loaderService.hideLoader();
            }
          );
      } else {
        var istimePeriodWave = this.isWaveTimePeriod();
        this._exportDownloads
          .exportToExcelLargeSelection(excelinputs, istimePeriodWave)
          .subscribe((result: results) => {
            // Check if the response has valid data
            if (result.HasValidData) {
              let ExportReport: ExcelExportReport = JSON.parse(result.Data);
              if (ExportReport != null) {
                // this.errorPopup(this.largeSelectionText, 'Alert');
                console.log('Started in Background');
              }
            }
            // Hide the loader after the deletion process
            this.arktabaccess = false;

            // this.usageDataLog(Feature.ExportExcel);
          });
      }
    }
    else if (this.mcode == 1) {
      this.excelexportClicked();
    }
  }
  OnTransposeClick() {
    this.isTableClick = false;

    this.isTranspose = !this.isTranspose;
    this.disableLineChart = this.isTranspose ? false : true;
    this.isLineChartClick = false;
    //disable significance if transpose enabled
    this.isSignificanceContainerDisabled =
      !this.isSignificanceContainerDisabled;
    if (
      (this.isVerticalGroupBarChartClick || this.isVerticalBarChartClick) &&
      this.isTranspose
    ) {
      this.VerticalChartClick('bar');
    } else if (
      (this.isVerticalGroupBarChartClick || this.isVerticalBarChartClick) &&
      !this.isTranspose
    ) {
      this.VerticalChartClick('column');
    } else if (this.isVerticalStackChartClick && this.isTranspose) {
      this.onVerticalStackBarChartIconClick('bar');
    } else if (this.isVerticalStackChartClick && !this.isTranspose) {
      this.onVerticalStackBarChartIconClick('column');
    }
    this.handleOutputdataObjectOnTransposeSelect();
    //else {
    //  this.handleOutputdataObjectOnTransposeSelect();
    //  // if (
    //  //   this.OutputdataObject != null &&
    //  //   (this.OutputdataObject['Row'].length > 0 ||
    //  //     this.OutputdataObject['Column'].length > 0)
    //  // ) {
    //  //   let tempRow = [...this.OutputdataObject.Row];
    //  //   let tempColumn = [...this.OutputdataObject.Column];
    //  //   this.OutputdataObject.Row = [...tempColumn];
    //  //   this.OutputdataObject.Column = [...tempRow];
    //  //   // this.crossTabService.setCrossTabOuputData(
    //  //   //   this.CrossTabOutPutData
    //  //   // );
    //  // }
    //}
  }
  handlePPTExportClick() {
    // debugger;
    if (this.mcode == 2 || this.mcode == 3) {
      this.SelectedSummary();
      let pptinputs: ChartDetails = {
        selectedSignifcance:
          this.DefaultSampleSize == 'Pairwise' ? 'None' : this.DefaultSampleSize,
        ChartCategory: this.isLineChartClick
          ? 'LineOrTrendChart'
          : this.isVerticalBarChartClick || this.isVerticalGroupBarChartClick
            ? 'Bar'
            : 'StackedBar',
        DisplayName: this.isLineChartClick
          ? 'Line Chart'
          : this.isVerticalBarChartClick
            ? 'BarChart'
            : this.isVerticalGroupBarChartClick
              ? 'GroupBarChart'
              : this.isVerticalStackChartClick && this.isTranspose
                ? 'StackedBar'
                : 'StackedColumn',
        ChartTitle: this.isLineChartClick
          ? 'Line Chart'
          : this.isVerticalBarChartClick && this.isTranspose
            ? 'horizontal bar chart'
            : this.isVerticalBarChartClick && !this.isTranspose
              ? 'vertical bar chart'
              : this.isVerticalGroupBarChartClick && this.isTranspose
                ? 'Horizontal Cluster Bar Chart'
                : this.isVerticalGroupBarChartClick && !this.isTranspose
                  ? 'Vertical Cluster Bar Chart'
                  : this.isVerticalStackChartClick && this.isTranspose
                    ? 'Horizontal Stacked Chart'
                    : 'Vertical Stacked Chart',
        ChartOutput: this.isLineChartClick
          ? JSON.stringify(this.LineChart)
          : this.isVerticalStackChartClick
            ? JSON.stringify(this.StackChart)
            : JSON.stringify(this.BarChart),
        isSolidPattern: false,
        chartId: this.isLineChartClick
          ? 1
          : this.isVerticalStackChartClick
            ? 2
            : (this.isVerticalBarChartClick || this.isVerticalGroupBarChartClick) &&
              this.isTranspose
              ? 3
              : (this.isVerticalBarChartClick || this.isVerticalGroupBarChartClick) &&
                !this.isTranspose
                ? 1
                : 0,
        Type: this.isTranspose ? 'Column' : 'Bar',
        // SelectionSummary: this.summaryText?.nativeElement.innerText,
        //SelectionSummary:JSON.stringify(this.insightsVal),
        insufficientBase: this.insufficientBase,
        lowBaseValue: this.LowBase,
        //  clientCode: this.selected_client
        SelectionSummary: this.selectedData,
        query: this.chatPreviewBlocks.length > 0 ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question : this.inputValue,
        insightsVal: JSON.stringify(this.insightsVal),
      };
      this._loaderService.showLoader();
      //excelinputs.output = JSON.stringify(this.CrossTabOutPutData)
      this.$unSubscribeSubmitData7 = this.apiService
        .exportToPPT(pptinputs)
        .subscribe(
          (pptBlob: Blob) => {
            this._loaderService.hideLoader();
            let datetimeFormat = this.getCurrentDateTime();
            let fileName =
              'KantarXTab_' +
              this.selected_client +
              '_' +
              this.selected_study +
              '_' +
              datetimeFormat +
              '.pptx';
            // Trigger file download
            this.downloadPPTFile(pptBlob, fileName);
          },
          (error) => {
            this._loaderService.hideLoader();
            console.error('Error exporting to Excel', error);
            // this.errorPopup('Something went wrong, please try again');
          }
        );
    }
    else {
      this.editablePPTClicked();
    }
  }

  fetchDiagnostic() {
    this.inputValue = '';
    this.apiService.getDiagonistics().subscribe((dt) => {
      try {
        const result = typeof dt === 'string' ? JSON.parse(dt) : dt;
        const data: Array<DiagnosticData> = JSON.parse(result.Data);
        this.displayDiagnosticData(data);
      } catch (err) {
        console.error('Failed to parse diagnostics response:', err, dt);
        alert('Failed to load diagnostics data.');
      }
    });
  }

  displayDiagnosticData(data: DiagnosticData[]) {
    const newTab = window.open('', '_blank');
    if (!newTab) {
      alert('Unable to open a new tab. Please check if pop-ups are blocked.');
      return;
    }

    // Handling empty dataset 
    if (!data || data.length === 0) {
      newTab.document.write(`
      <html>
        <head>
          <title>ARK Diagnostics Data</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
          </style>
        </head>
        <body>
          <h2>No diagnostic data available</h2>
        </body>
      </html>
    `);
      newTab.document.close();
      return;
    }

    const columnKeys = [
      'UserEmail',
      'Date',
      'clientName',
      'studyName',
      'MessageId',
      'user_input',
      'mcode',
      'IsLiked',
      'DislikeReason',
      'Column',
      'Column_Nesting',
      'Filter',
      'Page_ID',
      'Row',
      'Row_Nesting',
      'Section',
      'Snapshot_Name',
      'Snapshot_Type',
      'SubSection',
      'Widget_ID',
      'entryPointData',
      's_Filter',
      's_Market',
      's_Timeperiod'
    ];

    // Build the document structure
    newTab.document.write(`
    <html>
      <head>
        <title>ARK Diagnostics Data</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 20px;
            background-color: #f5f5f5;
          }
          .download-btn {
            padding: 10px 15px;
            background-color: #4CAF50;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
            float: right;
            margin-right: 20px;
          }
          .download-btn:hover {
            background-color: #45a049;
          }
          .search-container {
            margin-bottom: 20px;
          }
          .autocomplete {
            width: 300px;
            padding: 10px;
            border: 1px solid #ddd;
            border-radius: 4px;
            font-size: 14px;
          }
          .pagination-container {
            margin: 20px 0;
            text-align: center;
          }
          .pagination-info {
            margin: 10px 0;
            font-size: 14px;
            color: #666;
          }
          .pagination-controls {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            margin: 10px 0;
          }
          .pagination-btn {
            padding: 8px 12px;
            border: 1px solid #ddd;
            border-radius: 4px;
            background: white;
            cursor: pointer;
            font-size: 14px;
          }
          .pagination-btn:hover {
            background-color: #f0f0f0;
          }
          .pagination-btn:disabled {
            background-color: #e9e9e9;
            color: #999;
            cursor: not-allowed;
          }
          .page-input {
            width: 60px;
            padding: 8px;
            border: 1px solid #ddd;
            border-radius: 4px;
            text-align: center;
            font-size: 14px;
          }
          .table-container {
            max-height: 85vh;
            overflow: auto;
            border: 1px solid #ddd;
            border-radius: 4px;
            background-color: white;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            position: relative;
          }
          table {
            width: 100%;
            border-collapse: separate;
            border-spacing: 0;
            font-size: 13px;
            table-layout: auto;
          }
          
          /* Fixed columns styling */
          th:nth-child(1), td:nth-child(1) {
              position: sticky;
              left: 0;
              z-index: 20;
              background-color: white;
              border-right: 2px solid #4CAF50;
              min-width: 200px;
              width: 200px;
          }

          th:nth-child(2), td:nth-child(2) {
              position: sticky;
              left: 200px;
              z-index: 20;
              background-color: white;
              border-right: 2px solid #4CAF50;
              min-width: 200px;
              width: 200px;
          }

          th:nth-child(3), td:nth-child(3) {
              position: sticky;
              left: 400px; /* 200px * 2 */
              z-index: 20;
              background-color: white;
              border-right: 2px solid #4CAF50;
              min-width: 200px;
              width: 200px;
          }

          th:nth-child(4), td:nth-child(4) {
              position: sticky;
              left: 600px; /* 200px * 3 */
              z-index: 20;
              background-color: white;
              border-right: 2px solid #4CAF50;
              min-width: 200px;
              width: 200px;
          }

          th:nth-child(5), td:nth-child(5) {
              position: sticky;
              left: 800px; /* 200px * 4 */
              z-index: 20;
              background-color: white;
              border-right: 2px solid #4CAF50;
              min-width: 200px;
              width: 200px;
          }


          /* Header styling for fixed columns */
          th:nth-child(1), th:nth-child(2),
          th:nth-child(3), th:nth-child(4), th:nth-child(5) {
              background-color: #4CAF50;
              color: white;
              z-index: 30;
          }

          /* Apply hover effect to the entire row */
          tr:hover td {
              background-color: #e8f5e8;
          }

          /* Apply even-row striping to the entire row */
          tr:nth-child(even) td {
              background-color: #f9f9f9;
          }

          /* Ensure hover overrides even-row striping */
          tr:nth-child(even):hover td {
              background-color: #e8f5e8;
          }

          /* General header styling */
          th {
              background-color: #4CAF50;
              color: white;
              padding: 15px 12px;
              text-align: left;
              position: sticky;
              top: 0;
              z-index: 10;
              border-right: 1px solid #45a049;
              font-weight: bold;
              min-width: 180px;
              width: 240px;
              font-size: 14px;
          }
          
          td {
            padding: 12px;
            border-bottom: 1px solid #ddd;
            border-right: 1px solid #ddd;
            min-width: 180px;
            width: 200px;
            height: 170px;
            vertical-align: top;
            position: relative;
            background-color: white;
          }
          
          .cell-content {
            max-height: 150px;
            overflow-y: auto;
            word-wrap: break-word;
            word-break: break-word;
            line-height: 1.4;
            padding-right: 6px;
            font-size: 13px;
          }
          .cell-content::-webkit-scrollbar {
            width: 8px;
          }
          .cell-content::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 3px;
          }
          .cell-content::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 3px;
          }
          .cell-content::-webkit-scrollbar-thumb:hover {
            background: #555;
          }
          tr:nth-child(even) {
            background-color: #f9f9f9;
          }
          tr:hover {
            background-color: #e8f5e8;
          }
          .json-content {
            font-family: 'Courier New', monospace;
            font-size: 12px;
            background-color: #f8f8f8;
            border: 1px solid #e0e0e0;
            border-radius: 2px;
            white-space: pre-line;
          }
        </style>
      </head>
      <body>
        <div class="search-container">
          <input type="text" placeholder="Search..." class="autocomplete" id="searchInput"/>
          <button id="downloadExcelBtn" class="download-btn">Download Excel</button>
        </div>

        <div class="pagination-container">
          <div class="pagination-info" id="paginationInfo"></div>
          <div class="pagination-controls">
            <button class="pagination-btn" id="firstBtn">First</button>
            <button class="pagination-btn" id="prevBtn">Previous</button>
            <span>Page</span>
            <input type="number" class="page-input" id="pageInput" min="1" value="1">
            <span id="totalPagesLabel">of 1</span>
            <button class="pagination-btn" id="nextBtn">Next</button>
            <button class="pagination-btn" id="lastBtn">Last</button>
          </div>
        </div>

        <div class="table-container">
          <table id="diagnosticTable">
            <thead>
              <tr>
                ${columnKeys.map((key) => `<th>${key}</th>`).join('')}
              </tr>
            </thead>
            <tbody id="tableBody"></tbody>
          </table>
        </div>

        <script>
          (function() {
            const ITEMS_PER_PAGE = 10;
            let allData = [];
            let filteredData = [];
            let currentPage = 1;
            let totalPages = 1;
            const columnKeys = ${JSON.stringify(columnKeys)};

            // Initialize data
            function initializeData() {
              // Injected/serialized data (escape < and > to avoid HTML breaking)
              allData = ${JSON.stringify(data).replace(/</g, '\\u003c').replace(/>/g, '\\u003e')};

              // Format 'Date' property if present
              allData = allData.map(item => {
                if (item.Date) {
                  item.Date = formatDate(item.Date);
                }
                return item;
              });

              filteredData = [...allData];
              totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
              console.log('Total entries:', filteredData.length);
              console.log('Total pages:', totalPages);
            }

            // Format date function - handles C# DateTime serialization
            function formatDate(dateStr) {
              try {
                let date;
                if (typeof dateStr === 'string') {
                  if (dateStr.includes('T')) {
                    const cleanDateStr = dateStr.split('.')[0]; // Remove milliseconds
                    date = new Date(cleanDateStr);
                  } else {
                    date = new Date(dateStr);
                  }
                } else {
                  date = new Date(dateStr);
                }

                if (!isNaN(date.getTime())) {
                  return date.toLocaleString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false
                  });
                } else {
                  console.error('Invalid date:', dateStr);
                  return dateStr;
                }
              } catch (e) {
                console.error('Date formatting error:', e, 'Original:', dateStr);
                return dateStr;
              }
            }

            function renderTable() {
              const tableBody = document.getElementById('tableBody');
              const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
              const endIndex = Math.min(startIndex + ITEMS_PER_PAGE, filteredData.length);

              tableBody.innerHTML = '';

              for (let i = startIndex; i < endIndex; i++) {
                const item = filteredData[i];
                const row = document.createElement('tr');
                row.id = 'row-' + i;

                columnKeys.forEach((key) => {
                  const cell = document.createElement('td');
                  const cellContent = document.createElement('div');
                  cellContent.className = 'cell-content';

                  let value = (item[key] ?? 'N/A');

                  // Check if content looks like JSON
                  const isJsonContent = typeof value === 'string' &&
                    (value.trim().startsWith('{') || value.trim().startsWith('['));

                  if (isJsonContent) {
                    try {
                      const parsed = JSON.parse(value);
                      const formatted = JSON.stringify(parsed, null, 2);
                      const jsonDiv = document.createElement('div');
                      jsonDiv.className = 'json-content';
                      jsonDiv.textContent = formatted;
                      cellContent.appendChild(jsonDiv);
                    } catch (e) {
                      cellContent.textContent = value;
                    }
                  } else {
                    cellContent.textContent = value;
                  }

                  cell.appendChild(cellContent);
                  row.appendChild(cell);
                });

                tableBody.appendChild(row);
              }

              updatePaginationControls();
            }

            function updatePaginationControls() {
              const paginationInfo = document.getElementById('paginationInfo');
              const firstBtn = document.getElementById('firstBtn');
              const prevBtn = document.getElementById('prevBtn');
              const nextBtn = document.getElementById('nextBtn');
              const lastBtn = document.getElementById('lastBtn');
              const pageInput = document.getElementById('pageInput');
              const totalPagesLabel = document.getElementById('totalPagesLabel');

              const startIndex = (currentPage - 1) * ITEMS_PER_PAGE + 1;
              const endIndex = Math.min(currentPage * ITEMS_PER_PAGE, filteredData.length);

              if (paginationInfo) {
                paginationInfo.textContent = \`Showing \${startIndex}-\${endIndex} of \${filteredData.length} entries\`;
              }

              if (totalPagesLabel) {
                totalPagesLabel.textContent = \`of \${totalPages}\`;
              }

              if (pageInput) {
                pageInput.value = String(currentPage);
                pageInput.setAttribute('max', String(totalPages));
              }

              if (firstBtn) firstBtn.disabled = currentPage === 1;
              if (prevBtn)  prevBtn.disabled = currentPage === 1;
              if (nextBtn)  nextBtn.disabled = currentPage === totalPages;
              if (lastBtn)  lastBtn.disabled = currentPage === totalPages;
            }

            function goToPage(page) {
              const clamped = Math.max(1, Math.min(page, totalPages));
              if (clamped !== currentPage) {
                currentPage = clamped;
                renderTable();
              } else {
                // still update controls to keep input/labels in sync
                updatePaginationControls();
              }
            }

            // Pagination event listeners (guarded)
            const firstBtn = document.getElementById('firstBtn');
            const prevBtn  = document.getElementById('prevBtn');
            const nextBtn  = document.getElementById('nextBtn');
            const lastBtn  = document.getElementById('lastBtn');
            const pageInput = document.getElementById('pageInput');

            if (firstBtn) firstBtn.addEventListener('click', () => goToPage(1));
            if (prevBtn)  prevBtn.addEventListener('click', () => goToPage(currentPage - 1));
            if (nextBtn)  nextBtn.addEventListener('click', () => goToPage(currentPage + 1));
            if (lastBtn)  lastBtn.addEventListener('click', () => goToPage(totalPages));

            if (pageInput) {
              pageInput.addEventListener('change', function(e) {
                const value = (e.target && 'value' in e.target) ? Number(e.target.value) : NaN;
                if (!isNaN(value) && value >= 1 && value <= totalPages) {
                  goToPage(value);
                } else {
                  (e.target).value = String(currentPage);
                }
              });
            }

            // Search functionality
            const searchInput = document.getElementById('searchInput');
            if (searchInput) {
              searchInput.addEventListener('keyup', function(e) {
                const searchTerm = (e.target && 'value' in e.target) ? String(e.target.value).toLowerCase() : '';

                if (searchTerm === '') {
                  filteredData = [...allData];
                } else {
                  filteredData = allData.filter(item => {
                    return columnKeys.some(key => {
                      const value = item[key];
                      if (value === null || value === undefined) return false;
                      return String(value).toLowerCase().includes(searchTerm);
                    });
                  });
                }

                totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE) || 1;
                currentPage = 1; // Reset to first page after search
                renderTable();
              });
            }

            // Excel download functionality
            function downloadExcel() {
              if (!filteredData || filteredData.length === 0) {
                alert('No data to export');
                return;
              }

              // Create CSV content
              const headers = columnKeys.map(k => \`"\${k}"\`).join(',');
              const rows = filteredData.map(item => {
                return columnKeys.map(key => {
                  let cellData = item[key] ?? '';
                  // Handle objects/newlines/quotes
                  if (typeof cellData === 'object') {
                    cellData = JSON.stringify(cellData);
                  }
                  cellData = String(cellData).replace(/"/g, '""'); // Escape double quotes
                  return \`"\${cellData}"\`;
                }).join(',');
              });
              
              const csvContent = headers + '\\n' + rows.join('\\n');
              const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
              const url = URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.setAttribute('href', url);
              const dateStr = new Date().toISOString().slice(0,10).replace(/-/g,'');
              link.setAttribute('download', \`diagnostic_data_\${dateStr}.csv\`);
              link.style.visibility = 'hidden';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }

            const downloadBtn = document.getElementById('downloadExcelBtn');
            if (downloadBtn) {
              downloadBtn.addEventListener('click', downloadExcel);
            }

            // Initial setup
            initializeData();
            renderTable();
          })();
        </script>
      </body>
    </html>
  `);

    newTab.document.close();
  }

  snapshotWidgetData: any = [];
  snapshotDataModel: any = [];
  widegtconfigdetails: any = {
    section: '',
    subSection: '',
    snapshotType: '',
    snapshotName: '',
    clientName: '',
    study: '',
    IsCustomSnapshot: false,
  };
  indexVsBrandReference: any = [];
  significanceVsBrandReference: any = [];
  significance: string = 'None';
  weightColumnName: string = '';
  isBoostFactor: boolean = false;
  istimePeriodWave: boolean = false;
  passOutputData: any;
  snapshotName: string = '';
  moduleList: any = [];
  selectedType: any = 'Single Brand';
  filteredWidgetSelection: any;
  subSectionNames: any = [];
  output_details: any = {}; // un-comment it later
  pageData: any;
  widgetData: any;
  baseselected = 'Total Base';
  outputData: any;
  item: any;
  items: any;
  itemWithoutTrend: any;
  itemWithoutTrendItems: any;
  MainResult: any;
  filteredWidgetData: any;
  filteredWidgetID: any;
  selectedWidgetName: any;
  selectedWidgetID: any;
  WidgetId: any;
  getSnapshotPassOutputData() {
    this.significance = 'None';
    this.isFilteringActive = true;
    this.DefaultConfidenceLevel = 'None';
    this.SignificanceVsReference = '';
    this.isTotalBase = this.isTotalBase ?? true;
    this.weightColumnName = '';
    let isBoostFactor = false;
    let weightColumnName = '';
    var istimePeriodWave = false;
    // this.widegtconfigdetails.section = 'Scorecard'; //this.selectedSection;
    this.widegtconfigdetails.section = this.selectedSection; //'Single Brand Snapshot';
    this.widegtconfigdetails.subSection = 'NA'; //this.selectedSubSection;
    this.widegtconfigdetails.snapshotType = this.selectedcompareacrossOption; //'Single Brand';
    this.widegtconfigdetails.snapshotName = this.snapshotName;
    this.widegtconfigdetails.clientName = this.selected_client;
    this.widegtconfigdetails.study = this.selected_study;
    this.widegtconfigdetails.IsCustomSnapshot = true;
    let isBrandAnalysis = true;
    this.indexVsBrandReference = this.indexVsBrandReference;
    this.significanceVsBrandReference = this.significanceVsBrandReference;
    let passOutputData: any = {
      //  previewData: load ? this.output_data?.previewData : this.previewData,
      selectedClient: this.widegtconfigdetails.clientName,
      selectedStudy: this.widegtconfigdetails.study,
      significance: this.significance,
      isFilteringActive: this.isFilteringActive,
      DefaultConfidenceLevel: this.DefaultConfidenceLevel,
      isTotalBase: this.isTotalBase,
      selectedWeight: this.selectedWeight,
      weightColumnName: weightColumnName,
      isBoostFactor: isBoostFactor,
      SignificanceVsReference: this.SignificanceVsReference,
      columnLength: this.columnLength,
      dataArray: this.dataArray,
      isBrandAnalysis: isBrandAnalysis,
      isAggregatedData: this.isAggregatedData,
      isSemiAggregatedData: this.isSemiAggregatedData,
      isRespondentLevel: this.isRespondentLevel,
      aggregatedVariables: this.aggregatedVariables,
      istimePeriodWave: istimePeriodWave,
      widegtconfigdetails: this.widegtconfigdetails,
      indexVsBrandReference: this.indexVsBrandReference,
      significanceVsBrandReference: this.significanceVsBrandReference,
      LeftPanelSelectedBrand: ['JP Morgan Chase'], //this.selectedBrand,
      LeftPanelSelectedTimePeriod: ['2023'], //this.selectedTimePeriod,
    };
    return passOutputData;
  }

  selectedTypeFun2(data: any) {
    this.selectedType = data;
    // const sectionNav = document.querySelector('app-header-section-list');
    // if (sectionNav) {
    //   sectionNav?.classList.remove('NN');
    // }

    this.filteredWidgetSelection = this.snapshotWidgetData.snapshotType.filter(
      (item: any) => {
        //for Multiple Brands if else condition will come based on snapshotType
        return (
          item.snapshotType_name == this.selectedType &&
          item.section.filter(
            (s: any) =>
              s.section_name != 'NA' &&
              s.subsection.filter((ss: any) => ss.subsection_name != 'NA')
          )
        );
      }
    );

    this.moduleList = [];
    this.filteredWidgetSelection[0].section.forEach((element: any) => {
      this.moduleList.push({ name: element.section_name, isSelected: false });
    });
    this.moduleList[0].isSelected = true;

    //Subsection
    let selectedSection = this.moduleList.filter(
      (item: any) => item.isSelected == true
    )[0].name;
    let subSections = this.filteredWidgetSelection[0].section.filter(
      (item: any) => item.section_name == selectedSection
    )[0].subsection;
    subSections.forEach((element: any) => {
      this.subSectionNames.push({
        name: element.subsection_name,
        isSelected: false,
      });
    });
    this.subSectionNames[0].isSelected = true;

    //To get pagedetails for selected section and subsection
    this.pageDetailsForSectionSubsection();
  }
  pageDetailsForSectionSubsection() {
    let selectedSectionData = this.moduleList.find(
      (item: any) => item.isSelected
    );
    let selectedSectionName = selectedSectionData
      ? selectedSectionData.name
      : null;
    if (this._configService.selectedSection) {
      selectedSectionName = this._configService.selectedSection;
    }
    let selectedSubsectionData = this.subSectionNames.find(
      (item: any) => item.isSelected
    );
    let selectedSubsectionName = selectedSubsectionData
      ? selectedSubsectionData.name
      : null;
    if (this._configService.selectedSubSection) {
      selectedSubsectionName = this._configService.selectedSubSection;
    }
    let x = this.filteredWidgetSelection[0];
    let pageDetails = [];
    let widgetDetails = [];

    for (let i = 0; i < x.section.length; i++) {
      if (x.section[i].section_name == selectedSectionName) {
        for (let j = 0; j < x.section[i].subsection.length; j++) {
          if (
            x.section[i].subsection[j].subsection_name == selectedSubsectionName
          ) {
            pageDetails = x.section[i].subsection[j].page_details;
            widgetDetails = x.section[i].subsection[j].widget_detail;
          }
        }
      }
    }

    // this.output_details = {
    //   pageData: pageDetails,
    //   widgetData: widgetDetails
    // };
    this.pageData = pageDetails;
    this.widgetData = widgetDetails;
  }

  afterSubmit() {
    //this.outputData = this._configCustomService.SampleOutputArray; // change later

    this.outputData = this._configService.standardSnapOutputData;
    if (
      this._configService.selectedcompareacrossOption == 'Multiple Brands' ||
      this._configService.selectedcompareacrossOption == 'Multiple Markets'
    ) {
      this._configService.standardSnapOutputData.sort((a: any, b: any) => {
        const sortIdA =
          this._configService.brandSortId.find(
            (item: any) => item.name === a.colChild.split('|')[1]
          )?.sortId ?? Infinity;
        const sortIdB =
          this._configService.brandSortId.find(
            (item: any) => item.name === b.colChild.split('|')[1]
          )?.sortId ?? Infinity;
        return sortIdA - sortIdB;
      });
    }

    // Adding this code to remove duplicates
    this.outputData = Array.from(
      new Set(
        this.outputData
          .map((item: any) => {
            try {
              return JSON.stringify(item);
            } catch (err) {
              console.error('Error stringifying item:', item, err);
              return null; // Return a placeholder for problematic items
            }
          })
          .filter((item: any) => item !== null) // Remove null placeholders
      )
    )
      .map((item: any) => {
        try {
          return JSON.parse(item);
        } catch (err) {
          console.error('Error parsing item:', item, err);
          return null; // Handle any parsing errors
        }
      })
      .filter((item) => item !== null); // Remove null placeholders again
    let arr: any[] = [];
    let arrWithoutTrend: any[] = [];
    let metricsAvailable: any[] = [];
    // this.items = this.output_details.widgetData;
    // if(this.widgetData.length>0){
    //   this.widgetData.forEach((w:any)=>{
    //     if(w.metric.length>0){
    //       w.metric.forEach((m:any)=>{
    //         m.metric_value=JSON.parse(m.metric_value[0]);
    //       })
    //     }
    //   })
    // }
    this.items = _.cloneDeep(this.widgetData);

    if (this._configService.selectedcompareacrossOption.includes('Multiple')) {
      if (this.items) {
        this.items.forEach((item: any) => {
          item.metric.forEach((itemLev1: any) => {
            let metricsAvailable = JSON.parse(itemLev1.metric_value[0] || '[]');

            if (!Array.isArray(metricsAvailable)) {
              metricsAvailable = [];
            }
            if (itemLev1.metric_group == '' && metricsAvailable.length > 0) {
              let allMetricsNull = true;

              let metrics = metricsAvailable.map(
                (metric: any) => metric.option
              );

              let result = this.checkMetrics(metrics);

              metricsAvailable.forEach((metric: any) => {
                let outputRow: any[] = [];
                this.outputData.forEach((row: any) => {
                  if (row.rowChild == metric.option) {
                    //&& item.widget_name == row.widgetName
                    outputRow.push(row);
                    return true;
                  }
                  return false;
                });
                //const outputRow = _.cloneDeep(this.outputData.find((row: any) => row.rowChild == metric.metricName && row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName));
                // console.log(outputRow)
                if (
                  this._configService.selectedcompareacrossOption ==
                  'Multiple Brands'
                ) {
                  outputRow.sort((a: any, b: any) => {
                    const sortIdA =
                      this._configService.brandSortId.find(
                        (item: any) => item.name === a.colChild.split('|')[1]
                      )?.sortId ?? Infinity;
                    const sortIdB =
                      this._configService.brandSortId.find(
                        (item: any) => item.name === b.colChild.split('|')[1]
                      )?.sortId ?? Infinity;
                    return sortIdA - sortIdB;
                  });
                }

                metric.option = this.handlemetricname(metric.option, result);
                // console.log(outputRow.answerWeightedShare); // console.log(outputRow.totalWeightedShare);
                // console.log(this.baseSelected);
                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({
                    // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                    data: this._configService.weightToggle(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    // data: row.totalWeightedShare,
                    data2: this._configService.weightToggleIndex(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    lvl1Child: row.Level1ColChild,
                    colChild: row.colChild,
                    rowChild: row.rowChild,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
                    totalWeightedBase: row.totalWeightedBase,
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: row.answerWeightedBase,
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.totalUnweightedBase
                        : row.answerUnweightedBase,
                    // baseValueforLSorIs: row.totalUnweightedBase,
                    changeVsPY:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.changeVsPY_Total
                        : row.changeVsPY_Answer,
                    // changeVsPY: row.changeVsPY_Total,
                    Significance_Value:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.Significance_Total
                        : row.Significance_Answer,

                    // Significance_Value: row.Significance_Total
                  });

                  if (row.totalWeightedShare !== null) {
                    allMetricsNull = false;
                  }
                });

                metric.data = this.sortTrendTimeporiodData(metric.data);
                // if (metric.data !== null) {
                //   allMetricsNull = false;
                // }

                // if (metric.data !== null) {
                //   allMetricsNull = false;
                // }
              });
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              } else {
                item.noDataAvailble = false;
              }
            } else if (
              itemLev1.metric_group != '' &&
              metricsAvailable.length == 0
            ) {
              let allMetricsNull = true;
              // let x: any[] = [];
              // x = [...this.outputData, ...this.outputData];
              const metrics = this.outputData.filter(
                (row: any) => item.widget_name == row.widgetName
              );

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              let result = Object.keys(groupedByRowChild).map((key) => ({
                name: key,
                value: groupedByRowChild[key],
              }));
              let maxmetriclimit = JSON.parse(
                item?.customizationProperties
              )?.maxMetricLimit;
              if (maxmetriclimit != undefined) {
                result = result.slice(0, maxmetriclimit);
              }

              console.log(result);
              console.log(groupedByRowChild);
              //;

              if (result.length > 0) {
                result.forEach((metric: any, index: number) => {
                  metricsAvailable.push({
                    is_brandanalysis: 0,
                    metricName: this.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: [],
                  });

                  metric.value.forEach((row: any) => {
                    metricsAvailable[index].data.push({
                      // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                      data: this._configService.weightToggle(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      // data: row.totalWeightedShare,
                      data2: this._configService.weightToggleIndex(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
                      totalWeightedBase: row.totalWeightedBase,
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: row.answerWeightedBase,
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.totalUnweightedBase
                          : row.answerUnweightedBase,
                      // baseValueforLSorIs: row.totalUnweightedBase,
                      changeVsPY:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.changeVsPY_Total
                          : row.changeVsPY_Answer,
                      // changeVsPY: row.changeVsPY_Total,
                      Significance_Value:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.Significance_Total
                          : row.Significance_Answer,

                      // Significance_Value: row.Significance_Total
                    });

                    metricsAvailable[index].data = this.sortTrendTimeporiodData(
                      metricsAvailable[index].data
                    );

                    // if (this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare != null : row.totalWeightedShare !== null) {
                    //   allMetricsNull = false;
                    // }
                    if (row.totalWeightedShare !== null) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                } else {
                  item.noDataAvailble = false;
                }
              }
            }
            itemLev1.metric_value = metricsAvailable;
          });
          if (
            item.noDataAvailble != null &&
            item.noDataAvailble != undefined &&
            item.noDataAvailble == false
          ) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (
              item.noDataAvailble == null ||
              item.noDataAvailble == undefined
            ) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }
        });
      }
      arr.push(this.items);
      //To trigger ngOnchnages of widget-output component
      // this.output_details = {
      //   ...this.output_details,
      //   widgetData: arr
      // };
      // this.output_details = {
      //   pageData: this.pageData,
      //   widgetData: this.items
      // };

      //Trend Data Code:
      this.itemWithoutTrendItems = _.cloneDeep(this.widgetData);
      let brands: string[] = _.uniq(
        this.outputData.map((metric: any) => metric.colChild)
      );
      if (this.itemWithoutTrendItems) {
        this.itemWithoutTrendItems.forEach((item: any) => {
          // console.log(item);
          item.metric.forEach((itemLev1: any) => {
            // console.log(itemLev1)
            let metricsAvailable = JSON.parse(itemLev1.metric_value[0] || '[]');

            if (!Array.isArray(metricsAvailable)) {
              metricsAvailable = [];
            }
            if (itemLev1.metric_group == '' && metricsAvailable.length > 0) {
              let allMetricsNull = true;
              // let x:any[]=[]
              // x=[...this.outputData,...this.outputData];
              let metrics = metricsAvailable.map(
                (metric: any) => metric.option
              );

              let result = this.checkMetrics(metrics);
              let resultBrands = this.checkBrands(brands);

              metricsAvailable.forEach((metric: any) => {
                let outputRow: any[] = [];
                // this.outputData.forEach((row: any) => {
                //   // if (row.rowChild == metric.option && item.widget_name == row.widgetName && row.Level1ColChild == this._configService.selectedTPforNonTrendView) {
                //   //   outputRow.push(row);
                //   // }
                //   if (row.rowChild == metric.option && item.widget_name == row.widgetName && row.Level1ColChild == "Month|Jun_2023") {
                //     outputRow.push(row);
                //   }
                // })
                //const outputRow = _.cloneDeep(this.outputData.find((row: any) => row.rowChild == metric.metricName && row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName));
                // console.log(outputRow)

                // this.outputData.forEach((row: any) => {
                //   if (row.rowChild == metric.option ) {  //&& item.widget_name == row.widgetName
                //     outputRow.push(row);
                //     return true; //removr this later
                //   }
                //   return false; //removr this later
                // })

                for (const row of this.outputData) {
                  if (
                    row.rowChild === metric.option &&
                    item.widget_name === row.widgetName &&
                    this._configService.selectedTPforNonTrendView ==
                    row.Level1ColChild
                  ) {
                    // && item.widget_name === row.widgetName
                    outputRow.push(row);
                    // break;  // Breaks out of the loop once the condition is met
                  }
                }

                if (
                  this._configService.selectedcompareacrossOption ==
                  'Multiple Brands'
                ) {
                  outputRow.sort((a: any, b: any) => {
                    const sortIdA =
                      this._configService.brandSortId.find(
                        (item: any) => item.name === a.colChild.split('|')[1]
                      )?.sortId ?? Infinity;
                    const sortIdB =
                      this._configService.brandSortId.find(
                        (item: any) => item.name === b.colChild.split('|')[1]
                      )?.sortId ?? Infinity;
                    return sortIdA - sortIdB;
                  });
                }

                metric.option = this.handlemetricname(metric.option, result);
                // console.log(outputRow.answerWeightedShare); // console.log(outputRow.totalWeightedShare);
                // console.log(this.baseSelected);
                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({
                    // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                    data: this._configService.weightToggle(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    // data: row.totalWeightedShare,
                    data2: this._configService.weightToggleIndex(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    lvl1Child: row.Level1ColChild,
                    colChild: this.handleBrandName(row.colChild, resultBrands),
                    rowChild: row.rowChild,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
                    totalWeightedBase: row.totalWeightedBase,
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: row.answerWeightedBase,
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.totalUnweightedBase
                        : row.answerUnweightedBase,
                    // baseValueforLSorIs: row.totalUnweightedBase,
                    changeVsPY:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.changeVsPY_Total
                        : row.changeVsPY_Answer,
                    // changeVsPY: row.changeVsPY_Total,
                    Significance_Value:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.Significance_Total
                        : row.Significance_Answer,

                    // Significance_Value: row.Significance_Total
                  });

                  // if (this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare != null : row.totalWeightedShare !== null) {
                  //   allMetricsNull = false;
                  // }
                  if (row.totalWeightedShare !== null) {
                    allMetricsNull = false;
                  }
                });
              });
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              } else {
                item.noDataAvailble = false;
              }
            } else if (
              itemLev1.metric_group != '' &&
              metricsAvailable.length == 0
            ) {
              let allMetricsNull = true;
              // let x: any[] = [];
              // x = [...this.outputData, ...this.outputData];
              const metrics = this.outputData.filter(
                (row: any) =>
                  item.widget_name == row.widgetName &&
                  this._configService.selectedTPforNonTrendView ==
                  row.Level1ColChild
              );

              // const metrics = this.outputData.filter((row: any) => item.widgetName == row.widget_name && row.Level1ColChild == this._configService.selectedTPforNonTrendView);

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              const result = Object.keys(groupedByRowChild).map((key) => ({
                name: key,
                value: groupedByRowChild[key],
              }));

              console.log(result);
              console.log(groupedByRowChild);
              //;

              if (result.slice(0, 6).length > 0) {
                result.slice(0, 6).forEach((metric: any, index: number) => {
                  metricsAvailable.push({
                    is_brandanalysis: 0,
                    option: this.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: [],
                  });

                  metric.value.forEach((row: any) => {
                    metricsAvailable[index].data.push({
                      // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                      data: this._configService.weightToggle(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      // data: row.totalWeightedShare,
                      data2: this._configService.weightToggleIndex(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
                      totalWeightedBase: row.totalWeightedBase,
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: row.answerWeightedBase,
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.totalUnweightedBase
                          : row.answerUnweightedBase,
                      // baseValueforLSorIs: row.totalUnweightedBase,
                      changeVsPY:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.changeVsPY_Total
                          : row.changeVsPY_Answer,
                      // changeVsPY: row.changeVsPY_Total,
                      Significance_Value:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.Significance_Total
                          : row.Significance_Answer,

                      // Significance_Value: row.Significance_Total
                    });

                    // if (this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare != null : row.totalWeightedShare !== null) {
                    //   allMetricsNull = false;
                    // }
                    if (row.totalWeightedShare !== null) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                } else {
                  item.noDataAvailble = false;
                }
              }
            }

            itemLev1.metric_value = metricsAvailable;
          });
          if (
            item.noDataAvailble != null &&
            item.noDataAvailble != undefined &&
            item.noDataAvailble == false
          ) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (
              item.noDataAvailble == null ||
              item.noDataAvailble == undefined
            ) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }
        });
      }
      arrWithoutTrend.push(this.itemWithoutTrendItems);
    } else {
      if (this.items) {
        this.items.forEach((item: any) => {
          // console.log(item);
          item.metric.forEach((itemLev1: any) => {
            // console.log(itemLev1)
            let metricsAvailable = JSON.parse(itemLev1.metric_value[0] || '[]');

            if (!Array.isArray(metricsAvailable)) {
              metricsAvailable = [];
            }
            if (itemLev1.metric_group == '' && metricsAvailable.length > 0) {
              let allMetricsNull = true;
              // let x:any[]=[]
              // x=[...this.outputData,...this.outputData];

              let metrics = metricsAvailable.map(
                (metric: any) => metric.option
              );

              let result = this.checkMetrics(metrics);

              metricsAvailable.forEach((metric: any) => {
                let outputRow: any[] = [];
                this.outputData.forEach((row: any) => {
                  if (row.rowChild == metric.option) {
                    //&& item.widget_name == row.widgetName
                    outputRow.push(row);
                    return true;
                  }
                  return false;
                });
                //const outputRow = _.cloneDeep(this.outputData.find((row: any) => row.rowChild == metric.metricName && row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName));
                // console.log(outputRow)

                metric.option = this.handlemetricname(metric.option, result);
                // console.log(outputRow.answerWeightedShare); // console.log(outputRow.totalWeightedShare);
                // console.log(this.baseSelected);
                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({
                    // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                    data: this._configService.weightToggle(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    // data: row.totalWeightedShare,
                    data2: this._configService.weightToggleIndex(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    lvl1Child: row.Level1ColChild,
                    colChild: row.colChild,
                    rowChild: row.rowChild,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
                    totalWeightedBase: row.totalWeightedBase,
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: row.answerWeightedBase,
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.totalUnweightedBase
                        : row.answerUnweightedBase,
                    // baseValueforLSorIs: row.totalUnweightedBase,
                    changeVsPY:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.changeVsPY_Total
                        : row.changeVsPY_Answer,
                    // changeVsPY: row.changeVsPY_Total,
                    Significance_Value:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.Significance_Total
                        : row.Significance_Answer,

                    // Significance_Value: row.Significance_Total
                  });

                  if (row.totalWeightedShare !== null) {
                    allMetricsNull = false;
                  }
                });

                metric.data = this.sortTrendTimeporiodData(metric.data);
                // if (metric.data !== null) {
                //   allMetricsNull = false;
                // }

                // if (metric.data !== null) {
                //   allMetricsNull = false;
                // }
              });
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              } else {
                item.noDataAvailble = false;
              }
            } else if (
              itemLev1.metric_group != '' &&
              metricsAvailable.length == 0
            ) {
              let allMetricsNull = true;
              // let x: any[] = [];
              // x = [...this.outputData, ...this.outputData];
              const metrics = this.outputData.filter(
                (row: any) => item.widget_name == row.widgetName
              );

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              const result = Object.keys(groupedByRowChild).map((key) => ({
                name: key,
                value: groupedByRowChild[key],
              }));

              console.log(result);
              console.log(groupedByRowChild);
              //;

              if (result.length > 0) {
                result.forEach((metric: any, index: number) => {
                  metricsAvailable.push({
                    is_brandanalysis: 0,
                    metricName: this.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: [],
                  });

                  metric.value.forEach((row: any) => {
                    metricsAvailable[index].data.push({
                      // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                      data: this._configService.weightToggle(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      // data: row.totalWeightedShare,
                      data2: this._configService.weightToggleIndex(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
                      totalWeightedBase: row.totalWeightedBase,
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: row.answerWeightedBase,
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.totalUnweightedBase
                          : row.answerUnweightedBase,
                      // baseValueforLSorIs: row.totalUnweightedBase,
                      changeVsPY:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.changeVsPY_Total
                          : row.changeVsPY_Answer,
                      // changeVsPY: row.changeVsPY_Total,
                      Significance_Value:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.Significance_Total
                          : row.Significance_Answer,

                      // Significance_Value: row.Significance_Total
                    });

                    metricsAvailable[index].data = this.sortTrendTimeporiodData(
                      metricsAvailable[index].data
                    );

                    // if (this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare != null : row.totalWeightedShare !== null) {
                    //   allMetricsNull = false;
                    // }
                    if (row.totalWeightedShare !== null) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                } else {
                  item.noDataAvailble = false;
                }
              }
            }
            itemLev1.metric_value = metricsAvailable;
          });
          if (
            item.noDataAvailble != null &&
            item.noDataAvailble != undefined &&
            item.noDataAvailble == false
          ) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (
              item.noDataAvailble == null ||
              item.noDataAvailble == undefined
            ) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }
        });
      }
      arr.push(this.items);
      //To trigger ngOnchnages of widget-output component
      // this.output_details = {
      //   ...this.output_details,
      //   widgetData: arr
      // };
      // this.output_details = {
      //   pageData: this.pageData,
      //   widgetData: this.items
      // };

      //Trend Data Code:
      this.itemWithoutTrendItems = _.cloneDeep(this.widgetData);
      if (this.itemWithoutTrendItems) {
        this.itemWithoutTrendItems.forEach((item: any) => {
          // console.log(item);
          item.metric.forEach((itemLev1: any) => {
            // console.log(itemLev1)
            let metricsAvailable = JSON.parse(itemLev1.metric_value[0] || '[]');

            if (!Array.isArray(metricsAvailable)) {
              metricsAvailable = [];
            }
            if (itemLev1.metric_group == '' && metricsAvailable.length > 0) {
              let allMetricsNull = true;
              // let x:any[]=[]
              // x=[...this.outputData,...this.outputData];
              let metrics = metricsAvailable.map(
                (metric: any) => metric.option
              );
              let result = this.checkMetrics(metrics);

              metricsAvailable.forEach((metric: any) => {
                let outputRow: any[] = [];
                // this.outputData.forEach((row: any) => {
                //   // if (row.rowChild == metric.option && item.widget_name == row.widgetName && row.Level1ColChild == this._configService.selectedTPforNonTrendView) {
                //   //   outputRow.push(row);
                //   // }
                //   if (row.rowChild == metric.option && item.widget_name == row.widgetName && row.Level1ColChild == "Month|Jun_2023") {
                //     outputRow.push(row);
                //   }
                // })
                //const outputRow = _.cloneDeep(this.outputData.find((row: any) => row.rowChild == metric.metricName && row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName));
                // console.log(outputRow)

                // this.outputData.forEach((row: any) => {
                //   if (row.rowChild == metric.option ) {  //&& item.widget_name == row.widgetName
                //     outputRow.push(row);
                //     return true; //removr this later
                //   }
                //   return false; //removr this later
                // })

                for (const row of this.outputData) {
                  if (
                    row.rowChild === metric.option &&
                    item.widget_name === row.widgetName &&
                    this._configService.selectedTPforNonTrendView ==
                    row.Level1ColChild
                  ) {
                    // && item.widget_name === row.widgetName
                    outputRow.push(row);
                    // break;  // Breaks out of the loop once the condition is met
                  }
                }

                metric.option = this.handlemetricname(metric.option, result);
                // console.log(outputRow.answerWeightedShare); // console.log(outputRow.totalWeightedShare);
                // console.log(this.baseSelected);
                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({
                    // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                    data: this._configService.weightToggle(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    // data: row.totalWeightedShare,
                    data2: this._configService.weightToggleIndex(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    lvl1Child: row.Level1ColChild,
                    colChild: row.colChild,
                    rowChild: row.rowChild,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
                    totalWeightedBase: row.totalWeightedBase,
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: row.answerWeightedBase,
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.totalUnweightedBase
                        : row.answerUnweightedBase,
                    // baseValueforLSorIs: row.totalUnweightedBase,
                    changeVsPY:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.changeVsPY_Total
                        : row.changeVsPY_Answer,
                    // changeVsPY: row.changeVsPY_Total,
                    Significance_Value:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.Significance_Total
                        : row.Significance_Answer,

                    // Significance_Value: row.Significance_Total
                  });

                  // if (this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare != null : row.totalWeightedShare !== null) {
                  //   allMetricsNull = false;
                  // }
                  if (row.totalWeightedShare !== null) {
                    allMetricsNull = false;
                  }
                });
              });
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              } else {
                item.noDataAvailble = false;
              }
            } else if (
              itemLev1.metric_group != '' &&
              metricsAvailable.length == 0
            ) {
              let allMetricsNull = true;
              // let x: any[] = [];
              // x = [...this.outputData, ...this.outputData];
              const metrics = this.outputData.filter(
                (row: any) =>
                  item.widget_name == row.widgetName &&
                  this._configService.selectedTPforNonTrendView ==
                  row.Level1ColChild
              );

              // const metrics = this.outputData.filter((row: any) => item.widgetName == row.widget_name && row.Level1ColChild == this._configService.selectedTPforNonTrendView);

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              let result = Object.keys(groupedByRowChild).map((key) => ({
                name: key,
                value: groupedByRowChild[key],
              }));

              console.log(result);
              console.log(groupedByRowChild);
              //;
              let maxmetriclimit = JSON.parse(
                item?.customizationProperties
              )?.maxMetricLimit;
              if (maxmetriclimit != undefined) {
                result = result.slice(0, maxmetriclimit);
              }

              if (result.length > 0) {
                result.forEach((metric: any, index: number) => {
                  metricsAvailable.push({
                    is_brandanalysis: 0,
                    option: this.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: [],
                  });

                  metric.value.forEach((row: any) => {
                    metricsAvailable[index].data.push({
                      // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                      data: this._configService.weightToggle(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      // data: row.totalWeightedShare,
                      data2: this._configService.weightToggleIndex(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
                      totalWeightedBase: row.totalWeightedBase,
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: row.answerWeightedBase,
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.totalUnweightedBase
                          : row.answerUnweightedBase,
                      // baseValueforLSorIs: row.totalUnweightedBase,
                      changeVsPY:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.changeVsPY_Total
                          : row.changeVsPY_Answer,
                      // changeVsPY: row.changeVsPY_Total,
                      Significance_Value:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.Significance_Total
                          : row.Significance_Answer,

                      // Significance_Value: row.Significance_Total
                    });

                    // if (this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare != null : row.totalWeightedShare !== null) {
                    //   allMetricsNull = false;
                    // }
                    if (row.totalWeightedShare !== null) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                } else {
                  item.noDataAvailble = false;
                }
              }
            }

            itemLev1.metric_value = metricsAvailable;
          });
          if (
            item.noDataAvailble != null &&
            item.noDataAvailble != undefined &&
            item.noDataAvailble == false
          ) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (
              item.noDataAvailble == null ||
              item.noDataAvailble == undefined
            ) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }
        });
      }
      arrWithoutTrend.push(this.itemWithoutTrendItems);
    }
    this._configService.allPageOutputData = arr;
    this._configService.allPageOutputDataWithoutTrend = arrWithoutTrend;
    this.output_details = {
      pageData: this.pageData,
      widgetData: this.itemWithoutTrendItems,
    };
    console.log('customoutputview', this.output_details);
    //storing converted output to a service variable
    this._configService.allPageOutputData = arr;
    this._configService.allPageOutputDataWithoutTrend = arrWithoutTrend;
    //       this._configService.showWidget1Page = false;
    //       this._configService.showWidget2Page = false;
    //       this._configService.allPageOutputDataWithoutTrend.forEach((item:any) => {

    //             this._configService.showWidget1Page = item.pagewidgetdetails.filter((item1:any) => item1.widgetNotConfigured === false).length>0;

    //           this._configService.showWidget2Page = item.pagewidgetdetails.filter((item1:any) => item1.widgetNotConfigured === false).length>0;

    //       })
    // if(!this._configService.showWidget2Page){
    //         this._configService.page2ToggleSubject.next(1);
    //         this.paginationCounterFun(1);
    //         //this.page2Toggle = 1;
    //       }
    //       else if(!this._configService.showWidget1Page){
    //         this._configService.page2ToggleSubject.next(2);
    //         this.paginationCounterFun(2);
    //         //this.page2Toggle = 2;
    //       }
    //console.log("Page COUNTER:", this.pageCounter);
    console.log(this._configService.allPageOutputData);
    console.log(this._configService.allPageOutputDataWithoutTrend);

    console.log('withTrend', arr);
    this._configService.itemWithTrendData = arr;

    this.selectedWidgetName = 'Awareness'; // letr make it this.snapshotDataModel.selectedWidgetName when passed from Python
    this.selectedWidgetID = this.promptData.Widget_ID; // letr make it this.snapshotDataModel.selectedWidgetID when passed from Python
    // this.selectedWidgetID = 1;

    this.filteredWidgetData = this.output_details.widgetData.filter(
      (widget: any) => widget.previewChartPostion == this.selectedWidgetID
    )[0];
    //debugger;
    console.log(this.filteredWidgetData);
    this.filteredWidgetID = this.filteredWidgetData.previewChartPostion;
    //debugger;
    setTimeout(() => this.showSnapshot = true, 5);

    //this.showSnapshot = true;
    //this.showChart=true;
  }

  // refreshSnapshot() {
  //   this.showSnapshot = false;
  //   setTimeout(() => {
  //     this.showSnapshot = true;
  //   });
  // }



  checkBrands(metrics: string[]): number {
    let hasDelimiter = metrics.some((metric) => metric.includes('|'));
    if (!hasDelimiter) return 0;

    let firstParts = metrics.map((metric) => metric.split('|')[0]);
    let uniqueFirstParts = Array.from(new Set(firstParts));

    if (uniqueFirstParts.length === 1) {
      return 1;
    } else if (
      uniqueFirstParts.every((part) => part[0] === uniqueFirstParts[0][0])
    ) {
      return 2;
    } else {
      return 3;
    }
  }

  checkMetrics(metrics: string[]): number {
    let hasDelimiter = metrics.some((metric) => metric.includes('|'));
    if (!hasDelimiter) return 0;

    let firstParts = metrics.map((metric) => metric.split('|')[0]);
    let uniqueFirstParts = Array.from(new Set(firstParts));

    if (uniqueFirstParts.length === 1) {
      return 1;
    } else if (
      uniqueFirstParts.every((part) => part[0] === uniqueFirstParts[0][0])
    ) {
      return 2;
    } else {
      return 3;
    }
  }
  handlemetricname(metricName: any, type: number = 0) {
    if (type == 0) return metricName; // No delimiter
    else if (type == 1) {
      const parts = metricName.split('|'); // for showing only the last part (without delimiter)
      return parts[1];
    }

    const parts = metricName.split('|');

    if (parts.length <= 2) {
      return metricName;
    }

    return parts.slice(-2).join('|').trim();
  }

  handleBrandName(metricName: any, type: number = 0) {
    if (type == 0) return metricName; // No delimiter
    else if (type == 1) {
      const parts = metricName.split('|'); // for showing only the last part (without delimiter)
      return parts[1];
    }

    const parts = metricName.split('|');

    if (parts.length <= 2) {
      return metricName;
    }

    return parts.slice(-2).join('|').trim();
  }

  sortTrendTimeporiodData(metricData: any[]): any[] {
    // Filter leftPanelData for "Time Period" and sort by level1_sort_id
    let filteredLeftPanelData = this._configService.leftPanelData?.filter(
      (item: any) =>
        item.Level0 === 'Time Period' || item.Level1 === 'Time Period'
    );
    filteredLeftPanelData?.sort((a: any, b: any) => {
      return a.level1_sort_id - b.level1_sort_id;
    });

    // Sort metricData based on the order of MetricOption in filteredLeftPanelData
    metricData?.sort((a: any, b: any) => {
      const indexA = filteredLeftPanelData?.findIndex(
        (item: any) => item.MetricOption === a.lvl1Child.split('|')[1]
      );
      const indexB = filteredLeftPanelData?.findIndex(
        (item: any) => item.MetricOption === b.lvl1Child.split('|')[1]
      );
      return indexA - indexB;
    });
    metricData?.sort((a: any, b: any) => {
      const [monthA, yearA] = a.lvl1Child?.split('|')[1].split('_');
      const [monthB, yearB] = b.lvl1Child?.split('|')[1].split('_');

      const dateA: any = new Date(yearA, this.getMonthNumber(monthA) - 1);
      const dateB: any = new Date(yearB, this.getMonthNumber(monthB) - 1);

      return dateA - dateB;
    });

    return metricData;
  }

  getMonthNumber(monthAbbr: any) {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    return months.indexOf(monthAbbr) + 1;
  }


  getsnapShotOutputData(type: string, isBaseType: string, isChatResponse = false, getSnapshotInsights?: any, getSnapshotOutput?: any) {
    this.showSnapshot = !this.showSnapshot;
    //debugger;
    if (isBaseType == '') {
      this.Snapshotdataforexport.confidenceLevel = this.passOutputData.DefaultConfidenceLevel;
      this.Snapshotdataforexport.baseType = this.passOutputData.isTotalBase === true ? "Total Base" : "Answer Base";

      (getSnapshotOutput && isChatResponse ? of(getSnapshotOutput) :
        this._configService
          .getOutPutData(
            this.snapshotDataModel,
            this.selected_client,
            this.selected_study,
            this.passOutputData.significance,
            this.passOutputData.isFilteringActive,
            this.passOutputData.DefaultConfidenceLevel,
            this.passOutputData.isTotalBase,
            this.snapshotDataModel.SelectedWeight,
            this.passOutputData.weightColumnName,
            this.passOutputData.isBoostFactor,
            this.passOutputData.SignificanceVsReference,
            this.passOutputData.columnLength,
            this.dataArray,
            // this.snapshotDataModel.entryPointData,
            this.passOutputData.isBrandAnalysis,
            this.passOutputData.isAggregatedData,
            this.passOutputData.isSemiAggregatedData,
            this.passOutputData.isRespondentLevel,
            // this.aggregatedVariables,
            this.snapshotDataModel.aggregatedVariables,

            this.passOutputData.istimePeriodWave,
            this.passOutputData.widegtconfigdetails,
            this.passOutputData.indexVsBrandReference,
            this.passOutputData.significanceVsBrandReference,
            // this._configService.checkTrendEnabled(this.snapshotWidgetData)
            false,
            this.pageData,
            this.widgetData
          ))
        .subscribe((result) => {
          console.log("The Result Data" + result);
          if (!isChatResponse)
            this.pushChatResponseEntry('getSnapshotOutput', result);
          //debugger;
          if (
            result.Data != null &&
            result.Data != undefined &&
            result.Data != ''
          ) {
            let opData = JSON.parse(result.Data);
            this.MainResult = opData;
            const sortedOPdata = opData.sort(
              (a: any, b: any) => a.widgetNumber - b.widgetNumber
            );
            if (type == 'reference') {
              let dataForRef = _.cloneDeep(
                sortedOPdata.filter((item: any) =>
                  this.passOutputData.LeftPanelSelectedTimePeriod.some(
                    (period: any) => item.Level1ColChild.includes(period)
                  )
                )
              );
              let selectedSig =
                this.passOutputData.significanceVsBrandReference.length > 0;
              this.referenceCalculation(sortedOPdata, selectedSig);
              // if (typeof window !== undefined) {
              //   (window as any)["jsonObjectForIndex"] = sortedOPdata;
              // }
            }
            //this._configService.standardSnapOutputData = sortedOPdata;
            //this.outputData = sortedOPdata;
            //console.log(this._configService.standardSnapOutputData);

            // const outputViewDiv = document.querySelector('.output-view');
            // if (outputViewDiv) {
            //   outputViewDiv?.classList.remove('DN');
            //   this.showOutput.emit();
            // }
            else if (type == 'sig') {
              let dataForRef = _.cloneDeep(
                sortedOPdata.filter((item: any) =>
                  this.passOutputData.LeftPanelSelectedTimePeriod.some(
                    (period: any) => item.Level1ColChild.includes(period)
                  )
                )
              );
              this._configService.standardSnapOutputData = sortedOPdata;
              if (typeof window !== undefined) {
                (window as any)['jsonobject'] = sortedOPdata;
              }
              this.afterSubmit();
            } else if (type == 'significance') {
              let dataForRef = _.cloneDeep(
                sortedOPdata.filter((item: any) =>
                  this.passOutputData.LeftPanelSelectedTimePeriod.some(
                    (period: any) => item.Level1ColChild.includes(period)
                  )
                )
              );
              this._configService.standardSnapOutputData = sortedOPdata;
              if (typeof window !== undefined) {
                (window as any)['jsonobject'] = sortedOPdata;
              }
              this.afterSubmit();
            } else if (type == 'weight') {
              this._configService.standardSnapOutputData = sortedOPdata;
              if (typeof window !== undefined) {
                (window as any)['jsonobject'] = sortedOPdata;
              }
              this.afterSubmit();
            }
            // this._loaderService.hideLoader();

            this.arktabaccess = false;
          } else {
            //No Output Data
            // this._loaderService.hideLoader();
            this.arktabaccess = false;

            console.log(result);
            //debugger;
            if (isChatResponse)
              this.OnInsigthsbuttonClick(isChatResponse, getSnapshotInsights);
            else
              this.OnInsigthsbuttonClick();
          }
          //debugger;
          console.log("Widget Id" + this.Widget_Id);
          //          if(this.Widget_Id===4)
          //          {
          //debugger;
          //         }
          if (isChatResponse)
            this.OnInsigthsbuttonClick(isChatResponse, getSnapshotInsights);
          else
            this.OnInsigthsbuttonClick();
        });
    } else {
      if (

        this.MainResult != null &&
        this.MainResult != undefined &&
        this.MainResult != ''
      ) {
        let opData = this.MainResult;
        const sortedOPdata = opData.sort(
          (a: any, b: any) => a.widgetNumber - b.widgetNumber
        );
        if (type == 'reference') {
          let dataForRef = sortedOPdata.filter((item: any) =>
            this.passOutputData.LeftPanelSelectedTimePeriod.some(
              (period: any) => item.Level1ColChild.includes(period)
            )
          );
          let selectedSig =
            this.passOutputData.significanceVsBrandReference.length > 0;
          this.referenceCalculation(sortedOPdata, selectedSig);
        }
        //this._configService.standardSnapOutputData = sortedOPdata;
        //this.outputData = sortedOPdata;
        //console.log(this._configService.standardSnapOutputData);

        // const outputViewDiv = document.querySelector('.output-view');
        // if (outputViewDiv) {
        //   outputViewDiv?.classList.remove('DN');
        //   this.showOutput.emit();
        // }
        else if (type == 'sig') {
          let dataForRef = sortedOPdata.filter((item: any) =>
            this.passOutputData.LeftPanelSelectedTimePeriod.some(
              (period: any) => item.Level1ColChild.includes(period)
            )
          );
          this._configService.standardSnapOutputData = sortedOPdata;
          this.afterSubmit();
        } else if (type == 'significance') {
          let dataForRef = sortedOPdata.filter((item: any) =>
            this.passOutputData.LeftPanelSelectedTimePeriod.some(
              (period: any) => item.Level1ColChild.includes(period)
            )
          );
          this._configService.standardSnapOutputData = sortedOPdata;
          this.afterSubmit();
        } else if (type == 'weight') {
          this._configService.standardSnapOutputData = sortedOPdata;
          this.afterSubmit();
        }
        // this._loaderService.hideLoader();
        // this.showSnapshot = !this.showSnapshot;
        this.arktabaccess = false;
      } else {
        //No Output Data
        // this._loaderService.hideLoader();
        //  this.showSnapshot = !this.showSnapshot;
        this.arktabaccess = false;
      }
    }

  }

  // getsnapShotOutputDataModified(result: any) {
  //    this.showSnapshot = !this.showSnapshot;
  //   //debugger;
  //   if (isBaseType == '') {
  //     this.Snapshotdataforexport.confidenceLevel = this.passOutputData.DefaultConfidenceLevel;
  //     this.Snapshotdataforexport.baseType = this.passOutputData.isTotalBase === true ? "Total Base" : "Answer Base";

  //     (getSnapshotOutput && isChatResponse ? of(getSnapshotOutput) : 
  //     // this._configService
  //     //   .getOutPutData(
  //     //     this.snapshotDataModel,
  //     //     this.selected_client,
  //     //     this.selected_study,
  //     //     this.passOutputData.significance,
  //     //     this.passOutputData.isFilteringActive,
  //     //     this.passOutputData.DefaultConfidenceLevel,
  //     //     this.passOutputData.isTotalBase,
  //     //     this.snapshotDataModel.SelectedWeight,
  //     //     this.passOutputData.weightColumnName,
  //     //     this.passOutputData.isBoostFactor,
  //     //     this.passOutputData.SignificanceVsReference,
  //     //     this.passOutputData.columnLength,
  //     //     this.dataArray,
  //     //     // this.snapshotDataModel.entryPointData,
  //     //     this.passOutputData.isBrandAnalysis,
  //     //     this.passOutputData.isAggregatedData,
  //     //     this.passOutputData.isSemiAggregatedData,
  //     //     this.passOutputData.isRespondentLevel,
  //     //     // this.aggregatedVariables,
  //     //     this.snapshotDataModel.aggregatedVariables,

  //     //     this.passOutputData.istimePeriodWave,
  //     //     this.passOutputData.widegtconfigdetails,
  //     //     this.passOutputData.indexVsBrandReference,
  //     //     this.passOutputData.significanceVsBrandReference,
  //     //     // this._configService.checkTrendEnabled(this.snapshotWidgetData)
  //     //     false,
  //     //     this.pageData,
  //     //     this.widgetData
  //     //   ))
  //     //   .subscribe((result) => {
  //         console.log("The Result Data" + result);
  //         if (!isChatResponse)
  //           this.pushChatResponseEntry('getSnapshotOutput', result);
  //         //debugger;
  //         if (
  //           result.Data != null &&
  //           result.Data != undefined &&
  //           result.Data != ''
  //         ) {
  //           let opData = JSON.parse(result.Data);
  //           this.MainResult = opData;
  //           const sortedOPdata = opData.sort(
  //             (a: any, b: any) => a.widgetNumber - b.widgetNumber
  //           );
  //           if (type == 'reference') {
  //             let dataForRef = _.cloneDeep(
  //               sortedOPdata.filter((item: any) =>
  //                 this.passOutputData.LeftPanelSelectedTimePeriod.some(
  //                   (period: any) => item.Level1ColChild.includes(period)
  //                 )
  //               )
  //             );
  //             let selectedSig =
  //               this.passOutputData.significanceVsBrandReference.length > 0;
  //             this.referenceCalculation(sortedOPdata, selectedSig);
  //             // if (typeof window !== undefined) {
  //             //   (window as any)["jsonObjectForIndex"] = sortedOPdata;
  //             // }
  //           }
  //           //this._configService.standardSnapOutputData = sortedOPdata;
  //           //this.outputData = sortedOPdata;
  //           //console.log(this._configService.standardSnapOutputData);

  //           // const outputViewDiv = document.querySelector('.output-view');
  //           // if (outputViewDiv) {
  //           //   outputViewDiv?.classList.remove('DN');
  //           //   this.showOutput.emit();
  //           // }
  //           else if (type == 'sig') {
  //             let dataForRef = _.cloneDeep(
  //               sortedOPdata.filter((item: any) =>
  //                 this.passOutputData.LeftPanelSelectedTimePeriod.some(
  //                   (period: any) => item.Level1ColChild.includes(period)
  //                 )
  //               )
  //             );
  //             this._configService.standardSnapOutputData = sortedOPdata;
  //             if (typeof window !== undefined) {
  //               (window as any)['jsonobject'] = sortedOPdata;
  //             }
  //             this.afterSubmit();
  //           } else if (type == 'significance') {
  //             let dataForRef = _.cloneDeep(
  //               sortedOPdata.filter((item: any) =>
  //                 this.passOutputData.LeftPanelSelectedTimePeriod.some(
  //                   (period: any) => item.Level1ColChild.includes(period)
  //                 )
  //               )
  //             );
  //             this._configService.standardSnapOutputData = sortedOPdata;
  //             if (typeof window !== undefined) {
  //               (window as any)['jsonobject'] = sortedOPdata;
  //             }
  //             this.afterSubmit();
  //           } else if (type == 'weight') {
  //             this._configService.standardSnapOutputData = sortedOPdata;
  //             if (typeof window !== undefined) {
  //               (window as any)['jsonobject'] = sortedOPdata;
  //             }
  //             this.afterSubmit();
  //           }
  //           // this._loaderService.hideLoader();

  //           this.arktabaccess = false;
  //         } else {
  //           //No Output Data
  //           // this._loaderService.hideLoader();
  //           this.arktabaccess = false;

  //           console.log(result);
  //           //debugger;
  //           if (isChatResponse)
  //             this.OnInsigthsbuttonClick(isChatResponse, getSnapshotInsights);
  //           else
  //             this.OnInsigthsbuttonClick();
  //         }
  //         //debugger;
  //         console.log("Widget Id" + this.Widget_Id);
  //         //          if(this.Widget_Id===4)
  //         //          {
  //         //debugger;
  //         //         }
  //         if (isChatResponse)
  //           this.OnInsigthsbuttonClick(isChatResponse, getSnapshotInsights);
  //         else
  //           this.OnInsigthsbuttonClick();
  //       // });
  //   } else {
  //     if (

  //       this.MainResult != null &&
  //       this.MainResult != undefined &&
  //       this.MainResult != ''
  //     ) {
  //       let opData = this.MainResult;
  //       const sortedOPdata = opData.sort(
  //         (a: any, b: any) => a.widgetNumber - b.widgetNumber
  //       );
  //       if (type == 'reference') {
  //         let dataForRef = sortedOPdata.filter((item: any) =>
  //           this.passOutputData.LeftPanelSelectedTimePeriod.some(
  //             (period: any) => item.Level1ColChild.includes(period)
  //           )
  //         );
  //         let selectedSig =
  //           this.passOutputData.significanceVsBrandReference.length > 0;
  //         this.referenceCalculation(sortedOPdata, selectedSig);
  //       }
  //       //this._configService.standardSnapOutputData = sortedOPdata;
  //       //this.outputData = sortedOPdata;
  //       //console.log(this._configService.standardSnapOutputData);

  //       // const outputViewDiv = document.querySelector('.output-view');
  //       // if (outputViewDiv) {
  //       //   outputViewDiv?.classList.remove('DN');
  //       //   this.showOutput.emit();
  //       // }
  //       else if (type == 'sig') {
  //         let dataForRef = sortedOPdata.filter((item: any) =>
  //           this.passOutputData.LeftPanelSelectedTimePeriod.some(
  //             (period: any) => item.Level1ColChild.includes(period)
  //           )
  //         );
  //         this._configService.standardSnapOutputData = sortedOPdata;
  //         this.afterSubmit();
  //       } else if (type == 'significance') {
  //         let dataForRef = sortedOPdata.filter((item: any) =>
  //           this.passOutputData.LeftPanelSelectedTimePeriod.some(
  //             (period: any) => item.Level1ColChild.includes(period)
  //           )
  //         );
  //         this._configService.standardSnapOutputData = sortedOPdata;
  //         this.afterSubmit();
  //       } else if (type == 'weight') {
  //         this._configService.standardSnapOutputData = sortedOPdata;
  //         this.afterSubmit();
  //       }
  //       // this._loaderService.hideLoader();
  //       // this.showSnapshot = !this.showSnapshot;
  //       this.arktabaccess = false;
  //     } else {
  //       //No Output Data
  //       // this._loaderService.hideLoader();
  //       //  this.showSnapshot = !this.showSnapshot;
  //       this.arktabaccess = false;
  //     }
  //   }

  // }

  OnInsigthsbuttonClick(isChatResponse = false, getSnapshotInsights?: any) {
    //debugger;
    let WidgetId = this.Widget_Id;
    //debugger;
    this.arktabaccess = true;
    let data = [];
    this.InsightsResponse = [];
    let ShareColumn = (this.selectedDataFormat != 'Respondent Level' ? 'value' : (this.isTotalBase
      ? (this.selectedWeight == "Unweighted" ? 'totalUnweightedShare' : 'totalWeightedShare')
      : (this.selectedWeight == "Unweighted" ? 'answerUnweightedShare' : 'answerWeightedShare')));
    let BaseColumn = !this.isTotalBase
      ? 'totalUnweightedBase'
      : 'answerUnweightedBase';
    this.Snapshotdataforexport.selectionSummary = this.selectionSummary;
    (getSnapshotInsights && isChatResponse ? of(getSnapshotInsights) :
      this.apiService.getInsightsData(
        this.isIndexSelected,
        this.MainResult,
        this.selected_study,
        this.selected_client,
        this.selectionSummary,
        this.confidenceLevel,
        ShareColumn,
        BaseColumn,
        this._configService.getDropdownValues().compareAcross,
        "",
        "",
        WidgetId
      ))
      .subscribe((result: string) => {
        console.log(result);
        if (!isChatResponse) {
          this.pushChatResponseEntry('getSnapshotInsights', result);
          this.saveChatList(this.chatPreviewBlocks.length > 0 ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question : this.inputValue, this.chatResponse);
          this.chatResponse = [];
        }
        // Response is valid
        // this.errorPopup(result, "Insights for the Generated Ouptput data")
        // let insightsData = JSON.parse(result.Data);
        // this.InsightsData = insightsData;
        this.isInsightspopupOpen = true;
        this.showSnapshot = true;
        // const insightsObj: InsightsModel = {
        //   header: 'Insights',
        //   message: result,
        //   show: true,
        // };
        // const insightData = result
        // .split('- ')
        // .map((item) => item.trim())
        // .filter((item) => item.length > 0);
        //this.insightsVal=JSON.parse(result);

        if (!isChatResponse) {
          let parsedResult: any;

          try {
            parsedResult = JSON.parse(result);
          } catch {
            parsedResult = null;
          }

          if (parsedResult && parsedResult.success === false) {
            this.insightsVal = { "": { "Value": parsedResult.message } };
          }
          else if (result && result.trim() !== "") {
            this.insightsVal = JSON.parse(result);
          } else {
            this.insightsVal = { "": { "Value": "No Data Available" } };
          }

          let combinedInsightsText = '';
          for (const section in this.insightsVal) {
            if (this.insightsVal[section] && this.insightsVal[section].Value) {
              combinedInsightsText += this.insightsVal[section].Value + '\n';
            }
          }

          this.insightsVal = combinedInsightsText
            .split('\n')
            .map((line: string) => line.replace(/^[-•]\s*/, '').trim())
            .filter((line: string) => line.length > 0);

          console.log(this.insightsVal);
          this.arktabaccess = false; // Stop loader
        }
        else {
          let parsedResult: any;

          if (typeof result === "string") {
            try {
              parsedResult = JSON.parse(result);
            } catch (e) {
              console.error("Invalid JSON string:", e);
              parsedResult = null;
            }
          } else if (typeof result === "object") {
            parsedResult = result; // already parsed object
          } else {
            parsedResult = null;
          }

          if (parsedResult && parsedResult[""] && parsedResult[""].Value) {
            const valueText: string = parsedResult[""].Value;

            this.insightsVal = valueText
              .split('\n')
              .map((line: string) => line.replace(/^[-•]\s*/, '').trim())
              .filter((line: string) => line.length > 0);
          } else {
            this.insightsVal = ["No Data Available"];
          }

          console.log(this.insightsVal);
        }
        // Show the alert popup using the alert service
        this._insightsSerive.showInisghts(this.InsightsResponse);
        this.arktabaccess = false;
        //  this.insightsVal=JSON.parse(this.insightsVal).Value.replaceAll("\n","").replaceAll("\n\n","");
        //  this.insightsVal=this.insightsVal.split('- ')
        //   .map((item: string) => item.trim())
        //   .filter((item: string | any[]) => item.length > 0);
        //   console.log(this.insightsVal);
      });
  }



  selectedBrands: any[] = [];
  referenceBrand: string = '';
  allbrands: any;
  allSigBrands: any;
  referenceCalculation(output: any, selectedSig: boolean) {
    this.referenceBrand = '';
    this.selectedBrands = [];

    this.selectedBrands = this.passOutputData.LeftPanelSelectedBrand;
    if (selectedSig) {
      this._configService.isIndexSelected = false;
      for (let i = 0; i < this.allSigBrands.length; i++) {
        if (this.allSigBrands[i].isSelected == true) {
          this.referenceBrand = this.allSigBrands[i].MetricOption;
        }
      }
    } else {
      this._configService.isIndexSelected = true;
      for (let i = 0; i < this.allbrands.length; i++) {
        if (this.allbrands[i].isSelected == true) {
          this.referenceBrand = this.allbrands[i].MetricOption;
        }
      }
    }

    // Find the reference brand's data for each metric
    let referenceDataMap: any = {};
    let count = 0;
    output.forEach((item: any) => {
      if (item.colChild.includes(this.referenceBrand)) {
        let key = '';
        if (item.isCustomGroup || item.isCustomCalculation) {
          key = `${item.rowChild}_${item.rowChild}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
        } else {
          key = `${item.rowChild}_${item.rowVariableCode}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
        }
        count++;
        referenceDataMap[key] =
          this.baseselected.toLowerCase() !== 'total base'
            ? item.answerWeightedShare
            : item.totalWeightedShare;
      }
    });
    console.log(count);
    //adding NA to reference data for 0 or null value
    Object.keys(referenceDataMap).forEach((key) => {
      if (referenceDataMap[key] === null || referenceDataMap[key] === 0) {
        referenceDataMap[key] = 'NA';
      }
    });
    // ;

    // Create a new array with the divided data
    let newArr = output.map((item: any) => {
      // Construct the key from rowVariableCode and widgetName
      if (item.widgetName == 'Awarenesss') {
        let x = 1;
      }
      let key = '';
      if (item.isCustomGroup || item.isCustomCalculation) {
        key = `${item.rowChild}_${item.rowChild}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
      } else {
        key = `${item.rowChild}_${item.rowVariableCode}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
      }
      const referenceValue = referenceDataMap[key];

      if (referenceValue !== undefined) {
        return {
          ...item,
          // numTotal: item.totalWeightedShare,
          // deno: referenceValue,
          totalWeightedShareIndex:
            referenceValue === 'NA'
              ? null
              : this.baseselected.toLowerCase() == 'total base'
                ? (item.totalWeightedShare / referenceValue) * 100
                : item.totalWeightedShare,
          // numAnswer: item.answerWeightedShare,
          answerWeightedShareIndex:
            referenceValue === 'NA'
              ? null
              : this.baseselected.toLowerCase() == 'answer base'
                ? (item.answerWeightedShare / referenceValue) * 100
                : item.answerWeightedShare,
          CalculationTypeIndex: 'index',
        };
      }
      return item;
    });

    let updatedSelecetedBrandData = newArr.filter((item: any) =>
      this.selectedBrands.some((brand: any) => item.colChild.includes(brand))
    );
    this._configService.standardSnapOutputData = updatedSelecetedBrandData;
    this._configService.referenceData = updatedSelecetedBrandData;

    if (typeof window !== undefined) {
      (window as any)['jsonObjectForIndex'] = updatedSelecetedBrandData;
    }

    this.afterSubmit();
  }
  ConfidenceLevelDropDownToggle: boolean = false;
  BaseDropDownToggle: boolean = false;
  weightDropDownToggle: boolean = false;
  displayReference: any = 'None';
  sortToggle: boolean = true; //variable to make default sort
  isSigSelected: any = true;
  showOutput: boolean = true;
  weightSelectedValue: any = 'Total Population';
  weight: any = [];

  base = [
    { key: 'Total Base', selected: true },
    { key: 'Answer Base', selected: false },
  ];
  base2 = [{ key: 'Total Base', selected: true }];
  ImageURL: string = '';

  onBaseDropdown() {
    this.ConfidenceLevelDropDownToggle = false;
    this.weightDropDownToggle = false;
    this.BaseDropDownToggle = !this.BaseDropDownToggle;
  }
  closeBaseDropdown() {
    this.BaseDropDownToggle = false;
  }
  baseSelected(event: any) {
    // this.arktabaccess = true;
    this.sortToggle = !this.sortToggle; //reseting sorting dropdown value to default
    this._configService.setDropdownValue('baseType', event.target.textContent);
    this.passOutputData.isTotalBase = event.target.textContent != 'Answer Base';
    this.base.forEach((p: any) => {
      if (p.key == event.target.textContent) {
        p.selected = true;
        this.baseselected = p.key;
        // this.afterSubmit();
        if (this.isIndex && this.displayReference != 'None') {

          this.getsnapShotOutputData('reference', 'baseType');
          //debugger;
        } else if (this.isIndex && this.displayReference == 'None') {
          this.getsnapShotOutputData('sig', 'baseType');
          //debugger
        } else if (this.isSigSelected) {
          this.getsnapShotOutputData('sig', 'baseType');
          //debugger
        }
        //  this.showOutput = false;
        //  setTimeout(() => {
        this.showOutput = true;
        // }, 100);
      } else {
        p.selected = false;
      }
    });
    //console.log(this.base)

    // ;
    //this.dropdown.nativeElement.selectedIndex = 0;

    this.UpdateBaseSummary();
    this.BaseDropDownToggle = false;
  }
  base2Selected(event: any) {
    // this.arktabaccess = true;
    this.sortToggle = !this.sortToggle; //reseting sorting dropdown value to default

    this._configService.setDropdownValue('baseType', event.target.textContent);
    this.base2.forEach((p: any) => {
      if (p.key == event.target.textContent) {
        p.selected = true;
        this.baseselected = p.key;
        this.afterSubmit();
        if (this.isIndex) {
          this.getsnapShotOutputData('reference', 'baseType');
          //debugger
        } else if (this.isSigSelected) {
          this.getsnapShotOutputData('sig', 'baseType');
          //debugger
        }
        // this.showOutput = false;
        // setTimeout(() => {
        this.showOutput = true;
        //  }, 100);
      } else {
        p.selected = false;
      }
    });
    //this.dropdown.nativeElement.selectedIndex = 0;

    this.UpdateBaseSummary();
    this.BaseDropDownToggle = false;
  }
  onWeightDropdown() {
    this.ConfidenceLevelDropDownToggle = false;
    this.BaseDropDownToggle = false;
    this.weightDropDownToggle = !this.weightDropDownToggle;
  }

  closeWeightDropdown() {
    this.weightDropDownToggle = false;
  }
  weightSelected(event: any) {
    this.arktabaccess = true;
    let weight_variable = this.weight.find(
      (w: any) => w.key == event.target.textContent
    );
    this._configService.weightSelected =
      weight_variable.variable_code == ''
        ? 'Unweighted'
        : weight_variable.variable_code;
    this.passOutputData.selectedWeight =
      weight_variable.variable_code == ''
        ? 'Unweighted'
        : weight_variable.variable_code;
    this.weightSelectedValue = event.target.textContent;
    // this.afterSubmit();
    // this.ShowOutput();
    // this.getOutputData('sig');

    console.log(event.target.textContent);
    this.weightDropDownToggle = false;
    this.UpdateWeightSummary();
    if (this._configService.isIndexSelected) {
      this.getsnapShotOutputData('reference', '');
      //debugger;
    } else {
      this.getsnapShotOutputData('weight', '');
      //debugger;
    }
    this.showOutput = false;
    setTimeout(() => {
      this.showOutput = true;
    }, 100);
  }
  sigTypeDropdown = false;
  sigTypeSelected: any = '';
  searchQuery: string = '';
  referenceDropdownToggle: boolean = false;
  selectedReference: any;
  isIndexSelected: any; // Initially Index div is not selecte
  // isSigSelected: any; // Initially Sig div is selected
  sigConBaseToggle = true;
  selectedSignificance: any;
  // selectedReference: any;
  displaySignificance: any = 'None';
  significanceDropdownToggle: boolean = false;
  displayBrand = false;
  confidenceLevelSelectedValue = '';
  significanceSelectedValue = 'None';

  selectedSigBrand: any;
  vsBrandArray: any[] = [];
  displayConfidenceLevel: string = '';
  additionalList: any;
  selectedSigType: any[] = [];
  stacticText: string = '';
  significanceTypes: any[] = [];
  significanceVal: any[] = [];
  // selectedcompareacrossOption: string = 'Single Brand';
  // selectedSection: string = 'Single Brand SnapShot';
  selectedcompareacrossOption: string = '';
  selectedSection: string = '';
  selectedSubSection: string = 'NA';

  // significanceTypes: any[] = [];

  onSigType(event: Event) {
    this.sigTypeDropdown = !this.sigTypeDropdown;
    event.stopPropagation();
  }
  select(block: string, event: Event) {
    // ;
    //this.isSigSelected = !this.isSigSelected;
    // if (block == this.sigTypeSelected) {
    //   return;
    // }
    // this.arktabaccess = true;
    // this.showSnapshot = true;

    this.sigTypeSelected = block;
    if (block == 'sig') {
      //reset indexing serach box
      this.searchQuery = '';
      //reseting completing indexing code once clicked on sig after index

      this.referenceDropdownToggle = false;
      this.BaseDropDownToggle = false;
      this.weightDropDownToggle = false;
      this.passOutputData = this._configService.passdata;
      this.passOutputData.indexVsBrandReference = [];
      this.passOutputData.significanceVsBrandReference = [];
      this._configService.isIndexSelected = false; //So that in chart dataLabelStyle==index should not be true;
      this.displayReference = 'None';
      for (let i = 0; i < this.allbrands.length; i++) {
        this.allbrands[i].isSelected = false;
      }
      this.selectedReference = 'None';

      for (let i = 0; i < this.confidenceLevel.length; i++) {
        this.confidenceLevel[i].isSelected = false;
      }
      this.confidenceLevel[0].isSelected = true;
      this.passOutputData.DefaultConfidenceLevel = this.confidenceLevel[0].key;

      this._configService.setDropdownValue('significance', 'Z-test');

      this.getsnapShotOutputData('sig', '');
      //debugger;

      this.isSigSelected = true;
      this.isIndexSelected = false;
      this.sigTypeDropdown = true;
      this.sigConBaseToggle = true;

      //updating selection summary
      let temp = this._configService.selectionSummaryText.split(
        `<span class="summary-label">Index: </span>`
      );
      this._configService.selectionSummaryText = temp[0];

      let tempTitle =
        this._configService.selectionSummaryTextTitle.split('Index: ');
      this._configService.selectionSummaryTextTitle = tempTitle[0];
      this._configService.selectionSummaryTextTitle =
        this._configService.selectionSummaryTextTitle +
        'Significance: ' +
        this.displaySignificance +
        ' || Base: ' +
        this.baseselected;
      this._configService.selectionSummaryText =
        this._configService.selectionSummaryText +
        `<span class="summary-label">Significance: </span>` +
        this.displaySignificance +
        `<span class="grey-separator"> ||  </span>` +
        `<span class="summary-label">Base: </span>` +
        this.baseselected;

      this.UpdateSignificanceSummary();
    } else if (block == 'index') {
      //To reset significance
      this.displaySignificance = 'None';
      this.significanceDropdownToggle = false;
      this.ConfidenceLevelDropDownToggle = false;
      this.BaseDropDownToggle = false;
      this.weightDropDownToggle = false;
      this.selectedSignificance = 'None';
      this.passOutputData.significance = 'None';
      this.passOutputData.DefaultConfidenceLevel = 'None';
      this._configService.updateSignificanceValue('None');
      this._configService.updateConfedenceValue('None');
      this.passOutputData.SignificanceVsReference = '';
      this.passOutputData.significanceVsBrandReference = [];
      this.displayBrand = false;
      this.allSigBrands = this.allSigBrands.map((item: any) => {
        item.isSelected = false;
        return item;
      });
      this.allbrands = this.allbrands.map((item: any) => {
        item.isSelected = false;
        if (item.MetricOption == 'None') {
          item.isSelected = true;
        }
        return item;
      });

      //this._configService.setDropdownValue('baseType', "Total Base");
      this._configService.setDropdownValue('significance', 'None');
      this._configService.setDropdownValue('SignificanceVsReference', 'None');
      this.isIndexSelected = true;
      this.isSigSelected = false;
      this.sigTypeDropdown = false;
      this.sigConBaseToggle = false;

      this.UpdateIndexSummary();
    }
    event.stopPropagation();
  }
  closeSigDropdown() {
    this.sigTypeDropdown = false;
  }
  onSigTypeClick(type: any, event: Event) {
    this._configService.setDropdownValue('significance', type.name);
    for (let i = 0; i < this.significanceTypes.length; i++) {
      if (this.significanceTypes[i] == type) {
        this.significanceTypes[i].selected = true;
      } else {
        this.significanceTypes[i].selected = false;
      }
    }
    event.stopPropagation();
  }
  closeSignificance() {
    this.significanceDropdownToggle = false;
  }
  onSignificanceDropdown() {
    this.ConfidenceLevelDropDownToggle = false;
    this.BaseDropDownToggle = false;
    this.weightDropDownToggle = false;
    this.significanceDropdownToggle = !this.significanceDropdownToggle;
    // ;
  }
  significanceSelected1(item: any, event: any) {
    // this.significanceVal.push({ key: 'None', value: true, isSelected: true });

    //reseting sorting condition
    this.arktabaccess = true;
    if (item.key != 'None') {
      this.sortToggle = !this.sortToggle;
    }

    if (this.displaySignificance == item.key) {
      this.sortToggle = !this.sortToggle;
      this.significanceDropdownToggle = false;
      this.ConfidenceLevelDropDownToggle = false;
      this.BaseDropDownToggle = false;
      this.weightDropDownToggle = false;
      event.stopPropagation();
      return;
    }
    this.passOutputData.SignificanceVsReference = '';
    this.passOutputData.significanceVsBrandReference = [];
    this.selectedSignificance = item;

    var ele = document.querySelector('.confidenceLeveldropdown');
    if (item.key !== 'None') {
      if (ele) {
        // Check if the element exists
        ele.classList.remove('DNN');
      }
    } else {
      ele?.classList.add('DNN');
    }

    for (let i = 0; i < this.significanceVal.length; i++) {
      // ;
      if (this.significanceVal[i].key == item.key) {
        this.significanceVal[i].isSelected = true;
      } else {
        this.significanceVal[i].isSelected = false;
      }
    }

    if (item.key != 'Reference') {
      this.significanceDropdownToggle = false;
      this.ConfidenceLevelDropDownToggle = false;
      this.BaseDropDownToggle = false;
      this.weightDropDownToggle = false;
      this.displayBrand = false;
      this.displaySignificance = item.key;
      this.significanceSelectedValue = item.key;
      this.passOutputData.significance = item.key;
      this.brandSelection(this.allSigBrands, '');
    } else if (item.key == 'Reference') {
      this.displayBrand = true;
      return;
    }

    this._configService.updateSignificanceValue(item.key);

    //Handling confidence level as per significance
    if (item.key == 'None') {
      for (let i = 0; i < this.confidenceLevel.length; i++) {
        this.confidenceLevel[i].isSelected = false;
      }
      this.confidenceLevel[0].isSelected = true;
      this.confidenceLevelSelectedValue = this.confidenceLevel[0].key;
      this._configService.updateConfedenceValue(
        this.confidenceLevelSelectedValue
      );
    }

    for (let i = 0; i < this.confidenceLevel.length; i++) {
      if (this.confidenceLevel[i].isSelected == true) {
        this.passOutputData.DefaultConfidenceLevel =
          this.confidenceLevel[i].key;
        this._configService.updateConfedenceValue(this.confidenceLevel[i].key);
      }
    }
    this._configService.setDropdownValue('SignificanceVsReference', item.key);
    //API Call
    //-----------------------------------------------------------

    if (this.passOutputData.significance != 'None') {
      this._configService.isIndexSelected = false;
      this.displayBrand = false;
      this.getsnapShotOutputData('significance', '');
      //debugger;
    } else {
      this.displayBrand = false;
      this.passOutputData.confidenceLevel = 'None';
      this.getsnapShotOutputData('', '');
      //debugger;
    }
    if (this.displaySignificance != 'Reference')
      this.UpdateSignificanceSummary();
  }

  brandSig(brand: any, event: Event) {
    this.displaySignificance = this.selectedSignificance.key;
    this.significanceSelectedValue = this.selectedSignificance.key;
    this.passOutputData.significance = this.selectedSignificance.key;
    this._configService.updateSignificanceValue(this.significanceSelectedValue);
    this._configService.isIndexSelected = false;
    for (let i = 0; i < this.confidenceLevel.length; i++) {
      if (this.confidenceLevel[i].isSelected == true) {
        this.passOutputData.DefaultConfidenceLevel =
          this.confidenceLevel[i].key;
        this._configService.updateConfedenceValue(this.confidenceLevel[i].key);
      }
    }
    this._configService.setDropdownValue(
      'SignificanceVsReference',
      this.significanceSelectedValue
    );

    this.selectedSigBrand = brand;
    this.brandSelection(this.allSigBrands, brand);

    this.onSignificanceDropdown();
    event.stopPropagation();

    //Creating object for brand selected in reference similar as left panel submit object----------
    this.vsBrandArray = [];
    this.passOutputData.indexVsBrandReference = [];
    this.passOutputData.significanceVsBrandReference = [];
    this.passOutputData.SignificanceVsReference = 'Reference';
    this.vsBrandArray.push({
      Level0: this.selectedSigBrand.Level1,
      Level1: this.selectedSigBrand.Level2,
      Level2: this.selectedSigBrand.MetricOption,
      Level3: '',
      Level4: '',
      Level5: '',
      calc_type: this.selectedSigBrand.calculation_type,
      customGroupId: this.selectedSigBrand.customGroupId,
      dataYearCode: this.selectedSigBrand.dataYearCode,
      date: this.selectedSigBrand.date,
      hasNextLevel: false,
      is_CustomGroup: this.selectedSigBrand.is_CustomGroup,
      is_brand_analysis: this.selectedSigBrand.is_brandanalysis,
      is_derived: this.selectedSigBrand.is_derived_variable,
      is_dimension: this.selectedSigBrand.is_dimension,
      is_multi_punch: this.selectedSigBrand.is_multi_punch,
      is_time_Period_Present: this.selectedSigBrand.is_time_Period_Present,
      kibanaFilterScript: '',
      response_code: this.selectedSigBrand.response_code,
      sort_id: this.selectedSigBrand.sort_id,
      variable_code: this.selectedSigBrand.variable_code,
      variable_label: null, //No data available
      year_code: this.selectedSigBrand.year_code,
    });
    if (this.vsBrandArray) {
      this.vsBrandArray = this._configService.updatedDataForSubmit(
        this.vsBrandArray
      );
      // ;
      const x = this._configService.previewDataCreation(this.vsBrandArray);
      if (x !== undefined) {
        this.passOutputData.significanceVsBrandReference.push(x);
      }
    }
    this.getsnapShotOutputData('reference', '');
    //debugger;

    this.UpdateSignificanceSummary();
  }
  onCLclick() {
    this.significanceDropdownToggle = false;
    //this.sortToggle=!this.sortToggle;
  }
  onConfidenceLevelDropdown() {
    this.weightDropDownToggle = false;
    this.BaseDropDownToggle = false;
    this.ConfidenceLevelDropDownToggle = !this.ConfidenceLevelDropDownToggle;
  }
  onModuleSelectionDropdown() {
    this.moduleSelectionToggle = true;
  }
  searchBoxClick(event: Event) {
    event.stopPropagation();
  }
  moduleSelected(event: any) {
    this.moduleSelectionToggle = false;
    this.displayModuleSelected = event.target.textContent;
    // this._configService.setDropdownValue(
    //   'confidenceLevel',
    //   event.target.textContent
    // );
    this.moduleseSelections.forEach((p: any) => {
      if (p.key == event.target.textContent) {
        p.selected = true;
        p.isSelected = true;
      } else {
        p.selected = false;
        p.isSelected = false;
      }
    });
  }
  confidenceLevelSelected(event: any) {
    this.displayConfidenceLevel = event.target.textContent;
    this._configService.setDropdownValue(
      'confidenceLevel',
      event.target.textContent
    );
    this.confidenceLevel.forEach((p: any) => {
      if (p.key == event.target.textContent) {
        p.selected = true;
        p.isSelected = true;
      } else {
        p.selected = false;
        p.isSelected = false;
      }
    });
    //this.dropdown.nativeElement.selectedIndex = 0;
    this.passOutputData.DefaultConfidenceLevel = event.target.textContent;
    this._configService.updateConfedenceValue(event.target.textContent);
    for (let i = 0; i < this.confidenceLevel.length; i++) {
      if (this.significanceVal[i].isSelected == true) {
        this.passOutputData.significance = this.significanceVal[i].key;
      }
    }
    this._configService.setDropdownValue(
      'confidenceLevel',
      event.target.textContent
    );
    //API Call

    this.getsnapShotOutputData('confidence', '');
    //debugger;

    // update the summary text
    if (
      this._configService.selectionSummaryText.includes('Confidence Level:')
    ) {
      let temp = this._configService.selectionSummaryText.split(
        'Confidence Level: </span>'
      );

      let temp1 = temp[1]?.split('%');
      temp1[0] = this.passOutputData.DefaultConfidenceLevel.replace('%', '');
      this._configService.selectionSummaryText =
        temp[0] + 'Confidence Level: </span>' + temp1.join('%');

      let tempTitle =
        this._configService.selectionSummaryTextTitle.split(
          'Confidence Level: '
        );

      let tempTitle1 = tempTitle[1]?.split('%');
      tempTitle1[0] = this.passOutputData.DefaultConfidenceLevel.replace(
        '%',
        ''
      );
      this._configService.selectionSummaryTextTitle =
        tempTitle[0] + 'Confidence Level: ' + tempTitle1.join('%');
    }
    this.UpdateSelectionSummary();
    this.ConfidenceLevelDropDownToggle = false;
  }
  onReferenceDropdown() {
    this.referenceDropdownToggle = !this.referenceDropdownToggle;
  }

  closeReferenceDropdown() {
    this.referenceDropdownToggle = false;
  }

  referenceSelected(item: any) {
    this.arktabaccess = true;
    this.sortToggle = !this.sortToggle; //To reset sorting option to default;
    this.selectedReference = item;
    let oldReference = this.displayReference;
    this.displayReference = item.MetricOption;
    this._configService.setDropdownValue(
      'selectedIndex',
      this.displayReference
    );

    // ;
    for (let i = 0; i < this.allbrands.length; i++) {
      // ;
      if (this.allbrands[i].MetricOption == item.MetricOption) {
        this.allbrands[i].isSelected = true;
      } else {
        this.allbrands[i].isSelected = false;
      }
    }

    this.referenceDropdownToggle = false; //Closing the referenece dropdown

    //Creating object for brand selected in reference similar as left panel submit object----------
    this.vsBrandArray = [];
    this.passOutputData.indexVsBrandReference = [];
    this.passOutputData.significanceVsBrandReference = [];
    this.vsBrandArray.push({
      Level0: this.selectedReference.Level1,
      Level1: this.selectedReference.Level2,
      Level2: this.selectedReference.MetricOption,
      Level3: '',
      Level4: '',
      Level5: '',
      calc_type: this.selectedReference.calculation_type,
      customGroupId: this.selectedReference.customGroupId,
      dataYearCode: this.selectedReference.dataYearCode,
      date: this.selectedReference.date,
      hasNextLevel: false,
      is_CustomGroup: this.selectedReference.is_CustomGroup,
      is_brand_analysis: this.selectedReference.is_brandanalysis,
      is_derived: this.selectedReference.is_derived_variable,
      is_dimension: this.selectedReference.is_dimension,
      is_multi_punch: this.selectedReference.is_multi_punch,
      is_time_Period_Present: this.selectedReference.is_time_Period_Present,
      kibanaFilterScript: '',
      response_code: this.selectedReference.response_code,
      sort_id: this.selectedReference.sort_id,
      variable_code: this.selectedReference.variable_code,
      variable_label: null, //No data available
      year_code: this.selectedReference.year_code,
    });
    if (this.vsBrandArray && item.MetricOption != 'None') {
      this.vsBrandArray = this._configService.updatedDataForSubmit(
        this.vsBrandArray
      );
      // ;
      const x = this._configService.previewDataCreation(this.vsBrandArray);
      if (x !== undefined) {
        this.passOutputData.indexVsBrandReference.push(x);
      }
    }
    if (item.MetricOption == 'None') {
      this.getsnapShotOutputData('sig', ''); // for a blank output
      //debugger;
      this._configService.isIndexSelected = false;
      // let newArr = this._configService.standardSnapOutputData.map((item: any) => {
      //  item.CalculationType=item.CalculationType;
      // });
      // this._configService.standardSnapOutputData=newArr;
      // this.afterSubmit();
    } else {
      this.getsnapShotOutputData('reference', '');
      //debugger;
    }

    this._configService.selectionSummaryText =
      this._configService.selectionSummaryText.replace(
        'Index: </span>' + oldReference,
        'Index: </span>' + this.displayReference
      );
    this._configService.selectionSummaryTextTitle =
      this._configService.selectionSummaryTextTitle.replace(
        'Index: ' + oldReference,
        'Index: ' + this.displayReference
      );
    this.UpdateSelectionSummary();
  }

  brandSelection(allBrands: any, brand: any) {
    if (brand == '') {
      for (let i = 0; i < allBrands.length; i++) {
        allBrands[i].isSelected = false;
      }
    } else {
      for (let i = 0; i < allBrands.length; i++) {
        // ;
        if (allBrands[i].MetricOption == brand.MetricOption) {
          allBrands[i].isSelected = true;
        } else {
          allBrands[i].isSelected = false;
        }
      }
    }
  }
  UpdateSignificanceSummary() {
    let signi =
      this.displaySignificance +
      (this.displaySignificance == 'Reference'
        ? ': ' +
        (this.selectedSigBrand == undefined
          ? ''
          : this.selectedSigBrand.MetricOption)
        : '');

    if (this._configService.selectionSummaryText.includes('Significance: ')) {
      let temp = this._configService.selectionSummaryText.split(
        'Significance: </span>'
      );

      if (this.displaySignificance == 'None') {
        this._configService.selectionSummaryText =
          temp[0] +
          'Significance: </span>' +
          signi +
          `<span class="grey-separator"> ||  </span>` +
          `<span class="summary-label">Base: </span>` +
          this.baseselected +
          `<span class="grey-separator"> ||  </span>` +
          `<span class="summary-label">Weight: </span>` +
          this.weightSelectedValue;
      } else {
        if (temp.length > 2) {
          let tempt = temp[1]?.split('<span');
          tempt[0] = signi;
          this._configService.selectionSummaryText =
            temp[0] +
            'Significance: </span>' +
            tempt.join('<span') +
            `<span class="grey-separator"> ||  </span>` +
            `<span class="summary-label">Base: </span>` +
            this.baseselected +
            `<span class="grey-separator"> ||  </span>` +
            `<span class="summary-label">Weight: </span>` +
            this.weightSelectedValue;
        } else {
          this._configService.selectionSummaryText =
            temp[0] +
            'Significance: </span>' +
            signi +
            "<span class='grey-separator'> ||  </span>" +
            `<span class="summary-label">Confidence Level: </span>` +
            this.passOutputData.DefaultConfidenceLevel +
            `<span class="grey-separator"> ||  </span>` +
            `<span class="summary-label">Base: </span>` +
            this.baseselected +
            `<span class="grey-separator"> ||  </span>` +
            `<span class="summary-label">Weight: </span>` +
            this.weightSelectedValue;
        }
      }
    } else {
      this._configService.selectionSummaryText =
        this._configService.selectionSummaryText +
        `<span class="grey-separator"> ||  </span>` +
        `<span class="summary-label">Significance: </span>` +
        signi;
      this._configService.selectionSummaryText =
        this._configService.selectionSummaryText +
        `<span class="grey-separator"> ||  </span>` +
        `<span class="summary-label">Confidence Level: </span>` +
        this.passOutputData.DefaultConfidenceLevel +
        `<span class="grey-separator"> ||  </span>` +
        `<span class="summary-label">Base: </span>` +
        this.baseselected +
        `<span class="grey-separator"> ||  </span>` +
        `<span class="summary-label">Weight: </span>` +
        this.weightSelectedValue;
    }

    if (
      this._configService.selectionSummaryTextTitle.includes('Significance: ')
    ) {
      let tempTitle =
        this._configService.selectionSummaryTextTitle.split('Significance: ');

      if (this.displaySignificance == 'None') {
        this._configService.selectionSummaryTextTitle =
          tempTitle[0] +
          'Significance: ' +
          signi +
          ' || Base: ' +
          this.baseselected +
          ' || Weight: ' +
          this.weightSelectedValue;
      } else {
        if (tempTitle.length > 2) {
          let temptTitle = tempTitle[1]?.split(' || ');
          temptTitle[0] = signi;
          this._configService.selectionSummaryTextTitle =
            tempTitle[0] +
            'Significance: ' +
            temptTitle.join(' || ') +
            '|| Confidence Level: ' +
            this.passOutputData.DefaultConfidenceLevel +
            ' || Base: ' +
            this.baseselected +
            ' || Weight: ' +
            this.weightSelectedValue;
        } else {
          this._configService.selectionSummaryTextTitle =
            tempTitle[0] +
            'Significance: ' +
            signi +
            ' || Confidence Level: ' +
            this.passOutputData.DefaultConfidenceLevel +
            ' || Base: ' +
            this.baseselected +
            ' || Weight: ' +
            this.weightSelectedValue;
        }
      }
    } else {
      this._configService.selectionSummaryTextTitle =
        this._configService.selectionSummaryTextTitle +
        ' || Significance: ' +
        signi;
      this._configService.selectionSummaryTextTitle =
        this._configService.selectionSummaryTextTitle +
        ' || Confidence Level: ' +
        this.passOutputData.DefaultConfidenceLevel +
        ' || Base: ' +
        this.baseselected +
        ' || Weight: ' +
        this.weightSelectedValue;
    }

    this.UpdateSelectionSummary();
  }

  UpdateSelectionSummary() {
    // const infoRibbonDiv = document.querySelector(
    //   '.InforRibbonEntireSummary'
    // ) as HTMLDivElement;
    // const infoRibbonTextValuesDiv = document.querySelector(
    //   '.InforRibbonTextValues'
    // ) as HTMLDivElement;

    // if (infoRibbonDiv != null) {
    //   infoRibbonDiv.innerHTML = this._configService.selectionSummaryText;
    //   infoRibbonDiv.title = this._configService.selectionSummaryTextTitle;
    // }

    // if (infoRibbonTextValuesDiv != null) {
    //   infoRibbonTextValuesDiv.innerHTML =
    //     this._configService.selectionSummaryText;
    //   infoRibbonTextValuesDiv.title =
    //     this._configService.selectionSummaryTextTitle;
    // }

    // this._configService.setDropdownValue(
    //   'selectionSummary',
    //   this._configService.selectionSummaryTextTitle
    // );
    this.selectionSummary = this._configService.selectionSummaryTextTitle;
  }

  UpdateIndexSummary() {
    let temp = this._configService.selectionSummaryText.split(
      'Significance: </span>'
    );
    let index = this.displayReference;

    this._configService.selectionSummaryText =
      temp[0] +
      'Index: </span>' +
      index +
      `<span class="grey-separator"> ||  </span>` +
      `<span class="summary-label">Base: </span>` +
      this.baseselected +
      `<span class="grey-separator"> ||  </span>` +
      `<span class="summary-label">Weight: </span>` +
      this.weightSelectedValue;

    let tempTitle =
      this._configService.selectionSummaryTextTitle.split('Significance: ');
    this._configService.selectionSummaryTextTitle =
      tempTitle[0] +
      'Index: ' +
      index +
      ' || Base: ' +
      this.baseselected +
      ' || Weight: ' +
      this.weightSelectedValue;

    this.UpdateSelectionSummary();
  }

  UpdateBaseSummary() {
    // update the summary text and the title for this.baseSelected
    if (this._configService.selectionSummaryText.includes('Base: ')) {
      let temp =
        this._configService.selectionSummaryText.split('Base: </span>');

      let temp1 = temp[1]?.split(' Base');
      temp1[0] = this.baseselected;
      this._configService.selectionSummaryText =
        temp[0] +
        'Base: </span>' +
        temp1[0] +
        `<span class="grey-separator"> ||  </span>` +
        `<span class="summary-label">Weight: </span>` +
        this.weightSelectedValue;

      let tempTitle =
        this._configService.selectionSummaryTextTitle.split('Base: ');

      let tempTitle1 = tempTitle[1]?.split(' Base');
      tempTitle1[0] = this.baseselected;
      this._configService.selectionSummaryTextTitle =
        tempTitle[0] +
        'Base: ' +
        tempTitle1[0] +
        ' || Weight: ' +
        this.weightSelectedValue;
    }

    this.UpdateSelectionSummary();
  }

  UpdateWeightSummary() {
    // update the summary text and the title for this.baseSelected
    if (this._configService.selectionSummaryText.includes('Weight: ')) {
      let temp =
        this._configService.selectionSummaryText.split('Weight: </span>');

      let temp1 = temp[1]?.split(' Weight');
      temp1[0] = this.weightSelectedValue;
      this._configService.selectionSummaryText =
        temp[0] + 'Weight: </span>' + temp1[0];

      let tempTitle =
        this._configService.selectionSummaryTextTitle.split('Weight: ');

      let tempTitle1 = tempTitle[1]?.split(' Weight');
      tempTitle1[0] = this.weightSelectedValue;
      this._configService.selectionSummaryTextTitle =
        tempTitle[0] + 'Weight: ' + tempTitle1[0];
    }

    this.UpdateSelectionSummary();
  }

  sendInputMessage(ChatResponse?: any, isChatResponse: boolean = false) {
    //debugger;
    // Generate a new GUID only if it doesn't already exist
    if (!this.guidChatId) {
      this.guidChatId = this.generateGuid();
    }

    // if(this.inputValue!="" && !this.ValidateQuery(this.inputValue,this.existingquery)){
    if (!isChatResponse)
      this.selectedChatId = null;
    this.moduleSelectionToggle = false;
    this.showModuleDropdown = false;
    this.askMeLanding = false;
    if (this.inputValue != '' || isChatResponse == true) {
      this.selectedData = '';
      this.displayTable = false;
      this.insightsVal = '';
      this.OutputdataObject.Row = [];
      this.OutputdataObject.Column = [];
      this.arktabaccess = true;
      this.isVerticalGroupBarChartClick = false;
      this.isVerticalBarChartClick = false;
      this.isVerticalStackChartClick = false;
      this.isLineChartClick = false;
      this.isInsightspopupOpen = false;
      //this.fomData=JSON.parse(JSON.stringify(this.fomDataArray));
      if (this.inputValue && this.inputValue.trim()) {
        this.chatPreviewBlocks.push({
          question: this.inputValue,
          response: this.chatResponse && this.chatResponse.length > 0 ? this.chatResponse[0]['response'] || '' : '',
          QuestionAnswer: this.defaultQuestionAnswer
        });
      }
      this.failedCase = false;
      this.chatResponse = [];

      let GetMcode: any = null;
      let getSnapshotConfiguration: any = null;
      let GetCustomSnapshotWidget: any = null;
      let GetQuery: any = null;
      let getSnapshotOutput: any = null;
      let getSnapshotLoadData: any = null;
      let getConfiguration: any = null;
      let getSnapshotInsights: any = null;
      let getInsights: any = null;

      if (isChatResponse) {
        const parsed = this.parseChatResponse(ChatResponse);

        GetMcode = parsed['GetMcode'];
        getSnapshotConfiguration = parsed['getSnapshotConfiguration'];
        GetCustomSnapshotWidget = parsed['GetCustomSnapshotWidget'];
        GetQuery = parsed['GetQuery'];
        getSnapshotOutput = parsed['getSnapshotOutput'];
        getSnapshotLoadData = parsed['getSnapshotLoadData'];
        getConfiguration = parsed['getConfiguration'];
        getSnapshotInsights = parsed['getSnapshotInsights'];
        getInsights = parsed['getInsights'];
      }

      //this.apiService.getOutputData(this.inputValue,this.fomData).subscribe((data) => {

      // let selectedModule = ''; // Use Global Varuiable for identification later
      // this.mcode="";
      (GetMcode && isChatResponse ? of(GetMcode) : this.apiService.getMcode(this.inputValue, this.landingdata.client_code, this.landingdata.study, this.guidChatId)).subscribe((data) => {
        // debugger;
        if (!isChatResponse)
          this.pushChatResponseEntry('GetMcode', data);


        this.promptData = data.response;
        console.log(this.promptData);
        this.Widget_Id = this.promptData.Widget_ID;
        this.mcode = data.mcode;
        this.promptData.entryPointData = this.dataArray;
        this.isTotalBase = this.promptData.isTotalBase;
        if (this.chatPreviewBlocks.length === 0 && this.promptData?.user_input) {
          this.chatPreviewBlocks.push({ question: this.promptData.user_input, response: '', QuestionAnswer: this.defaultQuestionAnswer });
        }
        // new code - 08/12/2025
        // debugger;
        this.LoadRibbonData(this.filteredlist);
        this.isDiagnostic = true;
        this.existingquery = this.inputValue;
        // this.arktabaccess = false; // Kept active for insights
        this.inputValue = '';
        this.OutputdataObject.Row = [];
        this.OutputdataObject.Column = [];
        this.CrossTabOutPutData = [];
        this.showSnapshot = false;
        // if (data != null && data.HasValidData) {
        if (data.response != null) {
          // sessionStorage.setItem('ResponseData', JSON.stringify(data));
          // this.isExistingDataPresent=true;
          console.log(data.response);

          let outputstring = data.response;
          // let outputstring = JSON.parse(data);

          console.log(data.response);
          this.displayTable = true;

          //this.CrossTabOutPutData = JSON.parse(data.Data);
          this.CrossTabOutPutData = JSON.parse(outputstring.Data);
          console.log('output', this.CrossTabOutPutData);
          this.AssignDataToDataObject(data.payload);
          // this.SelectedSummary();
          this.SelectionSummary();

          this.variableTabData = this.receivedData;

          //this.CrossTabOutPutEntireData = JSON.parse(data.Data);
          this.CrossTabOutPutEntireData = JSON.parse(outputstring.Data);
          let chartType = 'column';
          chartType = this.isTranspose ? 'column' : 'bar';
          if (this.CrossTabOutPutEntireData.length > 0) {
            this.CrossTabOutPutData = this.CrossTabOutPutEntireData;
          }
          // this.isTotalBase = true;
          this.isTranspose = false;
          this.insufficientBase = '';
          this.DefaultConfidenceLevel = 'None';
          this.isAnswerBase = false;
          this.isSampleSize = false;
          this.isWeightedLabel = false;
          this.LowBase = '';

          this.isPairWise = false;
          this.DefaultSampleSize = 'None';
          this.threshold = '';
          this.selectedIndex = '';
          this.isIndex = false;
          this.selectedWeight = data.payload.SelectedWeight;
          // debugger;
          this.isBrandAnalysis = data.payload.isBrandAnalysis;
          if (!this.isTotal) {
            this.CrossTabOutPutData = this.CrossTabOutPutEntireData.filter(
              (x: any) => {
                return !x.isTotal;
              }
            );
          }
          if (this.isIndex && this.selectedIndex != '') {
            this.manipulateIndexData();
          }
          this.BindTableOutput(this.CrossTabOutPutData);
          this.sortOutputData();
          this.isCreateBtnClick = true;
          sessionStorage.setItem('isarkTabAccessed', 'true');
          if (this.isTranspose) {
            // If 'isTranspose' is true, call a function to modify row column based on transpose selection
            this.handleOutputdataObjectOnTransposeSelect();
          }
          if (
            this.OutputdataObject.Row.length != 0 &&
            this.OutputdataObject.Column.length != 0
          ) {
            this.displayTable = true;
          }
          const columndata = this.dataObject['Column'];

          const TimePeriodinColumn = columndata.filter((parent) => {
            return parent.Data.some((child) => child.isTimePeriod === true);
          });

          this.disableLineChart =
            TimePeriodinColumn.length == 1 ? true : false;

          const rowData = this.dataObject['Row']?.[0]?.Data || [];;
          //
          const rowNestData = this.dataObject['RowNesting']?.[0]?.Data || [];
          const colNestData = this.dataObject['ColNesting']?.[0]?.Data || [];
          this.isChartView = rowNestData.length > 0 || colNestData.length > 0 ? false : (rowData.length < 15 ? true : false);
          this.crossTabService.setCrossTabOuputData(
            this.CrossTabOutPutData
          );
          if (this.isLineChartClick) {
            this.onTrendChartIconClick();
          } else if (
            this.isVerticalGroupBarChartClick ||
            this.isVerticalBarChartClick
          ) {
            this.VerticalChartClick(this.chartType);
          } else if (this.isVerticalStackChartClick) {
            this.onVerticalStackBarChartIconClick(this.chartType);
          }
          this.is_Time_Period_Present = true;
        }
        this.isInsightspopupOpen = false;
        this.arktabaccess = true;
        this.isInsightsBtnEnabled = true;
        this.openInsights(isChatResponse, getInsights);
        // this.arktabaccess = false; // Kept active for insights
        this.LoadRibbonData(this.filteredlist);
        // OLD code - 08/12/2025

        if (this.mcode == 99) {
          if (!isChatResponse)
            this.saveChatList(this.chatPreviewBlocks.length > 0 ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question : this.inputValue, this.chatResponse);
          //this.insightsVal=this.promptData.p_user_response;
          this.insightsVal = this.fallbackMessage();
          this.failedCase = true;
          this.isInsightspopupOpen = true;
          // this.arktabaccess = false; // Keep active until getOutputData completes
          // this.inputValue='';
          this.isDiagnostic = true;

          this.apiService.getOutputData(
            this.inputValue,
            this.landingdata.client_code,
            this.landingdata.study,
            [],
            this.promptData,
            this.weightFilter
          ).subscribe(
            (outputResponse) => {
              this.promptData = outputResponse;
              this.insightsVal = outputResponse.p_user_response || this.fallbackMessage();
              this.Widget_Id = outputResponse.Widget_ID;
              this.isTotalBase = outputResponse.isTotalBase;

              this.failedCase = true;
              this.isInsightspopupOpen = true;
              this.arktabaccess = false;
              this.inputValue = '';
              this.isDiagnostic = true;
            },
            (error) => {
              console.error('Error from GetQuery (mcode 99):', error);
            }
          );
          // return;
        }

        // Snapshot Module
        if (this.mcode == 111) {
          this.Snapshotdataforexport = this._configService.getDropdownValues();
          // this.commonchartmodules.colortemplate();

          this.displayConfidenceLevel = '90%';
          this.allSigBrands = [
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'JP Morgan Chase',
              data_variable_code: '',
              response_code: '1',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120005,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'Acorns',
              data_variable_code: '',
              response_code: '2',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120006,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'Wells Fargo',
              data_variable_code: '',
              response_code: '3',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120007,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'Robinhood',
              data_variable_code: '',
              response_code: '4',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120008,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'Fidelity Investments',
              data_variable_code: '',
              response_code: '5',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120009,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'Bank Of America/Merrill Lynch',
              data_variable_code: '',
              response_code: '06',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120010,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'SoFi',
              data_variable_code: '',
              response_code: '11',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120011,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'Charles Schwab',
              data_variable_code: '',
              response_code: '14',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120012,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'Venmo',
              data_variable_code: '',
              response_code: '15',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120013,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'Webull',
              data_variable_code: '',
              response_code: '16',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120014,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'Vanguard',
              data_variable_code: '',
              response_code: '18',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120015,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'Edward Jones',
              data_variable_code: '',
              response_code: '19',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120016,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'ETrade',
              data_variable_code: '',
              response_code: '20',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120017,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'Morgan Stanley',
              data_variable_code: '',
              response_code: '22',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120018,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'TD Ameritrade',
              data_variable_code: '',
              response_code: '24',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120019,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'Coinbase',
              data_variable_code: '',
              response_code: '27',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120020,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'Bank of America/Merrill Lynch',
              data_variable_code: '',
              response_code: '6',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120038,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'Capital One',
              data_variable_code: '',
              response_code: '9',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120047,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'Citigroup',
              data_variable_code: '',
              response_code: '13',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120052,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'Goldman Sachs',
              data_variable_code: '',
              response_code: '26',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120073,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'PayPal',
              data_variable_code: '',
              response_code: '23',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120112,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
            {
              Header: 'VariableList',
              Level1: 'Brands',
              Level2: 'Brands',
              MetricOption: 'UBS',
              data_variable_code: '',
              response_code: '25',
              derived_metric_calculation: '',
              Level0: 'Brands',
              Level3: '',
              Level4: '',
              Level5: '',
              Level6: '',
              sort_id: 120146,
              level1_sort_id: 0,
              is_multi_punch: 0,
              is_derived_variable: false,
              is_dimension: true,
              calculation_type: 'share',
              url_logo: null,
              tooltip: 'Brands',
              year_code: null,
              year_label: null,
              date: '0001-01-01T00:00:00',
              isActive: true,
              is_CustomGroup: false,
              customGroupQuery: '',
              is_CustomCalculation: false,
              customCalculationQuery: null,
              dataYearCode: 'Year_code',
              is_time_Period_Present: true,
              is_dimension_Present: true,
              is_shared: null,
              user_name: null,
              customGroupId: null,
              customCalculationId: null,
              is_brandanalysis: 7,
              variable_code: '',
              is_aggregated_data: 0,
              is_semi_aggregated_data: 0,
              is_snapshot: 1,
              sequence: 2,
              isSelected: false,
            },
          ];
          this.allbrands = _.cloneDeep(this.allSigBrands);
          this.significanceVal = [
            {
              key: 'None',
              value: true,
              isSelected: true,
            },
            {
              key: 'Previous Year',
              value: true,
              isSelected: false,
            },
            {
              key: 'Previous Period',
              value: true,
              isSelected: false,
            },
          ];
          this.confidenceLevel = [
            {
              key: '90%',
              value: true,
              isSelected: true,
            },
            {
              key: '95%',
              value: true,
              isSelected: false,
            },
            {
              key: '99%',
              value: true,
              isSelected: false,
            },
          ];
          //this.isTotalBase = true;
          this.baseselected = this.isTotalBase ? 'Total Base' : 'Answer Base';
          //  this.baseLevelSelectedValue = this.baseselected;
          this.base = [
            { key: 'Total Base', selected: this.isTotalBase },
            { key: 'Answer Base', selected: !this.isTotalBase },
          ];
          //  this.base2 = [
          //    { key: 'Total Base', selected: this.isTotalBase },
          //  ];
          this.base2 = [
            { key: 'Total Base', selected: this.isTotalBase },
            { key: 'Answer Base', selected: !this.isTotalBase },
          ];
          // this.selected_study = 'Brand Insights'; //this.clientDetails.clientDetails.study;
          // this.selected_client = 'Fidelity'; //this.clientDetails.clientDetails.client_code;
          this.selected_study = this.landingdata.study;
          this.selected_client = this.landingdata.client_code;
          // this.snapshotName = 'Snapshot 01';
          this.snapshotName = this.promptData.Snapshot_Name;
          this.selectedSection = this.promptData.Section
          this.selectedcompareacrossOption = this.promptData.Snapshot_Type

          this.widegtconfigdetails = {
            // section: this.promptData.Snapshot_Type+' Snapshot',
            section: this.selectedSection,

            subSection: 'NA',
            snapshotType: this.promptData.Snapshot_Type,
            snapshotName: this.snapshotName,
            clientName: this.selected_client,
            study: this.selected_study,
            IsCustomSnapshot: true,
          };
          let data2 = {
            client_code: this.selected_client,
            // snapshot_name: this.selected_study,
            snapshot_name: this.snapshotName,

          };

          (getSnapshotConfiguration && isChatResponse ? of(getSnapshotConfiguration) : this._configService.getClientStudyData(data2)).subscribe((c) => {
            if (!isChatResponse)
              this.pushChatResponseEntry('getSnapshotConfiguration', c);
            let data = JSON.parse(c.body.Data);
            this.Snapshotdataforexport.staticText = data.static_text;
            this._configService.outputSnapshotData = data;

            this.snapshotName = data.snapshot_name;
            //this.snapNameNavHeader.emit(data.snapshot_name);
            this.additionalList = data.additional_list;

            //this.snapshotType_details = data.snapshotType_details;
            let studyName = data.study_list[0].study_name;
            this.selected_study = studyName;
            this.selected_client = data.client_name;
            this.Snapshotdataforexport.studyName = studyName;
            this.Snapshotdataforexport.clientName = this.selected_client;

            this._configService.staticText =
              data.static_text != null ? data.static_text : '';
            this.stacticText = this._configService.staticText;

            // let compareacross: any = [];
            // this.snapshotType_details.forEach((type: any) => {
            //   compareacross.push({
            //     name: type.snapshot_type,
            //     value: type.snapshot_type,
            //     selected: false,
            //   });
            // });
            this.selectedSigType =
              this._configService.outputSnapshotData?.significance_type;
            for (let i = 0; i < this.selectedSigType.length; i++) {
              this.significanceTypes.push({
                id: i + 1,
                selected: false,
                name: this.selectedSigType[i].key,
                value: this.selectedSigType[i].key,
              });
            }
          });

          let parameter1 = {
            study: this.selected_study,
            client_name: this.selected_client, //this.clientDetails.clientDetails.client_code,
            client_code: this.selected_client, //this.clientDetails.clientDetails.client_code,
            isBrandAnalysis: true,
          };

          (getConfiguration && isChatResponse ? of(getConfiguration) : this._configService
            .getGeneralConfigData(parameter1))
            .subscribe((data: any) => {
              if (!isChatResponse)
                this.pushChatResponseEntry('getConfiguration', data);
              if (data.Data != '') {
                let lsORisData = JSON.parse(data.Data);
                const configData = lsORisData.configData;

                const significanceData = configData.significance_type.find(
                  (item: { key: string; value: boolean }) => item.value === true
                );

                this.Snapshotdataforexport.significance = significanceData ? significanceData.key : null;

                this.Snapshotdataforexport.insufficientBase = configData.low_base_identifier.find(
                  (item: { key: string; data_value: string }) => item.key === "Insufficient Base"
                )?.data_value ?? null;

                this.Snapshotdataforexport.lowBase = configData.low_base_identifier.find(
                  (item: { key: string; data_value: string }) => item.key === "Low Base"
                )?.data_value ?? null;

                this.Snapshotdataforexport.thresholdIndex = configData.threshold_identifier.find(
                  (item: { key: string; data_value: string }) => item.key === "Threshold"
                )?.data_value ?? null;

                this.ImageURL = lsORisData.logoFile.url;
                this._configService.LBthreshold = Number(
                  lsORisData.configData.low_base_identifier.find(
                    (item: any) => item.key === 'Low Base'
                  )?.data_value
                );
                this.LowBase = this._configService.LBthreshold;
                this._configService.ISthreshold = Number(
                  lsORisData.configData.low_base_identifier.find(
                    (item: any) => item.key === 'Insufficient Base'
                  )?.data_value
                );
                this.insufficientBase = this._configService.ISthreshold;
                this._configService.weights = lsORisData.configData.weight.filter(
                  (m: any) => m.is_selected == true
                );
                if (
                  lsORisData.configData.threshold_identifier[0].data_value !=
                  undefined ||
                  lsORisData.configData.threshold_identifier[0].data_value != null
                ) {
                  this._configService.thresholdIndex = Number(
                    lsORisData.configData.threshold_identifier[0].data_value
                  );
                  // this.weight = this._configService.weights;
                }
              }
            });

          // 1.Get All Widget Data
          let data = {
            clientName: this.selected_client, //this.clientDetails.clientDetails.client_code,
            snapshotName: this.snapshotName, //this.clientDetails.clientDetails.study,
          };

          (GetCustomSnapshotWidget && isChatResponse ? of(GetCustomSnapshotWidget) : this._configCustomService
            .getCustomSnapshotWidgetLibrary(data))
            .subscribe((r: any) => {
              if (!isChatResponse)
                this.pushChatResponseEntry('GetCustomSnapshotWidget', r);
              if (r.Data) {
                this._configService.widgetAllData = JSON.parse(r.Data);
              } else {
                this._configService.widgetAllData = [];
              }

              this._configService.snapshotProductType = 'custom';
              this._configService.selectedSnapshotType = this.promptData.Snapshot_Type; // Chnage it based on compare cross when given
              this._configService.selectedSection =
                this.widegtconfigdetails.section;
              this._configService.selectedSubSection =
                this.widegtconfigdetails.subSection;

              this._configService.setwidgetVariable(
                this._configService.widgetAllData
              );

              this.snapshotWidgetData = this._configService.widgetAllData;

              this.selectedTypeFun2('Single Brand'); //False trigerring
            });
          this.Snapshotdataforexport.compareAcross = this.promptData.Snapshot_Type;
          this.Snapshotdataforexport.snapshotName = this.promptData.Snapshot_Name;
          this.Snapshotdataforexport.compareacrossmultiplesection = this.promptData?.Snapshot_Type + " | " + this.promptData?.Section;

          (getSnapshotLoadData && isChatResponse
            ? of(getSnapshotLoadData)
            : this._configService.getSnapshotLeftPanelData(this.dataArray))
            .subscribe({
              next: (data: any) => {
                try {
                  if (!isChatResponse) {
                    this.pushChatResponseEntry('getSnapshotLoadData', data);
                  }

                  let jsonLeftPanelData = [];

                  if (data && typeof data.Data === "string" && data.Data.trim() !== "") {
                    try {
                      jsonLeftPanelData = JSON.parse(data.Data);
                    } catch (e) {
                      console.error("Invalid JSON in snapshot left panel:", e);
                      jsonLeftPanelData = [];
                    }
                  }

                  this._configService.leftPanelData = jsonLeftPanelData;

                  if (Array.isArray(jsonLeftPanelData)) {
                    let weightOptions = jsonLeftPanelData.filter(
                      (lp: any) => lp?.Level1 === "Weight Metrics"
                    );

                    this._configService.weights?.forEach((wp: any) => {
                      if (wp.variable_code === "") {
                        wp.key = wp.variable_label;
                      }
                      let wop = weightOptions.find(
                        (w1: any) => w1?.data_variable_code === wp.variable_code
                      );
                      if (wop) {
                        wp.key = wop.Level2;
                      }
                    });

                    this.weight = this._configService.weights || [];
                    this.weightSelectedValue = this.weight[0]?.key || "";
                    this._configService.weightSelected =
                      this.weight[0]?.variable_label || "";
                  }
                } catch (err) {
                  console.error("Snapshot processing error:", err);
                }
              },

              // if (data.Data !== '') {
              //   let jsonLeftPanelData = JSON.parse(data.Data);
              //   this._configService.leftPanelData = jsonLeftPanelData;
              //   //  if (this.selectedcompareacrossOption == 'Multiple Markets') {
              //   //    this._configService.brandData = jsonLeftPanelData.filter(
              //   //      (item: any) => item.Level0 === 'Markets'
              //   //    );
              //   //    jsonLeftPanelData = jsonLeftPanelData.filter(
              //   //      (item: any) => item.Level0 != 'Markets'
              //   //    );
              //   //  } else {
              //   //    this._configService.brandData = jsonLeftPanelData.filter(
              //   //      (item: any) => item.Level0 === 'Brands'
              //   //    );
              //   //  }
              //   //  jsonLeftPanelData = jsonLeftPanelData.filter(
              //   //    (item: any) => item.is_snapshot === 1
              //   //  );
              //   //  this.BindVariableDataPanel(jsonLeftPanelData);
              //   //  if (this.isSavedScenarioSelected) {
              //   //    //isZeroEntryPoint &&
              //   //    this.LoadSelectionVariableData();
              //   //  }
              //   //  //console.log('variableList', this.variableList);

              //   //  this._configService.leftPanelSelectionsData =
              //   //    this.variableList;
              //   //  this.GetUniqueSelectionsList();
              //   let weightOptions = this._configService.leftPanelData.filter(
              //     (lp: any) => lp.Level1 == 'Weight Metrics'
              //   );
              //   this._configService.weights?.forEach((wp: any) => {
              //     if (wp.variable_code == '') {
              //       wp.key = wp.variable_label;
              //     }
              //     let wop = weightOptions.find(
              //       (w1: any) => w1.data_variable_code == wp.variable_code
              //     );
              //     if (wop) {
              //       wp.key = wop.Level2;
              //     }
              //   });
              //   //  console.log(this._configService.weights);
              //   //  const variableTab = document.querySelector('.variableTab');
              //   //  if (variableTab) variableTab.classList.remove('DN');
              //   this.weight = this._configService.weights;
              //   this.weightSelectedValue = this.weight[0].key;
              //   this._configService.weightSelected =
              //   this.weight[0].variable_label;


              // }

              complete: () => {
                (GetQuery && isChatResponse ? of(GetQuery) : this.apiService
                  .getOutputData(
                    this.inputValue,
                    this.selected_client,
                    this.selected_study,
                    this.aggregatedVariables,
                    this.promptData,
                    this.weightFilter
                  ))
                  .subscribe((data) => {
                    if (!isChatResponse) {
                      this.pushChatResponseEntry('GetQuery', data);
                    }
                    this.Snapshotdataforexport.isAggregatedData = data?.datamodel?.isAggregatedData;
                    this.Snapshotdataforexport.isSemiAggregatedData = data?.datamodel?.isSemiAggregatedData;
                    this.Snapshotdataforexport.isRespondentLevel = data?.datamodel?.isRespondentLevel;
                    this.isDiagnostic = true;
                    this.inputValue = '';
                    this.snapshotDataModel = data.datamodel;
                    console.log('Snapshot Data Model is ' + this.snapshotDataModel);
                    this._configService.passdata = this.getSnapshotPassOutputData();
                    this.passOutputData = this._configService.passdata;
                    // 4. Make api call to get complete snapShot output data
                    // this._configService.selectedTPforNonTrendView = 'Year|2023'; // make it dynamic later once we've python promopt
                    this._configService.selectedTPforNonTrendView = this.promptData.s_Timeperiod[0];    // make it dynamic later once we've python promopt

                    let entryPoints1Level1 = '';
                    let entryPoints1Level2 = '';
                    if (this.promptData.s_Market && this.promptData.s_Market[0]) {
                      entryPoints1Level1 = this.promptData.s_Market[0].split('|')[0];
                      entryPoints1Level2 = this.promptData.s_Market[0].split('|')[1];
                    }
                    let entryPoints2Level1 = '';
                    let entryPoints2Level2 = '';
                    let entryPoints3Level1 = '';
                    let entryPoints3Level2 = '';
                    let variableSelectionSummary =
                      // 'Time Period :  | Brands : Brands : JP Morgan Chase';
                      `Time Period : ${this.promptData.s_Timeperiod[0]} || Brands : ${this.promptData.s_Brand[0]} ||`;
                    // let variableFilterSelectionSummary = this.promptData.s_Filter;
                    let variableFilterSelectionSummary = (this.promptData.s_Filter.length > 0 && this.promptData.s_Filter[0] != ' ') ? this.promptData.s_Filter : '';

                    this.selectionSummary =
                      `<span class="summary-label">Compare Across:</span> ${this.selectedcompareacrossOption} : ${this.selectedSection}` +
                      (this.selectedSubSection != 'NA'
                        ? ` : ${this.selectedSubSection}`
                        : ``) +
                      (entryPoints1Level1.length == 0
                        ? ''
                        : `<span class="grey-separator"> ||  </span><span class="summary-label">Entry Point:</span> ${entryPoints1Level1} ` +
                        `: ` +
                        `${entryPoints1Level2}  `) +
                      (entryPoints2Level1.length == 0
                        ? ''
                        : `</span><span class="summary-label"> | </span> ${entryPoints2Level1} ` +
                        `: ` +
                        `${entryPoints2Level2}  `) +
                      (entryPoints3Level1.length == 0
                        ? ''
                        : `</span><span class="summary-label"> | </span> ${entryPoints3Level1} ` +
                        `: ` +
                        `${entryPoints3Level2}  `) +
                      `<span class="grey-separator"> ||  </span> <span class="summary-label">Selections: </span>` +
                      variableSelectionSummary +
                      (variableFilterSelectionSummary != ''
                        ? `<span class="grey-separator"> || </span> <span class="summary-label">Filters: </span>` +
                        variableFilterSelectionSummary
                        : '');

                    this._configService.selectionSummaryText = this.selectionSummary;

                    this.selectionSummaryTitle =
                      'Compare Across: ' +
                      this.promptData.Snapshot_Type +
                      ': ' +
                      // this.promptData.Snapshot_Type+" Snapshot"  +
                      this.promptData.Section +
                      (this.selectedSubSection != 'NA'
                        ? ': ' + this.selectedSubSection
                        : '') +
                      (entryPoints1Level1.length == 0
                        ? ''
                        : ' || Entry Point: ' +
                        entryPoints1Level1 +
                        ': ' +
                        entryPoints1Level2) +
                      (entryPoints2Level1.length == 0
                        ? ''
                        : '; ' + entryPoints2Level1 + ': ' + entryPoints2Level2) +
                      (entryPoints3Level1.length == 0
                        ? ''
                        : '; ' + entryPoints3Level1 + ': ' + entryPoints3Level2) +
                      ' || Selections: ' +
                      variableSelectionSummary +
                      (variableFilterSelectionSummary != ''
                        ? ' Filters: ' + variableFilterSelectionSummary
                        : '');

                    this._configService.selectionSummaryTextTitle =
                      this.selectionSummaryTitle;
                    this.isCreateBtnClick = true;
                    if (this.isSigSelected) {
                      // add this.displaySignificance and this.baseselected in the this._configService.selectionSummaryText and its string in this._configService.selectionSummaryTextTitle
                      this._configService.selectionSummaryTextTitle =
                        this._configService.selectionSummaryTextTitle +
                        ' || Significance: ' +
                        this.displaySignificance +
                        ' || Base: ' +
                        this.baseselected +
                        ' || Weight: ' +
                        this.weightSelectedValue;
                      this._configService.selectionSummaryText =
                        this._configService.selectionSummaryText +
                        `<span class="grey-separator"> ||  </span>` +
                        `<span class="summary-label">Significance: </span>` +
                        this.displaySignificance +
                        `<span class="grey-separator"> ||  </span>` +
                        `<span class="summary-label">Base: </span>` +
                        this.baseselected +
                        `<span class="grey-separator"> ||  </span>` +
                        `<span class="summary-label">Weight: </span>` +
                        this.weightSelectedValue;
                    } else {
                      this._configService.selectionSummaryText =
                        this._configService.selectionSummaryText.replace(
                          'Index: </span>' + this.displayReference,
                          'Index: </span>' + this.displayReference
                        );
                      this._configService.selectionSummaryTextTitle =
                        this._configService.selectionSummaryTextTitle.replace(
                          'Index: ' + this.displayReference,
                          'Index: ' + this.displayReference
                        );
                    }

                    this.UpdateSelectionSummary();
                    this.getsnapShotOutputData('sig', '', isChatResponse, getSnapshotInsights, getSnapshotOutput);
                    //debugger;
                    // this.openInsights();

                  });
              }
            });

          // this.getsnapShotOutputData('', '');
        }

        // Crosstab Module
        // else {
        //   (GetQuery && isChatResponse ? of(GetQuery) : this.apiService
        //     .getOutputData(
        //       this.inputValue,
        //       this.selected_client,
        //       this.selected_study,
        //       this.aggregatedVariables,
        //       this.promptData,
        //       this.weightFilter
        //     ))
        //     .subscribe((data) => {
        //       if (!isChatResponse) {
        //         this.pushChatResponseEntry('GetQuery', data);
        //       }
        //       // this.displayTable=true;
        //       this.isDiagnostic = true;
        //       this.existingquery = this.inputValue;
        //       this.arktabaccess = false;
        //       this.inputValue = '';
        //       this.OutputdataObject.Row = [];
        //       this.OutputdataObject.Column = [];
        //       this.CrossTabOutPutData = [];
        //       //debugger;
        //       this.showSnapshot = false;
        //       // if (data != null && data.HasValidData) {
        //       if (data.outputstring != null) {
        //         // sessionStorage.setItem('ResponseData', JSON.stringify(data));
        //         // this.isExistingDataPresent=true;
        //         let outputstring = JSON.parse(data.outputstring);

        //         console.log(data);
        //         this.displayTable = true;

        //         //this.CrossTabOutPutData = JSON.parse(data.Data);
        //         this.CrossTabOutPutData = JSON.parse(outputstring.Data);
        //         console.log('output', this.CrossTabOutPutData);
        //         this.AssignDataToDataObject(data.datamodel);
        //         // this.SelectedSummary();
        //         this.SelectionSummary();

        //         this.variableTabData = this.receivedData;

        //         //this.CrossTabOutPutEntireData = JSON.parse(data.Data);
        //         this.CrossTabOutPutEntireData = JSON.parse(outputstring.Data);
        //         let chartType = 'column';
        //         chartType = this.isTranspose ? 'column' : 'bar';
        //         if (this.CrossTabOutPutEntireData.length > 0) {
        //           this.CrossTabOutPutData = this.CrossTabOutPutEntireData;
        //         }
        //         // this.isTotalBase = true;
        //         this.isTranspose = false;
        //         this.insufficientBase = '';
        //         this.DefaultConfidenceLevel = 'None';
        //         this.isAnswerBase = false;
        //         this.isSampleSize = false;
        //         this.isWeightedLabel = false;
        //         this.LowBase = '';

        //         this.isPairWise = false;
        //         this.DefaultSampleSize = 'None';
        //         this.threshold = '';
        //         this.selectedIndex = '';
        //         this.isIndex = false;
        //         this.selectedWeight = '';
        //         if (!this.isTotal) {
        //           this.CrossTabOutPutData = this.CrossTabOutPutEntireData.filter(
        //             (x: any) => {
        //               return !x.isTotal;
        //             }
        //           );
        //         }
        //         if (this.isIndex && this.selectedIndex != '') {
        //           this.manipulateIndexData();
        //         }
        //         this.BindTableOutput(this.CrossTabOutPutData);
        //         this.sortOutputData();
        //         this.isCreateBtnClick = true;
        //         sessionStorage.setItem('isarkTabAccessed', 'true');
        //         if (this.isTranspose) {
        //           // If 'isTranspose' is true, call a function to modify row column based on transpose selection
        //           this.handleOutputdataObjectOnTransposeSelect();
        //         }
        //         if (
        //           this.OutputdataObject.Row.length != 0 &&
        //           this.OutputdataObject.Column.length != 0
        //         ) {
        //           this.displayTable = true;
        //         }
        //         const columndata = this.dataObject['Column'];

        //         const TimePeriodinColumn = columndata.filter((parent) => {
        //           return parent.Data.some((child) => child.isTimePeriod === true);
        //         });

        //         this.disableLineChart =
        //           TimePeriodinColumn.length == 1 ? true : false;

        //         const rowData = this.dataObject['Row']?.[0]?.Data || [];;
        //         //
        //         const rowNestData = this.dataObject['RowNesting']?.[0]?.Data || [];
        //         const colNestData = this.dataObject['ColNesting']?.[0]?.Data || [];
        //         this.isChartView = rowNestData.length > 0 || colNestData.length > 0 ? false : (rowData.length < 15 ? true : false);
        //         this.crossTabService.setCrossTabOuputData(
        //           this.CrossTabOutPutData
        //         );
        //         if (this.isLineChartClick) {
        //           this.onTrendChartIconClick();
        //         } else if (
        //           this.isVerticalGroupBarChartClick ||
        //           this.isVerticalBarChartClick
        //         ) {
        //           this.VerticalChartClick(this.chartType);
        //         } else if (this.isVerticalStackChartClick) {
        //           this.onVerticalStackBarChartIconClick(this.chartType);
        //         }
        //         this.is_Time_Period_Present = true;
        //       }
        //       this.isInsightspopupOpen = false;
        //       this.arktabaccess = true;
        //       this.isInsightsBtnEnabled = true;
        //       this.openInsights(isChatResponse, getInsights);
        //       this.arktabaccess = false;
        //     });
        //   this.LoadRibbonData(this.filteredlist);
        // }

      }) // Use Global Varuiable for identification later
      // let mcode="";

    }
  }
  ValidateQuery(newquery: string, oldquery: string): boolean {
    let inp =
      newquery.toLowerCase().localeCompare(oldquery.toLowerCase()) === 0;
    if (inp) {
      this.inputValue = '';
    }
    return inp;
  }
  private SelectedSummary() {
    //debugger;
    let rowdata = this.dataObject['Row'][0].Data.map(
      (item) => item.Child.split('|')[1]
    );
    let coldata = this.dataObject['Column'][0].Data.map(
      (item) => item.Child.split('|')[1]
    );
    let rowparentval = this.dataObject['Row'][0].Parent;
    let colparentval =
      this.dataObject['Column'] && this.dataObject['Column'][0] !== undefined
        ? this.dataObject['Column'][0].Parent
        : '';
    let filparentval =
      this.dataObject['Filter'] && this.dataObject['Filter'][0] !== undefined
        ? this.dataObject['Filter'][0].Parent
        : '';

    var year: any;
    // Extract Filters: Markets and Year
    const markets = this.dataObject['Filter']
      .filter((f) => f.Parent === 'Market' || f.Parent === 'Markets')[0]
      .Data.map((item) => item.Child.split('|')[1]);

    if (
      this.dataObject['Filter'].filter((f) => f.Parent === 'Year').length > 0
    ) {
      year = this.dataObject['Filter']
        .filter((f) => f.Parent === 'Year')[0]
        .Data.map((item) => item.Child.split('|')[1]);
    }
    let calculationtype =
      this.isTotalBase == true ? 'Total Base' : 'Answer Base';
    // Format the result
    this.selectedData = `Study Type: ${this.selected_study
      } || Calculation Type: ${calculationtype} || Filters: ${filparentval}: ${markets.join(
        ' , '
      )}${year && year.length > 0 ? ` , Year: ${year.join(' , ')}` : ''
      } || Row: ${rowparentval}: ${rowdata.join(
        ' , '
      )} || Column: ${colparentval}: ${coldata.join(' , ')} || Confidence Level: ${this.confidenceLevel}`;
  }

  AssignDataToDataObject(datamodel: any) {
    this.dataObject.Row = datamodel.Row;
    this.dataObject.Column = datamodel.Column;
    this.dataObject.ColNesting = datamodel.ColNesting;
    this.dataObject.RowNesting = datamodel.RowNesting;
    this.dataObject.Filter = datamodel.Filter;
    this.isTotalBaseFromPrompt = datamodel.isTotalBase;
  }

  LoadRibbonData(receivedData: any) {
    //  debugger
    if (this.SampleSizeList.length == 0) {
      for (const item of receivedData.comparison_point) {
        if (item.value) {
          this.SampleSizeList.push(item);
        }
      }
    }
    this.is_indexing = receivedData.output_page[1].value;
    this.isRowNesting =
      receivedData.dataformat[0].key == 'Respondent Level'
        ? receivedData.nesting[0].is_selected
        : false;
    this.isColumnNesting = receivedData.nesting[1].is_selected;
    this.is_TransposeBtn =
      receivedData.dataformat[0].key == 'Respondent Level'
        ? receivedData.output_page[0].value
        : false;
    this.filteringAnsBlock =
      receivedData.dataformat[0].key == 'Respondent Level'
        ? receivedData.filter_function[0].value
        : false;
    this.AnsBaseBlock =
      receivedData.dataformat[0].key == 'Respondent Level'
        ? receivedData.filter_function[1].value
        : false;
    this.is_sigtesting =
      receivedData.dataformat[0].key == 'Respondent Level'
        ? receivedData.output_page[2].value
        : false;
    (this.is_brand_analysis = receivedData.is_brand_analysis),
      (this.is_chart_visualization = receivedData.is_chart_visualization),
      (this.is_sticky_selection = receivedData.is_sticky_selection),
      (this.is_reset_selection = receivedData.is_reset_selection),
      (this.is_Transpose = receivedData.output_page[0].value),
      (this.is_sigtesting = receivedData.output_page[2].value),
      (this.is_ranking = receivedData.output_page[3].value),
      (this.is_confidenceLevel = receivedData.confidence_level);
    (this.isFilterToggle = receivedData.filter_function[0].value),
      (this.isAnswerToggle = receivedData.filter_function[1].value),
      (this.excelExport = receivedData.export_download[0].value),
      // this.SampleSizeList = receivedData.comparison_point;
      //  this.pptExport= receivedData.export_download[1].value,
      (this.repository = receivedData.export_download[2].value),
      (this.lowBaseIdentifier = receivedData.export_download[3].value),
      (this.is_AI_Integration = receivedData.is_AI_Integration),
      (this.is_StoryBoard = receivedData.is_StoryBoard),
      (this.is_Column_Row_Percentage = receivedData.is_Column_Row_Percentage),
      (this.insufficentBase = receivedData.low_base_identifier[0].data_value),
      (this.lowBase = receivedData.low_base_identifier[1].data_value),
      (this.threshold = receivedData.threshold_identifier[0].data_value),
      (this.iscustomgrp = receivedData.custom_content[0].value),
      (this.iscustomCalc = receivedData.custom_content[1].value),
      (this.iscustomreport = receivedData.custom_content[2].value),
      (this.changeEntryPoint = receivedData.save_selection[1].value),
      // this.dataFormat: dataFormat.length > 0 ? dataFormat[0].key : '',
      (this.aggregatedVariables = receivedData.aggregatedvariables),
      (this.isWeightedBase =
        receivedData.aggregatedvariables[1].data_value == '' ? false : true),
      (this.isSampleSize =
        receivedData.aggregatedvariables[2].data_value == '' ? false : true),
      (this.mandatoryVariableMapping = receivedData.mandatory_variable_mapping),
      (this.isSelectAllMetrics = receivedData.is_SelectAll_Metrics);
    this.isSelectAllMetricsLevel = receivedData.isSelectAllMetrics;
    this.SampleSizeContainer =
      receivedData.dataformat[0].key == 'Respondent Level'
        ? true
        : receivedData.isWeightedBase || receivedData.isSampleSize
          ? true
          : false;
    this.isSampleSizeBlock =
      receivedData.dataformat[0].key == 'Respondent Level'
        ? true
        : receivedData.isSampleSize;
    this.isWeightedSampleBlock =
      receivedData.dataformat[0].key == 'Respondent Level'
        ? true
        : receivedData.isWeightedBase;
    this.selectedDataFormat = receivedData.dataformat[0].key;
    const noneexists = this.SampleSizeList.some(
      (item: { key: string }) => item.key === 'None'
    );
    if (!noneexists) {
      let newPair = { key: 'None', value: true };
      this.SampleSizeList.unshift(newPair);
    }
  }
  manipulateIndexData() {
    let level = 0;
    if (this.dataObject.ColNesting.length > 0) {
      level = this.dataObject.ColNesting.length;
    }
    let selectedIndexData = this.CrossTabOutPutData.filter((x: any) => {
      if (level == 1) return x.Level1ColChild == this.selectedIndex;
      else if (level == 2) return x.Level2ColChild == this.selectedIndex;
      else return x.colChild == this.selectedIndex;
    });
    if (selectedIndexData.length > 0) {
      selectedIndexData = JSON.parse(JSON.stringify(selectedIndexData));
      selectedIndexData.forEach((item: any) => {
        let indexData = this.CrossTabOutPutData.filter((x: any) => {
          if (level == 1) {
            return (
              x.rowChild == item.rowChild &&
              x.Level2RowChild == item.Level2RowChild &&
              x.Level1RowChild == item.Level1RowChild &&
              x.colChild == item.colChild
            );
          } else if (level == 2) {
            return (
              x.rowChild == item.rowChild &&
              x.Level2RowChild == item.Level2RowChild &&
              x.Level1RowChild == item.Level1RowChild &&
              x.colChild == item.colChild &&
              x.Level1ColChild == item.Level1ColChild
            );
          } else
            return (
              x.rowChild == item.rowChild &&
              x.Level2RowChild == item.Level2RowChild &&
              x.Level1RowChild == item.Level1RowChild
            );
        });
        if (indexData.length > 0) {
          indexData.forEach((indexItem: any) => {
            if (this.selectedWeight == 'Unweighted') {
              indexItem.totalUnweightedShare = isNaN(
                indexItem.totalUnweightedShare / item.totalUnweightedShare
              )
                ? null
                : isFinite(
                  indexItem.totalUnweightedShare / item.totalUnweightedShare
                )
                  ? indexItem.totalUnweightedShare / item.totalUnweightedShare
                  : null;
              indexItem.answerUnweightedShare = isNaN(
                indexItem.answerUnweightedShare / item.answerUnweightedShare
              )
                ? null
                : isFinite(
                  indexItem.answerUnweightedShare / item.answerUnweightedShare
                )
                  ? indexItem.answerUnweightedShare / item.answerUnweightedShare
                  : null;
              indexItem.totalUnweightedShare_Index =
                indexItem.totalUnweightedShare;
              indexItem.answerUnweightedShare_Index =
                indexItem.answerUnweightedShare;
            } else {
              indexItem.totalWeightedShare = isNaN(
                indexItem.totalWeightedShare / item.totalWeightedShare
              )
                ? null
                : isFinite(
                  indexItem.totalWeightedShare / item.totalWeightedShare
                )
                  ? indexItem.totalWeightedShare / item.totalWeightedShare
                  : null;
              indexItem.answerWeightedShare = isNaN(
                indexItem.answerWeightedShare / item.answerWeightedShare
              )
                ? null
                : isFinite(
                  indexItem.answerWeightedShare / item.answerWeightedShare
                )
                  ? indexItem.answerWeightedShare / item.answerWeightedShare
                  : null;
              indexItem.totalWeightedShare_Index = indexItem.totalWeightedShare;
              indexItem.answerWeightedShare_Index =
                indexItem.answerWeightedShare;
            }
          });
        }
      });
    }
  }
  onVerticalStackBarChartIconClick(chartType: string) {
    this.isData = false;
    this.isWeightedNumerator = false;
    this.isUnWeightedNumerator = false;
    this.isTableClick = false;
    this.isTableView = false;
    this.isLineChartClick = false;
    this.isVerticalStackChartClick = true;
    this.isVerticalGroupBarChartClick = false;
    this.isVerticalBarChartClick = false;
    const columndata = this.dataObject['Column'];
    this.disableStackChart = false;
    const TimePeriodinColumn = columndata.filter((parent) => {
      return parent.Data.some((child) => child.isTimePeriod === true);
    });

    this.disableLineChart = TimePeriodinColumn.length == 1 ? true : false;

    let calculatedPercentage: number | string;
    let SigNumber: number | string;
    let changePy: number | string;
    let numberType: string = 'percentage';
    const distinctColumnChildren: string[] = Array.from(
      new Set(
        this.dataObject.Column.flatMap((parent) =>
          parent.Data.map((selection) => selection.Child)
        )
      )
    );

    const distinctColChildValues: string[] = distinctColumnChildren.map(
      (child) => child.replaceAll('|', ' : ')
    );

    /*if (!this.StackChart.Data) {*/
    this.StackChart.Data = [];
    this.StackChart.Properties = [];
    /* }*/

    // Clear existing data before updating for a new chart
    this.StackChart.Data.length = 0;
    let index = 0;
    // Iterate through CrossTabOutPutData
    this.CrossTabOutPutData.forEach((item: CrossTabOutputItem) => {
      let ShareNumber = this.isTotalBase
        ? this.selectedWeight == 'Unweighted'
          ? item.totalUnweightedShare
          : item.totalWeightedShare
        : this.selectedWeight == 'Unweighted'
          ? item.answerUnweightedShare
          : item.answerWeightedShare;
      calculatedPercentage =
        item.isDerived && item.CalculationType == 'mean'
          ? ShareNumber == null
            ? 'NA'
            : Number(ShareNumber.toFixed(1))
          : ShareNumber == null
            ? 'NA'
            : Number((ShareNumber * 100).toFixed(1));
      let SignificanceValue = this.isTotalBase
        ? item.Significance_Total
        : item.Significance_Answer;
      let changevsPY = this.isTotalBase
        ? item.changeVsPY_Total
        : item.changeVsPY_Answer;

      SigNumber =
        SignificanceValue == null || isNaN(SignificanceValue)
          ? 0
          : Number(SignificanceValue.toFixed(1));

      changePy =
        changevsPY == null
          ? 'NA'
          : item.isDerived && item.CalculationType == 'mean'
            ? Number(changevsPY.toFixed(1))
            : Number((changevsPY * 100).toFixed(1));

      this.StackChart.Data.push({
        // color: this.crossTabService.customColors[index].toString(),
        'Series Name': item.rowChild.replaceAll('|', ' : '),
        'Category Name': item.colChild.replaceAll('|', ' : '),
        'Rounded Value': calculatedPercentage.toString(),
        Value: calculatedPercentage.toString(),
        Label: calculatedPercentage.toString(),
        'Change value vs PY': changePy.toString(),
        Significance: this.isTotalBase
          ? item.Significance_Total == null
            ? '0'
            : item.Significance_Total.toString()
          : item.Significance_Total == null
            ? '0'
            : item.Significance_Total.toString(),
        Significance1: this.isTotalBase
          ? item.Significance_Total == null
            ? '0'
            : item.Significance_Total.toString()
          : item.Significance_Total == null
            ? '0'
            : item.Significance_Total.toString(),
        'Sample size': this.isTotalBase
          ? item.totalUnweightedBase == null
            ? '0'
            : item.totalUnweightedBase.toString()
          : item.answerUnweightedBase == null
            ? '0'
            : item.answerUnweightedBase.toString(),
      });
      index++;
    });

    // Set the title for the chart (assuming you want to use the title from the first item)
    if (this.CrossTabOutPutData.length > 0) {
      this.StackChart.title = this.CrossTabOutPutData[0].colChild;
      numberType = this.CrossTabOutPutData[0].CalculationType;
    }

    this.StackChart.Properties.push({
      plotBands: false,
      lowSample: false,
      showNegative: false,
      allowOverlap: true,
      chartStyle: '',
      showLegend: true,
      gridlines: false,
      shadow: false,
      stacking: 0,
      darkTheme: false,
      legendPosition: 'bottom',
      axisLabelOrientation: 'horizontal',
      chartTitlePosition: 'center',
      showDataLabel: true,
      datalabelStyle: this.DefaultSampleSize == 'None' ? 'datalabel' : 'change',
      axisImage: false,
      dataLabelPosition: 'center',
      dataLabelColor: 'black',
      marker: 'disable',
      showRemaining: false,
      gradientBarColor: false,
      showPattern: false,
      dataLabelPositionPPT: 'Inside Base',
      datalabelFormat: numberType == this.CrossTabOutPutData?.[0]?.rowChild?.toLowerCase().includes('mean')
        ? ''
        : 'percentage',
      datalabelOrientation: 0,
      lineWidth: 0,
      gridLineDashStyle: '',
      markerLineWidth: 0,
      markerStyle: 'circle',
      title: '',
      toolTipStyle: 'default',
      ChartCat: distinctColChildValues,
    });

    //let distinctColChildValues = Array.from(new Set(this.CrossTabOutPutData.map((item: CrossTabOutputItem) => item.colChild.replaceAll("|", " : "))));
    chartType = this.isTranspose == true ? 'bar' : 'column';
    const distinctRowChildren: string[] = Array.from(
      new Set(
        this.dataObject.Row.flatMap((parent) =>
          parent.Data.map((selection) => selection.Child)
        )
      )
    );
    const distinctRowChildValues: string[] = distinctRowChildren.map((child) =>
      child.replaceAll('|', ' : ')
    );
    this.StackChart.Data.sort((a, b) => {
      const indexA = distinctRowChildValues.findIndex(
        (item) => item === a['Series Name']
      );
      const indexB = distinctRowChildValues.findIndex(
        (item) => item === b['Series Name']
      );
      return indexA - indexB;
    });
    let selectedSignifcance =
      this.DefaultSampleSize == 'Pairwise' ? 'None' : this.DefaultSampleSize;
    this.crossTabService.StackChartData(
      this.StackChart,
      distinctColChildValues,
      selectedSignifcance,
      this.DefaultConfidenceLevel,
      numberType,
      chartType
    );
  }
  onTrendChartIconClick() {
    this.disableLineChart = false;
    this.displayTable = false;
    this.isTableClick = false;
    this.isData = false;
    this.isWeightedNumerator = false;
    this.isUnWeightedNumerator = false;
    this.isSampleSize = false;
    this.isWeightedLabel = false;
    this.isLineChartClick = true;
    this.isVerticalStackChartClick = false;
    this.isVerticalGroupBarChartClick = false;
    this.isVerticalBarChartClick = false;

    const rowdata = this.dataObject['Row'];
    const columndata = this.dataObject['Column'];

    const isMultiPunchRow = rowdata.filter((parent) => {
      return parent.Data.some(
        (child) => child.isMultiPunch === Status.MultiPunchDisableChart
      );
    });
    const isMultiPunchColumn = columndata.filter((parent) => {
      return parent.Data.some(
        (child) => child.isMultiPunch === Status.MultiPunchDisableChart
      );
    });

    const isDefaultRespGrp = rowdata.filter((parent) => {
      return parent.Data.some(
        (child) =>
          child.CalculationType === 'RespGrp' && child.isDerviedVariable == true
      );
    });

    const isMeanMetric = rowdata.filter((parent) => {
      return parent.Data.some(
        (child) =>
          child.CalculationType.toLowerCase() === 'mean' &&
          child.isDerviedVariable == true
      );
    });

    if (rowdata.length == 1) {
      let filteredData: any = [];
      const disctinctRowValues = this.getDistinctChildValues(
        this.dataObject.Row
      );

      let distinctFirstParts = this.getDistinctValuesByPipeCount(
        disctinctRowValues,
        0
      );
      let distinctSecondParts = this.getDistinctValuesByPipeCount(
        disctinctRowValues,
        1
      );
      let distinctThirdParts = this.getDistinctValuesByPipeCount(
        disctinctRowValues,
        2
      );
      let distinctFourthParts = this.getDistinctValuesByPipeCount(
        disctinctRowValues,
        3
      );
      let distinctFifthParts = this.getDistinctValuesByPipeCount(
        disctinctRowValues,
        4
      );

      if (
        distinctFifthParts.length > 0 &&
        distinctFourthParts.length == 1 &&
        distinctThirdParts.length == 1 &&
        distinctSecondParts.length == 1 &&
        distinctFirstParts.length == 1
      ) {
        this.StackFlag = true;
      } else if (
        distinctFourthParts.length > 0 &&
        distinctThirdParts.length == 1 &&
        distinctSecondParts.length == 1 &&
        distinctFirstParts.length == 1
      ) {
        this.StackFlag = true;
      } else if (
        distinctFourthParts.length > 0 &&
        distinctThirdParts.length > 0 &&
        distinctSecondParts.length == 1 &&
        distinctFirstParts.length == 1
      ) {
        this.StackFlag = false;
      } else if (
        distinctThirdParts.length > 0 &&
        distinctSecondParts.length == 1 &&
        distinctFirstParts.length == 1
      ) {
        this.StackFlag = true;
      } else if (
        distinctThirdParts.length > 0 &&
        distinctSecondParts.length > 0 &&
        distinctFirstParts.length == 1
      ) {
        this.StackFlag = false;
      } else if (
        distinctSecondParts.length > 0 &&
        distinctFirstParts.length == 1
      ) {
        this.StackFlag = true;
      }

      if (this.StackFlag) {
        rowdata[0].Data.forEach((item) => {
          const pipeCount = (item.Child.match(/\|/g) || []).length;
          if (pipeCount === 1) {
            const [level1] = item.Child.split('|');
            filteredData = this.variableTabData.filter(
              (x: any) => x.Level1 === level1 && x.Header == 'VariableList'
            );
          } else if (pipeCount === 2) {
            const [level1, level2] = item.Child.split('|');
            filteredData = this.variableTabData.filter(
              (x: any) =>
                x.Level1 === level1 &&
                x.Level2 === level2 &&
                x.Header == 'VariableList'
            );
          } else if (pipeCount === 3) {
            const [level1, level2, level3] = item.Child.split('|');
            filteredData = this.variableTabData.filter(
              (x: any) =>
                x.Level1 === level1 &&
                x.Level2 === level2 &&
                x.level3 === level3 &&
                x.Header == 'VariableList'
            );
          } else if (pipeCount === 4) {
            const [level1, level2, level3, level4] = item.Child.split('|');
            filteredData = this.variableTabData.filter(
              (x: any) =>
                x.Level1 === level1 &&
                x.Level2 === level2 &&
                x.level3 === level3 &&
                x.level4 == level4 &&
                x.Header == 'VariableList'
            );
          } else if (pipeCount === 5) {
            const [level1, level2, level3, level4, level5] =
              item.Child.split('|');
            filteredData = this.variableTabData.filter(
              (x: any) =>
                x.Level1 === level1 &&
                x.Level2 === level2 &&
                x.level3 === level3 &&
                x.level4 == level4 &&
                x.level5 == level5 &&
                x.Header == 'VariableList'
            );
          }
        });
      } else {
        this.StackFlag = false;
      }
      this.disableStackChart =
        isMultiPunchRow.length > 0 ||
          isMultiPunchColumn.length > 0 ||
          isDefaultRespGrp.length > 0 ||
          isMeanMetric.length > 0
          ? false
          : rowdata[0].Data.length == filteredData.length
            ? true
            : false;
    }
    let calculatedPercentage: number | string;
    let SigNumber: number | string;
    let changePy: number | string;
    let numberType: string = 'percentage';

    /* if (!this.LineChart.Data) {*/
    this.LineChart.Data = [];
    this.LineChart.Properties = [];
    //}

    this.LineChart.Data.length = 0;
    const distinctColumnChildren: string[] = Array.from(
      new Set(
        this.dataObject.Column.flatMap((parent) =>
          parent.Data.map((selection) => selection.Child)
        )
      )
    );
    const distinctRowChildren: string[] = Array.from(
      new Set(
        this.dataObject.Row.flatMap((parent) =>
          parent.Data.map((selection) => selection.Child)
        )
      )
    );

    const distinctColChildValues: string[] = distinctColumnChildren.map(
      (child) => child.replaceAll('|', ' : ')
    );
    const distinctRowChildValues: string[] = distinctRowChildren.map((child) =>
      child.replaceAll('|', ' : ')
    );

    this.CrossTabOutPutData.forEach((item: CrossTabOutputItem) => {
      let ShareNumber = this.isTotalBase
        ? this.selectedWeight == 'Unweighted'
          ? item.totalUnweightedShare
          : item.totalWeightedShare
        : this.selectedWeight == 'Unweighted'
          ? item.answerUnweightedShare
          : item.answerWeightedShare;
      calculatedPercentage =
        item.isDerived && item.CalculationType == 'mean'
          ? ShareNumber == null
            ? 'NA'
            : Number(ShareNumber.toFixed(1))
          : ShareNumber == null
            ? 'NA'
            : Number((ShareNumber * 100).toFixed(1));
      let SignificanceValue = this.isTotalBase
        ? item.Significance_Total
        : item.Significance_Answer;
      let changevsPY = this.isTotalBase
        ? item.changeVsPY_Total
        : item.changeVsPY_Answer;

      SigNumber =
        SignificanceValue == null || isNaN(SignificanceValue)
          ? 0
          : Number(SignificanceValue.toFixed(1));

      changePy =
        changevsPY == null
          ? 'NA'
          : item.isDerived && item.CalculationType == 'mean'
            ? Number(changevsPY.toFixed(1))
            : Number((changevsPY * 100).toFixed(1));

      this.LineChart.Data.push({
        'Series Name': item.rowChild.replaceAll('|', ' : '),
        'Category Name': item.colChild.replaceAll('|', ' : '),
        'Rounded Value': ShareNumber == null ? 'NA' : calculatedPercentage,
        XValue: '0',
        Value: calculatedPercentage,
        Label: calculatedPercentage.toString(),
        'Change value vs PY': changePy,
        Significance: this.isTotalBase
          ? item.Significance_Total == null
            ? 0
            : item.Significance_Total
          : item.Significance_Total == null
            ? 0
            : item.Significance_Total,
        'Sample Size': this.isTotalBase
          ? item.totalUnweightedBase == null
            ? 0
            : item.totalUnweightedBase
          : item.answerUnweightedBase == null
            ? 0
            : item.answerUnweightedBase,
      });
    });

    // Set the title for the chart (assuming you want to use the title from the first item)
    if (this.CrossTabOutPutData.length > 0) {
      this.LineChart.title = this.CrossTabOutPutData[0].colChild;
      numberType = this.CrossTabOutPutData[0].CalculationType;
    }

    this.LineChart.Properties.push({
      plotBands: false,
      lowSample: false,
      showNegative: false,
      allowOverlap: false,
      chartStyle: 'area',
      showLegend: true,
      gridlines: false,
      legendPosition: 'bottom',
      stacking: 0,
      darkTheme: false,
      axisLabelOrientation: 'center',
      chartTitlePosition: 'center',
      showDataLabel: true,
      datalabelFormat: numberType == this.CrossTabOutPutData?.[0]?.rowChild?.toLowerCase().includes('mean')
        ? 'number'
        : 'percentage',
      dataLabelPosition: 'center',
      dataLabelColor: 'black',
      marker: 'disable',
      showRemaining: false,
      gradientBarColor: false,
      showPattern: false,
      dataLabelPositionPPT: 'center',
      datalabelStyle: this.DefaultSampleSize == 'None' ? '' : 'sigchan',
      datalabelOrientation: 0,
      axisImage: false,
      lineWidth: 2,
      gridLineDashStyle: 'Solid',
      markerLineWidth: 1,
      markerStyle: 'circle',
      title: 'LineChart',
      shadow: false,
      toolTipStyle: 'default',
      ChartCat: distinctColChildValues,
    });

    this.LineChart.Data.sort((a, b) => {
      const indexA = distinctRowChildValues.findIndex(
        (item) => item === a['Series Name']
      );
      const indexB = distinctRowChildValues.findIndex(
        (item) => item === b['Series Name']
      );
      return indexA - indexB;
    });
    let selectedSignifcance =
      this.DefaultSampleSize == 'Pairwise' ? 'None' : this.DefaultSampleSize;
    this.crossTabService.LineChartData(
      this.LineChart,
      distinctColChildValues,
      selectedSignifcance,
      this.DefaultConfidenceLevel,
      numberType,
      ''
    );
  }
  getDistinctChildValues(data: checkboxSelectionWithParent[]): string[] {
    const distinctChildValues: string[] = [];

    data.forEach((item) => {
      item.Data.forEach((checkbox) => {
        if (!distinctChildValues.includes(checkbox.Child)) {
          distinctChildValues.push(checkbox.Child);
        }
      });
    });

    return distinctChildValues;
  }
  onVerticalBarChartIconClick(
    chartType: string,
    distinctColChildValues: string[]
  ) {
    // debugger
    this.isVerticalBarChartClick = true;
    this.isVerticalGroupBarChartClick = false;
    let calculatedPercentage: number | string;
    let SigNumber: number | string;
    let changePy: number | string;
    let numberType: string = 'percentage';
    let index = 1;
    /*if (!this.BarChart.Data) {*/
    this.BarChart.Data = [];
    this.BarChart.Properties = [];
    /* }*/

    this.BarChart.Data.length = 0;

    this.CrossTabOutPutData.forEach((item: CrossTabOutputItem) => {
      let ShareNumber = this.isTotalBase
        ? this.selectedWeight == 'Unweighted'
          ? item.totalUnweightedShare
          : item.totalWeightedShare
        : this.selectedWeight == 'Unweighted'
          ? item.answerUnweightedShare
          : item.answerWeightedShare;
      calculatedPercentage =
        item.isDerived && item.CalculationType == 'mean'
          ? ShareNumber == null
            ? 'NA'
            : Number(ShareNumber.toFixed(1))
          : ShareNumber == null
            ? 'NA'
            : Number((ShareNumber * 100).toFixed(1));
      let SignificanceValue = this.isTotalBase
        ? item.Significance_Total
        : item.Significance_Answer;
      let changevsPY = this.isTotalBase
        ? item.changeVsPY_Total
        : item.changeVsPY_Answer;

      SigNumber =
        SignificanceValue == null || isNaN(SignificanceValue)
          ? 0
          : Number(SignificanceValue.toFixed(1));

      changePy =
        changevsPY == null
          ? 'NA'
          : item.isDerived && item.CalculationType == 'mean'
            ? Number(changevsPY.toFixed(1))
            : Number((changevsPY * 100).toFixed(1));

      this.BarChart.Data.push({
        'Series Name': item.rowChild.replaceAll('|', ' : '),
        'Category Name': item.colChild.replaceAll('|', ' : '),
        'Rounded Value':
          ShareNumber == null ? 'NA' : calculatedPercentage.toString(),
        Value: ShareNumber == null ? 'NA' : calculatedPercentage.toString(),
        XValue: index.toString(),
        Label: ShareNumber == null ? 'NA' : calculatedPercentage.toString(),
        'Change value vs PY': changePy.toString(),
        Significance: this.isTotalBase
          ? item.Significance_Total == null
            ? '0'
            : item.Significance_Total.toString()
          : item.Significance_Total == null
            ? '0'
            : item.Significance_Total.toString(),
        Significance2: this.isTotalBase
          ? item.Significance_Total == null
            ? '0'
            : item.Significance_Total.toString()
          : item.Significance_Total == null
            ? '0'
            : item.Significance_Total.toString(),
        'Sample size': this.isTotalBase
          ? item.totalUnweightedBase == null
            ? '0'
            : item.totalUnweightedBase.toString()
          : item.answerUnweightedBase == null
            ? '0'
            : item.answerUnweightedBase.toString(),
      });
      index++;
    });

    if (this.CrossTabOutPutData.length > 0) {
      this.BarChart.title = this.CrossTabOutPutData[0].colChild;
      numberType = this.CrossTabOutPutData[0].CalculationType;
    }
    const distinctRowChildren: string[] = Array.from(
      new Set(
        this.dataObject.Row.flatMap((parent) =>
          parent.Data.map((selection) => selection.Child)
        )
      )
    );
    const distinctRowChildValues: string[] = distinctRowChildren.map((child) =>
      child.replaceAll('|', ' : ')
    );
    this.BarChart.Properties.push({
      plotBands: false,
      lowSample: false,
      showNegative: false,
      allowOverlap: false,
      chartStyle: '',
      showLegend: true,
      gridlines: false,
      legendPosition: 'bottom',
      stacking: 0,
      darkTheme: false,
      axisLabelOrientation: 'horizontal',
      chartTitlePosition: 'center',
      showDataLabel: true,
      datalabelFormat: numberType == this.CrossTabOutPutData?.[0]?.rowChild?.toLowerCase().includes('mean')
        ? ''
        : 'percentage',
      dataLabelPosition: 'Center',
      dataLabelColor: 'black',
      marker: 'disable',
      showRemaining: false,
      gradientBarColor: false,
      showPattern: false,
      dataLabelPositionPPT: 'center',
      datalabelStyle: this.DefaultSampleSize == 'None' ? 'default' : 'change',
      datalabelOrientation: 0,
      axisImage: false,
      lineWidth: 0,
      gridLineDashStyle: '',
      markerLineWidth: 0,
      markerStyle: 'circle',
      title: '',
      shadow: false,
      toolTipStyle: 'default',
      ChartCat: distinctColChildValues,
    });

    chartType = this.isTranspose == true ? 'bar' : 'column';

    this.BarChart.Data.sort((a, b) => {
      const indexA = distinctRowChildValues.findIndex(
        (item) => item === a['Series Name']
      );
      const indexB = distinctRowChildValues.findIndex(
        (item) => item === b['Series Name']
      );
      return indexA - indexB;
    });
    let selectedSignifcance =
      this.DefaultSampleSize == 'Pairwise' ? 'None' : this.DefaultSampleSize;
    this.crossTabService.ChartData(
      this.BarChart,
      distinctColChildValues,
      selectedSignifcance,
      this.DefaultConfidenceLevel,
      numberType,
      chartType
    );
  }
  onGroupVerticalChartClick(
    chartType: string,
    distinctColChildValues: string[]
  ) {
    this.isVerticalBarChartClick = false;
    this.isVerticalGroupBarChartClick = true;
    let calculatedPercentage: number | string;
    let SigNumber: number | string;
    let changePy: number | string;
    let numberType: string = 'percentage';

    /* if (!this.BarChart.Data || !this.BarChart.Properties) {*/
    this.BarChart.Data = [];
    this.BarChart.Properties = [];
    /*  }*/

    this.BarChart.Data.length = 0;

    this.CrossTabOutPutData.forEach((item: CrossTabOutputItem) => {
      let ShareNumber = this.isTotalBase
        ? this.selectedWeight == 'Unweighted'
          ? item.totalUnweightedShare
          : item.totalWeightedShare
        : this.selectedWeight == 'Unweighted'
          ? item.answerUnweightedShare
          : item.answerWeightedShare;
      calculatedPercentage =
        item.isDerived && item.CalculationType == 'mean'
          ? ShareNumber == null
            ? 'NA'
            : Number(ShareNumber.toFixed(1))
          : ShareNumber == null
            ? 'NA'
            : Number((ShareNumber * 100).toFixed(1));
      let SignificanceValue = this.isTotalBase
        ? item.Significance_Total
        : item.Significance_Answer;
      let changevsPY = this.isTotalBase
        ? item.changeVsPY_Total
        : item.changeVsPY_Answer;

      SigNumber =
        SignificanceValue == null || isNaN(SignificanceValue)
          ? 0
          : Number(SignificanceValue.toFixed(1));

      changePy =
        changevsPY == null
          ? 'NA'
          : item.isDerived && item.CalculationType == 'mean'
            ? Number(changevsPY.toFixed(1))
            : Number((changevsPY * 100).toFixed(1));

      this.BarChart.Data.push({
        'Series Name': item.rowChild.replaceAll('|', ' : '),
        'Category Name': item.colChild.replaceAll('|', ' : '),
        'Rounded Value':
          ShareNumber == null ? 'NA' : calculatedPercentage.toString(),
        Value: ShareNumber == null ? 'NA' : calculatedPercentage.toString(),
        XValue: '1',
        Label: ShareNumber == null ? 'NA' : calculatedPercentage.toString(),
        'Change value vs PY': changePy.toString(),
        Significance: this.isTotalBase
          ? item.Significance_Total == null
            ? '0'
            : item.Significance_Total.toString()
          : item.Significance_Total == null
            ? '0'
            : item.Significance_Total.toString(),
        Significance2: this.isTotalBase
          ? item.Significance_Total == null
            ? '0'
            : item.Significance_Total.toString()
          : item.Significance_Total == null
            ? '0'
            : item.Significance_Total.toString(),
        'Sample size': this.isTotalBase
          ? item.totalUnweightedBase == null
            ? '0'
            : item.totalUnweightedBase.toString()
          : item.answerUnweightedBase == null
            ? '0'
            : item.answerUnweightedBase.toString(),
      });
    });

    // Set the title for the chart (assuming you want to use the title from the first item)
    if (this.CrossTabOutPutData.length > 0) {
      this.BarChart.title = this.CrossTabOutPutData[0].colChild;
      numberType = this.CrossTabOutPutData[0].CalculationType;
    }
    const distinctRowChildren: string[] = Array.from(
      new Set(
        this.dataObject.Row.flatMap((parent) =>
          parent.Data.map((selection) => selection.Child)
        )
      )
    );
    const distinctRowChildValues: string[] = distinctRowChildren.map((child) =>
      child.replaceAll('|', ' : ')
    );

    this.BarChart.Properties.push({
      plotBands: false,
      lowSample: false,
      showNegative: false,
      allowOverlap: false,
      chartStyle: '',
      showLegend: true,
      gridlines: false,
      shadow: false,
      stacking: 0,
      darkTheme: false,
      legendPosition: 'bottom',
      axisLabelOrientation: 'horizontal',
      chartTitlePosition: 'center',
      showDataLabel: true,
      datalabelStyle: this.DefaultSampleSize == 'None' ? 'datalabel' : 'change',
      axisImage: false,
      dataLabelPosition: 'center',
      dataLabelColor: 'black',
      marker: 'disable',
      showRemaining: false,
      gradientBarColor: false,
      showPattern: false,
      dataLabelPositionPPT: 'Center',
      datalabelFormat: numberType == this.CrossTabOutPutData?.[0]?.rowChild?.toLowerCase().includes('mean')
        ? ''
        : 'percentage',
      datalabelOrientation: 0,
      lineWidth: 0,
      gridLineDashStyle: '',
      markerLineWidth: 0,
      markerStyle: 'circle',
      title: '',
      toolTipStyle: 'default',
      ChartCat: distinctColChildValues,
    });

    //let distinctColChildValues = Array.from(new Set(this.CrossTabOutPutData.map((item: CrossTabOutputItem) => item.colChild.replaceAll("|", " : "))));
    chartType = this.isTranspose == true ? 'bar' : 'column';

    this.BarChart.Data.sort((a, b) => {
      const indexA = distinctRowChildValues.findIndex(
        (item) => item === a['Series Name']
      );
      const indexB = distinctRowChildValues.findIndex(
        (item) => item === b['Series Name']
      );
      return indexA - indexB;
    });
    let selectedSignifcance =
      this.DefaultSampleSize == 'Pairwise' ? 'None' : this.DefaultSampleSize;
    this.crossTabService.GrpChartData(
      this.BarChart,
      distinctColChildValues,
      selectedSignifcance,
      this.DefaultConfidenceLevel,
      numberType,
      chartType
    );
  }

  VerticalChartClick(chartType: string) {
    this.displayTable = false;
    this.isTableClick = false;
    this.isData = false;
    this.isSampleSize = false;
    this.isWeightedNumerator = false;
    this.isUnWeightedNumerator = false;
    this.isWeightedLabel = false;
    this.isLineChartClick = false;
    this.isVerticalStackChartClick = false;
    const rowdata = this.dataObject['Row'];
    const columndata = this.dataObject['Column'];
    this.isVerticalBarChartClick = true;

    const isMultiPunchRow = rowdata.filter((parent) => {
      return parent.Data.some(
        (child) => child.isMultiPunch === Status.MultiPunchDisableChart
      );
    });
    const isMultiPunchColumn = columndata.filter((parent) => {
      return parent.Data.some(
        (child) => child.isMultiPunch === Status.MultiPunchDisableChart
      );
    });

    const isDefaultRespGrp = rowdata.filter((parent) => {
      return parent.Data.some(
        (child) =>
          child.CalculationType === 'RespGrp' && child.isDerviedVariable == true
      );
    });

    const isMeanMetric = rowdata.filter((parent) => {
      return parent.Data.some(
        (child) =>
          child.CalculationType.toLowerCase() === 'mean' &&
          child.isDerviedVariable == true
      );
    });

    if (rowdata.length == 1) {
      let filteredData: any = [];
      const disctinctRowValues = this.getDistinctChildValues(
        this.dataObject.Row
      );

      let distinctFirstParts = this.getDistinctValuesByPipeCount(
        disctinctRowValues,
        0
      );
      let distinctSecondParts = this.getDistinctValuesByPipeCount(
        disctinctRowValues,
        1
      );
      let distinctThirdParts = this.getDistinctValuesByPipeCount(
        disctinctRowValues,
        2
      );
      let distinctFourthParts = this.getDistinctValuesByPipeCount(
        disctinctRowValues,
        3
      );
      let distinctFifthParts = this.getDistinctValuesByPipeCount(
        disctinctRowValues,
        4
      );

      if (
        distinctFifthParts.length > 0 &&
        distinctFourthParts.length == 1 &&
        distinctThirdParts.length == 1 &&
        distinctSecondParts.length == 1 &&
        distinctFirstParts.length == 1
      ) {
        this.StackFlag = true;
      } else if (
        distinctFourthParts.length > 0 &&
        distinctThirdParts.length == 1 &&
        distinctSecondParts.length == 1 &&
        distinctFirstParts.length == 1
      ) {
        this.StackFlag = true;
      } else if (
        distinctFourthParts.length > 0 &&
        distinctThirdParts.length > 0 &&
        distinctSecondParts.length == 1 &&
        distinctFirstParts.length == 1
      ) {
        this.StackFlag = false;
      } else if (
        distinctThirdParts.length > 0 &&
        distinctSecondParts.length == 1 &&
        distinctFirstParts.length == 1
      ) {
        this.StackFlag = true;
      } else if (
        distinctThirdParts.length > 0 &&
        distinctSecondParts.length > 0 &&
        distinctFirstParts.length == 1
      ) {
        this.StackFlag = false;
      } else if (
        distinctSecondParts.length > 0 &&
        distinctFirstParts.length == 1
      ) {
        this.StackFlag = true;
      }

      if (this.StackFlag) {
        rowdata[0].Data.forEach((item) => {
          const pipeCount = (item.Child.match(/\|/g) || []).length;
          if (pipeCount === 1) {
            const [level1] = item.Child.split('|');
            filteredData = this.variableTabData.filter(
              (x: any) => x.Level1 === level1 && x.Header == 'VariableList'
            );
          } else if (pipeCount === 2) {
            const [level1, level2] = item.Child.split('|');
            filteredData = this.variableTabData.filter(
              (x: any) =>
                x.Level1 === level1 &&
                x.Level2 === level2 &&
                x.Header == 'VariableList'
            );
          } else if (pipeCount === 3) {
            const [level1, level2, level3] = item.Child.split('|');
            filteredData = this.variableTabData.filter(
              (x: any) =>
                x.Level1 === level1 &&
                x.Level2 === level2 &&
                x.level3 === level3 &&
                x.Header == 'VariableList'
            );
          } else if (pipeCount === 4) {
            const [level1, level2, level3, level4] = item.Child.split('|');
            filteredData = this.variableTabData.filter(
              (x: any) =>
                x.Level1 === level1 &&
                x.Level2 === level2 &&
                x.level3 === level3 &&
                x.level4 == level4 &&
                x.Header == 'VariableList'
            );
          } else if (pipeCount === 5) {
            const [level1, level2, level3, level4, level5] =
              item.Child.split('|');
            filteredData = this.variableTabData.filter(
              (x: any) =>
                x.Level1 === level1 &&
                x.Level2 === level2 &&
                x.level3 === level3 &&
                x.level4 == level4 &&
                x.level5 == level5 &&
                x.Header == 'VariableList'
            );
          }
        });
      } else {
        this.StackFlag = false;
      }
      this.disableStackChart =
        isMultiPunchRow.length > 0 ||
          isMultiPunchColumn.length > 0 ||
          isDefaultRespGrp.length > 0 ||
          isMeanMetric.length > 0
          ? false
          : rowdata[0].Data.length == filteredData.length
            ? true
            : false;
    }

    // const rowDataLength: number =
    //   rowdata.length > 0 ? rowdata[0].Data.length : 0;
    const rowDataLength: number = rowdata.length > 1 ? rowdata.length : rowdata[0]?.Data?.length || 0;

    //if (this.isTranspose) {
    //  this.handleOutputdataObjectOnTransposeSelect();
    //}
    //else {
    //  let tempRow = [...this.OutputdataObject.Row];
    //  let tempColumn = [...this.OutputdataObject.Column];

    //  // Swap rows and columns to transpose the data
    //  this.OutputdataObject.Row = [...tempRow];
    //  this.OutputdataObject.Column = [...tempColumn];
    //}

    const distinctColumnChildren: string[] = Array.from(
      new Set(
        this.dataObject.Column.flatMap((parent) =>
          parent.Data.map((selection) => selection.Child)
        )
      )
    );

    const distinctColChildValues: string[] = distinctColumnChildren.map(
      (child) => child.replaceAll('|', ' : ')
    );

    const TimePeriodinColumn = columndata.filter((parent) => {
      return parent.Data.some((child) => child.isTimePeriod === true);
    });

    this.disableLineChart = TimePeriodinColumn.length == 1 ? true : false;

    if (rowDataLength == 1) {
      this.onVerticalBarChartIconClick(chartType, distinctColChildValues);
    } else {
      this.onGroupVerticalChartClick(chartType, distinctColChildValues);
    }
  }
  getDistinctValuesByPipeCount(data: string[], pipeCount: number): string[] {
    const distinctValues = new Set<string>();
    data.forEach((item) => {
      const total = (item.match(/\|/g) || []).length;
      if (pipeCount <= total) {
        const parts = item.split('|')[pipeCount];
        distinctValues.add(parts.trim());
      }
    });
    return Array.from(distinctValues);
  }
  handleOutputdataObjectOnTransposeSelect() {
    if (
      this.OutputdataObject != null &&
      (this.OutputdataObject['Row'].length > 0 ||
        this.OutputdataObject['Column'].length > 0)
    ) {
      // Create copies of rows and columns arrays to preserve the original data
      let tempRow = [...this.OutputdataObject.Row];
      let tempColumn = [...this.OutputdataObject.Column];

      // Swap rows and columns to transpose the data
      this.OutputdataObject.Row = [...tempColumn];
      this.OutputdataObject.Column = [...tempRow];
    }
  }
  openInsights(isChatResponse = false, getInsights?: any) {
    // Close export popup if open
    this.isExportspopup = false;

    // Toggle logic: close if already open
    if (this.isInsightspopupOpen) {
      this.isInsightspopupOpen = false;
      return;
    }

    const insightsObj: InsightsModel = {
      header: 'Insights',
      message: '',
      show: false,
    };
    this._insightsSerive.showInisghts(insightsObj);

    const ShareColumn = (this.selectedDataFormat !== 'Respondent Level')
      ? 'value'
      : (this.isTotalBase
        ? (this.selectedWeight === 'Unweighted' ? 'totalUnweightedShare' : 'totalWeightedShare')
        : (this.selectedWeight === 'Unweighted' ? 'answerUnweightedShare' : 'answerWeightedShare'));

    const BaseColumn = this.isTotalBase
      ? 'totalUnweightedBase'
      : 'answerUnweightedBase';

    this.isInsightspopupOpen = true;

    let accumulatedResult = '';
    let streamingInsights: string[] = [];
    let isFirstChunk = true;

    // Update UI with partial insights
    const updateStreamingUI = () => {
      const parts = accumulatedResult
        .split('- ')
        .map(item => item.trim())
        .filter(item => item.length > 0 && !item.startsWith('```'))
        .map(item => item.replace(/```$/, '').trim());

      // Only update if we have new parts
      if (parts.length > streamingInsights.length) {
        streamingInsights = parts;
        this.insightsVal = [...streamingInsights]; // Trigger change detection

        // Show popup on first real content
        if (isFirstChunk && streamingInsights.length > 0) {
          const showObj: InsightsModel = {
            header: 'Insights',
            message: '',
            show: true,
          };
          this._insightsSerive.showInisghts(showObj);
          isFirstChunk = false;
        }

  
        // Wait for the animation to start before scrolling
        setTimeout(() => {
          if (this.insightsContainer?.nativeElement) {
            // Find all insight items
            const insightItems = this.insightsContainer.nativeElement.querySelectorAll('.insight-item');
            
            if (insightItems.length > 0) {
              // Scroll the last (newest) insight into view smoothly
              const lastInsight = insightItems[insightItems.length - 1];
              
              
              const animationDelay = (insightItems.length - 1) * 200;
              setTimeout(() => {
                lastInsight.scrollIntoView({ 
                  behavior: 'smooth', 
                  block: 'end',
                  inline: 'nearest'
                });
              }, animationDelay); 
            }
          }
        }, 50);
      }
    };

    // Start streaming after small delay
    setTimeout(() => {
      const insightsObservable = getInsights && isChatResponse
        ? of(getInsights)
        : this.crossTabService.getInsightsData(
          this.CrossTabOutPutData,
          this.selected_study,
          this.selected_client,
          this.selectionSummary,
          this.DefaultConfidenceLevel,
          ShareColumn,
          BaseColumn
        );

      insightsObservable.subscribe({
        next: (chunk: string) => {
          accumulatedResult += chunk;
          updateStreamingUI(); // Live update UI
        },

        complete: () => {
          console.log('Final accumulated result:', accumulatedResult);

          if (!isChatResponse) {
            this.pushChatResponseEntry('getInsights', accumulatedResult);
            this.saveChatList(this.chatPreviewBlocks.length > 0 ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question : this.inputValue, this.chatResponse);
            this.chatResponse = [];
          }

          if (!accumulatedResult || accumulatedResult.trim().length === 0) {
            this.insightsVal = this.fallbackMessage();
            this.failedCase = true;
            return;
          }

          const finalInsights = accumulatedResult
            .split('- ')
            .map(item => item.trim())
            .filter(item => item.length > 0 && !item.startsWith('```'))
            .map(item => item.replace(/```$/, '').trim());

          this.insightsVal = finalInsights;

          const finalInsightsObj: InsightsModel = {
            header: 'Insights',
            message: accumulatedResult,
            show: true,
          };
          this._insightsSerive.showInisghts(finalInsightsObj);
          this.arktabaccess = false; // Stop loader
        },

        error: (err) => {
          console.error('Error fetching insights:', err);
          this.insightsVal = this.fallbackMessage();
          this.failedCase = true;
          this.isInsightspopupOpen = true;

          const errorObj: InsightsModel = {
            header: 'Insights',
            message: '',
            show: true,
          };
          this._insightsSerive.showInisghts(errorObj);
          this.arktabaccess = false; // Stop loader
        },
      });
    }, 500);
  }

  // openInsights() {
  //   this.apiService
  //     .getChatBotInsightsData(
  //       this.CrossTabOutPutData,
  //       this.selected_study,
  //       this.selected_client,
  //       this.isTotalBaseFromPrompt
  //     )
  //     .subscribe((result: string) => {
  //       // Response is valid
  //       // this.errorPopup(result, "Insights for the Generated Ouptput data")
  //       // let insightsData = JSON.parse(result.Data);
  //       // this.InsightsData = insightsData;
  //       if (!this.showSnapshot) {
  //         this.isInsightspopupOpen = true;
  //       }
  //       // this.insightsVal = result;

  //       const insightData = result
  //         .split('- ')
  //         .map((item) => item.trim())
  //         .filter((item) => item.length > 0);

  //       this.insightsVal = insightData;
  //       //hide the loader
  //       // this.Loader.hideLoader();
  //     });
  // }
  selectionSummaryBlock(): void {
    this.isSelectionSummary = !this.isSelectionSummary;
    console.log('Selection Summary toggled:', this.isSelectionSummary);
    console.log('Selection Summary content:', this.selectionSummary);
    console.log('isCreateBtnClick:', this.isCreateBtnClick);
    console.log('failedCase:', this.failedCase);
  }


  SelectionsummaryCollapseExpand(text: any) {


    this.isselectionsummarycollapse = true;
    setTimeout(() => {
      this.isselectionsummarycollapse2 = true;
    }, 300);
    if (text == 'SelectionSummary') {
      this.isselectionHeader = "Selection Summary";
      this.issavedselectionblock = false;
    }
    else {
      this.isselectionHeader = "Save Selections";
      this.issavedselectionblock = true;
      this.SaveSelectiontext = '';
    }

    if (this.showSnapshot) {
      this.GenerateSelectionSummary()
    }
    else {
      const disctinctRowValues = this.getDistinctChildValues(this.dataObject.Row);
      const disctinctRowNestingValues = this.getDistinctChildValues(this.dataObject.RowNesting);
      const disctinctColumnValues = this.getDistinctChildValues(this.dataObject.Column);
      const disctinctColumnNestingValues = this.getDistinctChildValues(this.dataObject.ColNesting);
      const FilterValues = this.getDistinctChildValues(this.dataObject.Filter);

      const RowValues = this.transformData(disctinctRowValues);
      const RowNestingValues = this.transformData(disctinctRowNestingValues);
      const ColumnValues = this.transformData(disctinctColumnValues);
      const ColumnNestingValues = this.transformData(disctinctColumnNestingValues);
      const FilterData = this.transformData(FilterValues);
      let isSavedSelection = false
      this.Columnselections = [];
      this.Rowselections = [];
      this.AllSelections = [];

      this.Columnselections = ColumnValues.map(item => {
        const [key, ...valueParts] = item.split(':');
        return {
          key: key.trim(),
          value: valueParts.join(':').trim() // handles if colon appears in value
        };
      });

      this.Rowselections = RowValues.map(item => {
        const [key, ...valueParts] = item.split(':');
        return {
          key: key.trim(),
          value: valueParts.join(':').trim() // handles if colon appears in value
        };
      });

      if (FilterData.length > 0) {
        this.AllSelections = FilterData.map(item => {
          const [key, ...valueParts] = item.split(':');
          return {
            key: key.trim(),
            value: valueParts.join(':').trim() // handles if colon appears in value
          };
        });
      }

      if (RowNestingValues.length > 0) {
        let rowNestingSection = RowNestingValues.join(
          '&nbsp;,&nbsp;'
        );
        this.AllSelections.push({
          key: 'Row Nesting',
          value: rowNestingSection
        });
      }
      if (ColumnNestingValues.length > 0) {
        let colNestSection = ColumnNestingValues.join(
          '&nbsp;,&nbsp;'
        );
        this.AllSelections.push({
          key: 'Column Nesting',
          value: colNestSection
        });
      }

      if (!isSavedSelection && this.selectedDataFormat == 'Respondent Level') {
        let significanceSection;
        if (this.SignificanceVsReference != '') {
          significanceSection = `${this.DefaultSampleSize
            } : ${this.replacePipe(
              this.SignificanceVsReference
            )}`;
        } else {
          significanceSection = this.DefaultSampleSize;
        }
        this.AllSelections.push({
          key: 'Significance',
          value: significanceSection
        });

        this.AllSelections.push({
          key: 'Confidence Level',
          value: this.DefaultConfidenceLevel
        });
      }

      if (
        this.selectedIndex != '' &&
        this.isIndex &&
        this.selectedDataFormat == 'Respondent Level'
      ) {
        let Reference = `${this.replacePipe(
          this.selectedIndex
        )}`;

        this.AllSelections.push({
          key: 'Reference',
          value: Reference
        });
      }
      if (
        this.DefaultWeight != '' &&
        this.selectedDataFormat == 'Respondent Level'
      ) {
        this.AllSelections.push({
          key: 'Calculation Weight',
          value: this.DefaultWeight
        });
      }
      if (this.selectedDataFormat == 'Respondent Level') {
        let Base = `${this.isTotalBase ? 'Total Base' : 'Answer Base'
          }`;
        this.AllSelections.push({
          key: 'Calculation Base',
          value: Base
        });
      }
    }

  }

  OnCloseClick() {
    setTimeout(() => {
      this.isselectionsummarycollapse = false;
    }, 500);
    this.isselectionsummarycollapse2 = false;
    this.issavedselectionblock = false;
  }
  onKeyDown(event: KeyboardEvent): void {
    // Get the pressed key
    const pressedKey = event.key;

    // Allow alphanumeric characters, space, and backspace; prevent other keys

    //onst isValidKey = /^[A-Za-z0-9\s\-_]+$/.test(pressedKey);

    //const isValidKey = /^[^\s@]+$/.test(pressedKey);
    const isValidKey = /^[^\@]+$/.test(pressedKey) || pressedKey === ' ';

    if (!isValidKey) {
      event.preventDefault();
    }
  }

  // SaveSelectionClick() {
  //   this.isselectionsummarycollapse = false;
  //   this.isselectionsummarycollapse2 = false;
  //   if (this.SaveSelectiontext == '') {
  //     this.errorPopup('Selection name cannot be empty.');
  //   } else {
  //     this.SaveSelection({
  //       isValidationPass: true,
  //       selectionName: this.SaveSelectiontext,
  //       isShareSelection: false, //this is for save selection
  //       selectionType: 'userDefined', //only user defined can be saved
  //     });
  //   }
  // }

  redirectToLandingPage() {
    this.router.navigate(['/landing']);
  }

  Exportspopup() {
    this.isExportspopup = !this.isExportspopup;
  }


  SaveSelection: string = '';
  // selectionSummary : String = '';
  headerText: String = "";

  // New structured data model
  titleSection: { key: string, value: string }[] = [];
  entryPoints: { key: string, value: string }[] = [];
  selections: { key: string, value: string }[] = [];
  GenerateSelectionSummary() {
    // Clear existing data
    this.titleSection = [];
    this.entryPoints = [];
    this.selections = [];
    this.selectionSummary = this._configService.selectionSummaryTextTitle;
    // this.headerText = this.Header;

    let selectionSummaryArray = this.selectionSummary.split("||");

    // Process the selectionSummary string
    for (let i = 0; i < selectionSummaryArray.length; i++) {
      let section = selectionSummaryArray[i].trim();

      if (section.startsWith("Compare Across:")) {
        // Handle the title section
        const titleContent = section.replace("Compare Across:", "").trim();

        // Parse the title content (e.g., "Single Brand: Brand Scorecard")
        const titleParts = titleContent.split(":");
        if (titleParts.length > 1) {
          this.titleSection.push({
            key: titleParts[0].trim(),
            value: titleParts.slice(1).join(":").trim()
          });
        } else {
          // In case there's no colon in the title
          this.titleSection.push({
            key: "",
            value: titleContent
          });
        }
      }
      else if (section.startsWith("Entry Point:")) {
        // Handle Entry Points section
        const entryPointContent = section.replace("Entry Point:", "").trim();
        const entryPointItems = entryPointContent.split(";");

        for (let item of entryPointItems) {
          item = item.trim();
          if (item) {
            const itemParts = item.split(":");
            if (itemParts.length > 1) {
              this.entryPoints.push({
                key: itemParts[0].trim(),
                value: itemParts.slice(1).join(":").trim()
              });
            }
          }
        }
      }
      else if (section.startsWith("Selections:")) {
        // Handle Selections section
        let selectionsText = section.replace("Selections:", "").trim();
        // let selectionItems = selectionsText.split("|");
        let selectionItems = [selectionsText];
        for (let item of selectionItems) {
          item = item.trim();
          if (item) {
            let itemParts = item.split(":");
            if (itemParts.length > 1) {
              let key = itemParts[0].trim();
              let value = itemParts.slice(1).join(":").trim();

              this.selections.push({
                key: key,
                value: value
              });
            }
          }
        }
      }
      else if (section) {
        // Handle other sections (Significance, Base, Weight)
        let sectionParts = section.split(":");
        if (sectionParts.length > 1) {
          let key = sectionParts[0].trim();
          let value = sectionParts.slice(1).join(":").trim();

          this.selections.push({
            key: key,
            value: value
          });
        }
      }
    }
  }

  toggleLeftPanel() {
    this.isHidden = !this.isHidden;
  }

  getChatListData() {
    this.apiService.getChatList().subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData && apiResponse.Data) {
          const allChats = JSON.parse(apiResponse.Data) as ChatListDocument[];
          this.allChatList = allChats;
          this.onChatSearch();

        } else {
          this.recentChats = [];
          this.olderChats = [];
          this.allChatList = [];
          this.chatAccordions = [];
        }
      },
      error: () => {
        console.error('Error while fetching chat list');
        this.recentChats = [];
        this.olderChats = [];
      }
    });
  }

  /**
   * Load the latest chat if exists when coming from landing page
   */
  loadLatestChatIfExists() {
    // Don't auto-load if user explicitly started a new chat session
    if (this.isNewChatSession) {
      console.log('New chat session - skipping auto-load of latest chat');
      this.isNewChatSession = false; // Reset the flag after checking
      this.currentView = 'landing'; // Show welcome section for new chat
      this.arktabaccess = false; // Stop loader
      return;
    }

    // Keep in loading state while determining what to show
    // Wait a bit for chat list to load
    setTimeout(() => {
      console.log('loadLatestChatIfExists - checking allChatList:', this.allChatList?.length || 0);
      
      if (this.allChatList && this.allChatList.length > 0) {
        // Chats available - switch to chat view
        // Sort by CreatedAt to get the latest chat
        const sortedChats = [...this.allChatList].sort((a, b) => {
          const dateA = a.CreatedAt ? new Date(a.CreatedAt).getTime() : 0;
          const dateB = b.CreatedAt ? new Date(b.CreatedAt).getTime() : 0;
          return dateB - dateA; // Most recent first
        });

        const latestChat = sortedChats[0];
        
        if (latestChat && latestChat.ChatId) {
          console.log('Loading latest chat:', latestChat.ChatId, 'with', latestChat.ChatHistory?.length || 0, 'messages');
          this.newChatId = latestChat.ChatId;
          this.guidChatId = latestChat.ChatId; // Set guidChatId to the existing chat ID
          this.selectedChatId = latestChat.ChatId;
          
          // Load the chat history for this chat (all questions)
          if (latestChat.ChatHistory && latestChat.ChatHistory.length > 0) {
            // Switch to chat view now that we have valid data
            this.currentView = 'chat';
            
            // Sort by MessageIndex to ensure correct order
            const sortedHistory = [...latestChat.ChatHistory].sort((a, b) => {
              const indexA = a.MessageIndex !== undefined ? a.MessageIndex : 0;
              const indexB = b.MessageIndex !== undefined ? b.MessageIndex : 0;
              return indexA - indexB;
            });

            // Map all messages to chatPreviewBlocks for display in chat-content
            this.chatPreviewBlocks = sortedHistory.map(msg => ({
              question: msg.Question || '',
              response: msg.QuestionAnswer || '',
              messageId: msg.MessageId,
              isLiked: msg.IsLiked ?? null, // Load feedback from chat history
              isStarred: msg.IsStarred || false,
              feedbackSaved: (msg.IsLiked === true || msg.IsLiked === false), // Feedback saved if IsLiked is true or false
              showDislikeInput: false,
              dislikeReason: msg.DislikeReason || '', // Load dislike reason from chat history
              QuestionAnswer: msg.QuestionAnswer || ''
            }));

            console.log('chatPreviewBlocks populated with', this.chatPreviewBlocks.length, 'messages');
            console.log('Feedback states loaded from backend:', this.chatPreviewBlocks.map(c => ({ 
              messageId: c.messageId, 
              rawIsLiked: sortedHistory.find(m => m.MessageId === c.messageId)?.IsLiked,
              isLiked: c.isLiked, 
              feedbackSaved: c.feedbackSaved 
            })));

            // Scroll to the bottom to show the latest question
            this.scrollToBottom();

            // Load the response/output for the last message only
            const lastMessage = sortedHistory[sortedHistory.length - 1];
            if (lastMessage && lastMessage.MessageId) {
              console.log('Loading response for last message:', lastMessage.MessageId);
              this.getChatResponse(lastMessage.MessageId, true);
            }

            // Stop loader after data is loaded and displayed
            this.arktabaccess = false;
          } else {
            // No chat history in latest chat - show welcome section
            this.currentView = 'landing';
            this.arktabaccess = false;
          }
        } else {
          // No valid latest chat - show welcome section
          this.currentView = 'landing';
          this.arktabaccess = false;
        }
      } else {
        console.log('No chats available to load');
        // No chats available - show welcome section
        this.currentView = 'landing';
        this.arktabaccess = false;
      }
    }, 1000); // Give time for the API call to complete (increased to 1000ms)
  }

  onChatSearch(): void {
    const searchText = this.chatSearchText.toLowerCase().trim();
    const searchTokens = searchText.split(/\s+/).filter(token => token.length > 0);
    console.log('Search Text:', searchText, 'Tokens:', searchTokens);

    // Fallback: If allChatList is empty but we have displayed chats, populate it (fixes hot-reload issues)
    if (this.allChatList.length === 0 && (this.recentChats.length > 0 || this.olderChats.length > 0)) {
      this.allChatList = [...this.recentChats, ...this.olderChats];
    }

    console.log('Total Chats:', this.allChatList.length);

    // Filter chats
    // Filter chats
    const filteredChats = this.allChatList.filter(chat => {
      const title = (chat.ChatTitle || '').toLowerCase();
      // If no search text, show all. Otherwise, check if EVERY token exists in the title.
      return searchTokens.length === 0 || searchTokens.every(token => title.includes(token));
    });

    this.chatAccordions = filteredChats.map(chat => {
      // Find the first question (MessageIndex 0)
      const firstQuestion = (chat.ChatHistory || []).find(h => h.MessageIndex === 0);

      // Include ALL messages including index 0 in the history list (no filtering)
      const history = (chat.ChatHistory || []);

      // Use the first question text as the header, fallback to ChatTitle if not found
      const headerTitle = firstQuestion ? firstQuestion.Question : chat.ChatTitle;

      return {
        mainQuestion: headerTitle,
        mainQuestionMessageId: firstQuestion?.MessageId || null, // Store MessageId for the main question
        chatId: chat.ChatId,
        questions: history, // Now includes index 0 as well
        isExpanded: false
      };
    });
  }


  saveChatList(title: string, chatResponse?: { [key: string]: string }[]) {
    this.newChatId = null;

    // Generate chatId if not already present
    if (!this.guidChatId) {
      this.guidChatId = this.generateGuid();
    }

    // Check if the chat already exists in the chat list
    const chatExists = this.allChatList.some(chat => chat.ChatId === this.guidChatId);
    
    if (chatExists) {
      // Chat already exists, skip API call and directly save chat history
      console.log('Chat already exists in list, skipping saveChatList API call');
      this.newChatId = this.guidChatId;
      this.selectedChatId = this.newChatId;
      
      // Directly save chat history without calling saveChatList API
      this.saveChatHistory(this.newChatId, chatResponse, title);
      return;
    }

    // Chat doesn't exist, call API to save it
    this.apiService.saveChatList(title, this.guidChatId).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData && apiResponse.Data) {
          this.newChatId = apiResponse.Data;
          this.selectedChatId = this.newChatId;
          this.getChatListData();
          
          // Always save chat history to get messageId, even if chatResponse is empty
          this.saveChatHistory(this.newChatId, chatResponse, title);
        }
      },
      error: () => {
        console.error('Error while saving chat list');
      }
    });
  }

  saveChatHistory(
    chatId: string, 
    questionAnswer?: { [key: string]: string }[], 
    question?: string, 
    messageIndex?: number, 
    questionAnswerMarkdown?: string,
    isLiked?: boolean | null,
    dislikeReason?: string
  ) {
    // QuestionAnswer = the markdown formatted AI response
    const questionText = question || '';

    // Get the QuestionAnswer markdown - use passed value or use default
    const questionAnswerText = questionAnswerMarkdown || this.defaultQuestionAnswer;

    // Answer = only the responses array (GetMcode, getInsights, etc.)
    const answerString = questionAnswer && questionAnswer.length > 0
      ? JSON.stringify(questionAnswer)
      : JSON.stringify([]);

    // Build ChatHistory document
    const chatHistory: ChatHistoryDocument = {
      UserId: this.userId || '',
      ChatId: chatId || '',
      Question: questionText,
      MessageIndex: messageIndex || 0,
      QuestionAnswer: questionAnswerText,  // The markdown formatted AI response (default value)
      IsActive: true,
      IsStarred: false,
      IsLiked: isLiked ?? null,            // Add feedback field
      DislikeReason: dislikeReason || ''   // Add feedback reason
    };

    // Build ChatAnswer document - Answer contains only the responses
    const chatAnswer: ChatAnswerDocument = {
      UserId: this.userId || '',
      ChatId: chatId || '',
      Answer: answerString  // Only the responses (GetMcode, getInsights, etc.)
    };

    // Prepare diagnostic payload with all relevant information
    const diagnosticPayload = this.prepareDiagnosticPayload();

    // Build the request with both ChatHistory and ChatAnswer
    const request: SaveChatResponseRequest = {
      ChatHistory: chatHistory,
      ChatAnswer: chatAnswer,
      PythonPrompt: diagnosticPayload ? JSON.stringify(diagnosticPayload) : undefined,
      SelectedClient: this.selected_client || this.landingdata?.client_code || undefined,
      SelectedStudy: this.selected_study || this.landingdata?.study || undefined,
      InputQuery: questionText || undefined
    };

    console.log("SaveChatResponseRequest", request);
    this.apiService.saveChatHistory(request).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData && apiResponse.Data) {
          const messageId = apiResponse.Data;
          console.log('Chat history saved, MessageId:', messageId);
          
          // Update the latest chat block with the messageId
          if (this.chatPreviewBlocks.length > 0) {
            const latestChat = this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1];
            if (!latestChat.messageId) {
              latestChat.messageId = messageId;
            }
          }
          
          // Refresh the chat list to show the updated chat
          this.getChatListData();
        }
      },
      error: (err) => {
        console.error('SaveChatHistory error:', err);
      }
    });
  }

  prepareDiagnosticPayload(): any {
    try {
      // Create a comprehensive diagnostic payload
      const payload: any = {
        mcode: this.mcode,
        Widget_ID: this.Widget_Id || this.promptData?.Widget_ID,
        user_input: this.promptData?.user_input,
        isTotalBase: this.isTotalBase,
        isBrandAnalysis: this.isBrandAnalysis,
        entryPointData: this.dataArray || [],
        
        // Selection data
        Row: this.dataObject?.Row || [],
        Column: this.dataObject?.Column || [],
        Filter: this.dataObject?.Filter || [],
        RowNesting: this.dataObject?.RowNesting || [],
        ColNesting: this.dataObject?.ColNesting || [],
        
        // Configuration
        clientCode: this.landingdata?.client_code || this.selected_client,
        studyname: this.landingdata?.study || this.selected_study,
        significance: this.DefaultConfidenceLevel || 'None',
        confidenceLevel: this.DefaultConfidenceLevel || 'None',
        SelectedWeight: this.selectedWeight || 'weight',
        
        // Snapshot related
        Section: this.promptData?.Section,
        SubSection: this.promptData?.SubSection,
        Snapshot_Name: this.promptData?.Snapshot_Name,
        Snapshot_Type: this.promptData?.Snapshot_Type,
        Page_ID: this.promptData?.Page_ID,
        
        // Additional prompt data if available
        ...(this.promptData || {})
      };

      return payload;
    } catch (error) {
      console.error('Error preparing diagnostic payload:', error);
      return this.promptData || {};
    }
  }

  getChatResponse(messageId: string, showSingleMessageOnly: boolean = false) {
    // Find the chat that contains this message
    const chat = this.allChatList.find(c => c.ChatHistory && c.ChatHistory.some(h => h.MessageId === messageId));

    if (chat) {
      this.selectedChatId = chat.ChatId || null;
      this.guidChatId = chat.ChatId || ''; // Set guidChatId to preserve chat session
      this.newChatId = chat.ChatId || null; // Set newChatId as well for consistency

      // Only update chatPreviewBlocks if NOT showing single message only
      // When showSingleMessageOnly is true, we just want to load the output/visualization
      // without modifying the chat history display
      if (!showSingleMessageOnly) {
        this.chatPreviewBlocks = (chat.ChatHistory || []).map(h => ({
          question: h.Question || '',
          response: '', // We don't have the full text response in the list summary
          messageId: h.MessageId,
          isStarred: h.IsStarred || false,
          isLiked: h.IsLiked ?? null,              // Load feedback from chat history
          feedbackSaved: (h.IsLiked === true || h.IsLiked === false),  // Feedback saved if IsLiked is true or false
          showDislikeInput: false,
          dislikeReason: h.DislikeReason || '',    // Load dislike reason from chat history
          QuestionAnswer: h.QuestionAnswer || this.defaultQuestionAnswer
        }));
      }
    } else {
      // Fallback: just use the messageId as chatId (legacy behavior) or clear context
      this.selectedChatId = messageId;
      this.guidChatId = messageId; // Set guidChatId even in fallback case
    }


    // Close the chat history panel when a question is clicked
    this.isChatHistoryOpen = false;
    this.isQuestionBrowserOpen = false;

    // Ensure inputValue is empty so sendInputMessage doesn't add a duplicate block
    this.inputValue = '';

    this.apiService.getChatResponse(messageId).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);

        if (apiResponse.HasValidData && apiResponse.Data) {
          let historyItem: any;
          const parsedData = JSON.parse(apiResponse.Data);

          if (Array.isArray(parsedData)) {
            historyItem = parsedData[0];
          } else {
            historyItem = parsedData;
          }

          console.log("chatResponse.Answer", historyItem?.Answer);
          // Parse Answer string back to object if it's a string
          let answerData = historyItem?.Answer;
          if (typeof answerData === 'string') {
            try {
              answerData = JSON.parse(answerData);
            } catch (e) {
              console.error('Error parsing Answer:', e);
            }
          }
          this.sendInputMessage(answerData, true);
        } else {
          // If no data, maybe keep the history but show no result?
          // this.chatHistory = []; 
        }
      },
      error: (err) => {
        console.error('Error while fetching chat response:', err);
        this.chatHistory = [];
      }
    });
  }

  toggleStarred(chat: { question: string, response: string, messageId?: string, isStarred?: boolean, isLiked?: boolean | null, dislikeReason?: string }) {
    if (!chat.messageId || !this.selectedChatId) {
      console.warn('Cannot toggle starred: messageId is not available');
      this.showToast('Cannot star: Message ID is not available', 'error');
      return;
    }

    const newStarredState = !chat.isStarred;

    this.apiService.updateChatStarred(chat.messageId, newStarredState).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData) {
          // Update local state
          chat.isStarred = newStarredState;
          console.log(`Chat ${chat.messageId} starred status updated to: ${newStarredState}`);
          this.showToast(newStarredState ? 'Message starred successfully' : 'Message unstarred successfully', 'success');
        } else {
          console.error('Failed to update starred status:', apiResponse.ExceptionMessage);
          this.showToast('Failed to update starred status', 'error');
        }
      },
      error: (err) => {
        console.error('Error while updating starred status:', err);
        this.showToast('Error while updating starred status', 'error');
      }
    });
  }

  onDeleteClick(chat: { question: string, response: string, messageId?: string, isStarred?: boolean, isLiked?: boolean | null, feedbackSaved?: boolean, showDislikeInput?: boolean, dislikeReason?: string, QuestionAnswer?: string }) {
    if (!chat.messageId) {
      console.warn('Cannot delete message: messageId is not available');
      this.showToast('Cannot delete: Message ID is not available', 'error');
      return;
    }

    // Optional: Show confirmation dialog
    if (!confirm('Are you sure you want to delete this message?')) {
      return;
    }

    this.apiService.deleteChatMessage(chat.messageId).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData) {
          // Remove the chat from the UI
          const index = this.chatPreviewBlocks.indexOf(chat);
          if (index > -1) {
            this.chatPreviewBlocks.splice(index, 1);
          }
          console.log(`Chat ${chat.messageId} deleted successfully`);
          this.showToast('Message deleted successfully', 'success');
          
          // Refresh the chat list
          this.getChatListData();
        } else {
          console.error('Failed to delete message:', apiResponse.ExceptionMessage);
          this.showToast('Failed to delete message', 'error');
        }
      },
      error: (err) => {
        console.error('Error while deleting message:', err);
        this.showToast('Error while deleting message', 'error');
      }
    });
  }

  onLikeClick(chat: { question: string; response: string; messageId?: string; isLiked?: boolean | null; feedbackSaved?: boolean; showDislikeInput?: boolean; dislikeReason?: string }) {
    if (!chat.messageId || !this.selectedChatId) {
      console.warn('Cannot save feedback: messageId or chatId is not available');
      this.showToast('Cannot save feedback: Message ID is not available', 'error');
      return;
    }

    // Close any open dislike input
    chat.showDislikeInput = false;
    chat.dislikeReason = '';

    // If already liked, remove the like (toggle off)
    const newLikedState = chat.isLiked === true ? null : true;

    this.saveFeedback(chat, newLikedState, '');
  }

  onDislikeClick(chat: { question: string; response: string; messageId?: string; isLiked?: boolean | null; feedbackSaved?: boolean; showDislikeInput?: boolean; dislikeReason?: string }) {
    if (!chat.messageId || !this.selectedChatId) {
      console.warn('Cannot save feedback: messageId or chatId is not available');
      this.showToast('Cannot save feedback: Message ID is not available', 'error');
      return;
    }

    // If already disliked, toggle off and close input
    if (chat.isLiked === false) {
      chat.showDislikeInput = false;
      chat.dislikeReason = '';
      this.saveFeedback(chat, null, '');
    } else {
      // Show the dislike reason input box
      chat.showDislikeInput = true;
      chat.dislikeReason = '';
    }
  }

  submitDislikeFeedback(chat: { question: string; response: string; messageId?: string; isLiked?: boolean | null; feedbackSaved?: boolean; showDislikeInput?: boolean; dislikeReason?: string }) {
    if (!chat.messageId || !this.selectedChatId) {
      console.warn('Cannot save feedback: messageId or chatId is not available');
      return;
    }

    const reason = chat.dislikeReason?.trim() || '';
    this.saveFeedback(chat, false, reason);
    chat.showDislikeInput = false;
  }

  cancelDislikeFeedback(chat: { question: string; response: string; messageId?: string; isLiked?: boolean | null; feedbackSaved?: boolean; showDislikeInput?: boolean; dislikeReason?: string }) {
    chat.showDislikeInput = false;
    chat.dislikeReason = '';
  }

  private saveFeedback(
    chat: { question: string; response: string; messageId?: string; isLiked?: boolean | null; feedbackSaved?: boolean; showDislikeInput?: boolean; dislikeReason?: string },
    isLiked: boolean | null,
    dislikeReason: string
  ) {
    if (!chat.messageId || !this.selectedChatId) {
      console.warn('Cannot save feedback: messageId or chatId is not available');
      this.showToast('Cannot save feedback: Message ID is not available', 'error');
      return;
    }

    console.log('saveFeedback - Before save:', { messageId: chat.messageId, isLiked, currentIsLiked: chat.isLiked });

    // Prepare the feedback request matching the C# API
    const feedbackRequest = {
      MessageId: chat.messageId,
      IsLiked: isLiked, // Send null if feedback is being removed
      DislikeReason: dislikeReason || ''
    };

    // Call the SaveChatFeedback API
    this.apiService.saveChatFeedback(feedbackRequest).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData) {
          // Update local state immediately - this will trigger CSS class changes
          chat.isLiked = isLiked;
          chat.feedbackSaved = (isLiked === true || isLiked === false);
          chat.dislikeReason = dislikeReason;
          
          console.log('saveFeedback - After save:', { messageId: chat.messageId, isLiked: chat.isLiked, feedbackSaved: chat.feedbackSaved });
          
          // Show appropriate toast message
          if (isLiked === true) {
            this.showToast('Feedback saved: Liked', 'success');
          } else if (isLiked === false) {
            this.showToast('Feedback saved: Disliked', 'success');
          } else {
            this.showToast('Feedback removed', 'success');
          }
        } else {
          console.error('Failed to save feedback:', apiResponse.ExceptionMessage);
          this.showToast('Failed to save feedback', 'error');
        }
      },
      error: (err: any) => {
        console.error('Error while saving feedback:', err);
        this.showToast('Error while saving feedback', 'error');
      }
    });
  }

  parseChatResponse(ChatResponse: any): {
    GetMcode?: any;
    getSnapshotConfiguration?: any;
    GetCustomSnapshotWidget?: any;
    GetQuery?: any;
    getSnapshotOutput?: any;
    getSnapshotLoadData?: any;
    getConfiguration?: any;
    getSnapshotInsights?: any;
    getInsights?: any;
  } {
    const parsedResponses: Record<string, any> = {};

    if (!Array.isArray(ChatResponse)) {
      return {};
    }
    ChatResponse.forEach((item: any, index: any) => {
      if (typeof item !== 'object' || item === null) return;

      Object.keys(item).forEach((key) => {
        const value = item[key];
        if (typeof value === 'string') {
          try {
            // Only try to parse if it looks like JSON (starts with { or [)
            const trimmedValue = value.trim();
            if ((trimmedValue.startsWith('{') && trimmedValue.endsWith('}')) || 
                (trimmedValue.startsWith('[') && trimmedValue.endsWith(']'))) {
              parsedResponses[key] = JSON.parse(value);
            } else {
              parsedResponses[key] = value;
            }
          } catch (e) {
            console.error(`Error parsing key "${key}" at index ${index}`, e);
            parsedResponses[key] = value; // Keep original value if parsing fails
          }
        } else {
          parsedResponses[key] = value;
        }
      });
    });

    return {
      GetMcode: parsedResponses['GetMcode'],
      getSnapshotConfiguration: parsedResponses['getSnapshotConfiguration'],
      GetCustomSnapshotWidget: parsedResponses['GetCustomSnapshotWidget'],
      GetQuery: parsedResponses['GetQuery'],
      getSnapshotOutput: parsedResponses['getSnapshotOutput'],
      getSnapshotLoadData: parsedResponses['getSnapshotLoadData'],
      getConfiguration: parsedResponses['getConfiguration'],
      getSnapshotInsights: parsedResponses['getSnapshotInsights'],
      getInsights: parsedResponses['getInsights'],
    };
  }

  pushChatResponseEntry(key: string, value: any) {
    const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
    this.chatResponse.push({ [key]: stringValue });
  }

  preapreexceldata(data: any) {
    // let outputTrendArray = JSON.parse(data.outputTrendArray)[0];
    let outputTrendArray = JSON.parse(data.outputTrendArray);
    outputTrendArray = _.sortBy(outputTrendArray, 'previewChartPostion');
    let formetterdata = [];
    for (let i = 0; i < outputTrendArray.length; i++) {
      let currentwightdat = outputTrendArray[i];
      let custumization = JSON.parse(
        currentwightdat.customizationProperties || '{}'
      );
      for (let x = 0; x < currentwightdat.metric.length; x++) {
        for (
          let j = 0;
          j < currentwightdat.metric[x].metric_value.length;
          j++
        ) {
          let currentmetricdata = currentwightdat.metric[x].metric_value[j];
          for (let k = 0; k < currentmetricdata.data.length; k++) {
            let obj: any = {};
            obj.widget_name = currentwightdat.widget_name;
            obj.widgetchart_name = currentwightdat.widgetchart_name;
            obj.option = currentmetricdata.option;
            _.extend(obj, currentmetricdata.data[k]);
            obj.roundoffvalue = custumization.decimalRoundOff;
            formetterdata.push(obj);
          }
        }
      }
    }
    data.outputTrendArray = JSON.stringify(formetterdata);
    return data;
  }

  preapreexceldata1(data: any) {
    let outputTrendArray = JSON.parse(data.outputTrendArray);

    for (let i = 0; i < outputTrendArray.length; i++) {
      let currentWidgetData = outputTrendArray[i];

      // Check if metric exists
      if (currentWidgetData.metric && currentWidgetData.metric.length) {
        for (let x = 0; x < currentWidgetData.metric.length; x++) {
          let currentMetric = currentWidgetData.metric[x];

          // Check if metric_value exists
          if (currentMetric.metric_value && currentMetric.metric_value.length) {
            for (let j = 0; j < currentMetric.metric_value.length; j++) {
              let currentMetricValue = currentMetric.metric_value[j];

              // Check if data exists and deduplicate
              if (currentMetricValue.data && Array.isArray(currentMetricValue.data)) {
                currentMetricValue.data = _.uniqWith(currentMetricValue.data, _.isEqual);
              }
            }
          }
        }
      }
    }

    // Store back as JSON string
    data.outputTrendArray = JSON.stringify([outputTrendArray]);

    return data;
  }

  excelexportClicked() {
    let allpageOutputDataWithoutTrend = _.cloneDeep(
      this._configService.allPageOutputDataWithoutTrend
    )[0].sort(
      (a: any, b: any) => a.previewChartPostion - b.previewChartPostion
    );
    const filteredDataoutputArray = allpageOutputDataWithoutTrend.filter(
      (item: any) => item.widget_name === this.filteredWidgetData.widget_name
    );
    const filteredDataoutputTrendArray = this._configService.allPageOutputData[0].filter(
      (item: any) => item.widget_name === this.filteredWidgetData.widget_name
    );
    this._configService.setDropdownValue(
      'outputArray',
      JSON.stringify(filteredDataoutputArray)
    );
    this._configService.setDropdownValue(
      'outputTrendArray',
      JSON.stringify(filteredDataoutputTrendArray)
    );
    this.handleExcelExportClick();
  }

  handleExcelExportClick() {
    // let data = this._configService.getDropdownValues();
    let data = this.Snapshotdataforexport;

    if (
      data.compareAcross == 'Multiple Brands' ||
      data.compareAcross == 'Multiple Markets'
    ) {
      data = this.preapreexceldata(data);
    } else {
      data = this.preapreexceldata1(data);
    }

    if (this.significanceSelectedValue != 'None') {
      data.confidenceLevel = this.displayConfidenceLevel;
    } else {
      data.confidenceLevel = 'None';
    }
    data.userRole = "superadmin";
    data.custumview = true;
    data.isAggregatedData = this._configService.isAggregatedData;
    data.isSemiAggregatedData = this._configService.isSemiAggregatedData;
    data.isRespondentLevel = this._configService.isRespondentLevel;
    data.compareacrossmultiplesection = data.selectionSummary
      .split('||')[0]
      .trim()
      .split(':')
      .slice(1)
      .map((part: any) => part.trim())
      .join(' | ');
    this._loaderService.showLoader();
    const payload = { ...data };
    payload.insightSelectionSummary = JSON.stringify(this.insightsVal);

    if (typeof payload.outputArray !== 'string') {
      try {
        payload.outputArray = JSON.stringify(payload.outputArray ?? {});
      } catch (e) {
        console.error('Failed to stringify outputArray:', e);
        payload.outputArray = '[]';
      }
    }

    if (typeof payload.outputTrendArray !== 'string') {
      try {
        payload.outputTrendArray = JSON.stringify(payload.outputTrendArray ?? []);
      } catch (e) {
        console.error('Failed to stringify outputTrendArray:', e);
        payload.outputTrendArray = '[]';
      }
    }

    this.subscriptions.add(
      this.apiService.exportToExcelARKSnapshot(payload).subscribe(
        (excelBlob: Blob) => {
          //;
          let datetimeFormat = this.getCurrentDateTime();
          let fileName =
            'Snapshot' +
            '_' +
            data.clientName +
            '_' +
            data.snapshotName +
            '_' +
            data.compareAcross +
            '_' +
            datetimeFormat +
            '.xlsx';
          // Trigger file download
          this.downloadFile(excelBlob, fileName);
          this._loaderService.hideLoader();
          this.usageDataLog('Excel Export');
        },
        (error) => {
          //this.errorPopup('Something went wrong, please try again');
          this._loaderService.hideLoader();
        }
      )
    );
  }

  editablePPTClicked(isTredendDataRequired: boolean = false) {
    this._loaderService.showLoader();
    let allpageOutputData = _.cloneDeep(
      this._configService.allPageOutputData
    )[0].sort(
      (a: any, b: any) => a.previewChartPostion - b.previewChartPostion
    );
    let allpageOutputDataWithoutTrend = _.cloneDeep(
      this._configService.allPageOutputDataWithoutTrend
    )[0].sort(
      (a: any, b: any) => a.previewChartPostion - b.previewChartPostion
    );
    // this._configService.setDropdownValue(
    //   'outputArray',
    //   JSON.stringify(allpageOutputDataWithoutTrend)
    // );
    // this._configService.setDropdownValue(
    //   'outputTrendArray',
    //   JSON.stringify(allpageOutputData)
    // );
    const filteredDataoutputArray = allpageOutputDataWithoutTrend.filter(
      (item: any) => item.widget_name === this.filteredWidgetData.widget_name
    );
    const filteredDataoutputTrendArray = this._configService.allPageOutputData[0].filter(
      (item: any) => item.widget_name === this.filteredWidgetData.widget_name
    );
    this._configService.setDropdownValue(
      'outputArray',
      JSON.stringify(filteredDataoutputArray)
    );
    this._configService.setDropdownValue(
      'outputTrendArray',
      JSON.stringify(filteredDataoutputTrendArray)
    );
    this._configService.setDropdownValue('product', 'custom');

    this._configService.getDropdownValues().staticText =
      this._configService.staticText;
    // let data = _.cloneDeep(this._configService.getDropdownValues());
    // let data = _.cloneDeep(this._configService.getDropdownValues());
    let data = this.Snapshotdataforexport;

    data.isAggregatedData = this._configService.isAggregatedData;
    data.isSemiAggregatedData = this._configService.isSemiAggregatedData;
    data.isRespondentLevel = this._configService.isRespondentLevel;

    let newCustomizationData: any;
    if (
      this._configService.newCustomizationData != null &&
      this._configService.newCustomizationData != undefined
    ) {
      newCustomizationData = this._configService.newCustomizationData;
    }

    if (
      data.compareAcross == 'Multiple Brands' ||
      data.compareAcross == 'Multiple Markets'
    ) {
      let outputTrendArray = JSON.parse(data.outputTrendArray);
      outputTrendArray = _.sortBy(outputTrendArray, 'previewChartPostion');
      let formetterdata = [];

      if (data.outputArray != null) {
        let outputArray = JSON.parse(data.outputArray);
        outputArray.forEach((itm: any) => {
          if (newCustomizationData != null) {
            let customization = _.filter(
              newCustomizationData,
              (x) => x.widget_name == itm.widget_name
            );
            if (customization != null && customization.length > 0) {
              itm.customizationProperties =
                customization[0].customizationProperties;
            }
          }
        });

        data.outputArray = JSON.stringify(
          JSON.parse(JSON.stringify(outputArray))
        );
      }
      for (let i = 0; i < outputTrendArray.length; i++) {
        let currentwightdat = outputTrendArray[i];
        let custumization = JSON.parse(
          currentwightdat.customizationProperties || '{}'
        );
        for (let x = 0; x < currentwightdat.metric.length; x++) {
          for (
            let j = 0;
            j < currentwightdat.metric[x].metric_value.length;
            j++
          ) {
            let currentmetricdata = currentwightdat.metric[x].metric_value[j];

            for (let k = 0; k < currentmetricdata.data.length; k++) {
              let obj: any = {};
              obj.widget_name = currentwightdat.widget_name;
              obj.widgetchart_name = currentwightdat.widgetchart_name;
              obj.roundoffvalue = custumization.decimalRoundOff;
              obj.option = currentmetricdata.option;
              _.extend(obj, currentmetricdata.data[k]);
              formetterdata.push(obj);
            }
          }
        }
      }
      data.outputTrendArrayforExcel = JSON.stringify(formetterdata);
    } else {
      let outputTrendArray = JSON.parse(data.outputTrendArray);
      let formetterdata = [];
      if (data.outputArray != null) {
        let outputArray = JSON.parse(data.outputArray);
        outputArray.forEach((itm: any) => {
          if (newCustomizationData != null) {
            let customization = _.filter(
              newCustomizationData,
              (x) => x.widget_name == itm.widget_name
            );
            if (customization != null && customization.length > 0) {
              itm.customizationProperties =
                customization[0].customizationProperties;
            }
          }
        });

        data.outputArray = JSON.stringify(
          JSON.parse(JSON.stringify(outputArray))
        );
      }
      for (let i = 0; i < outputTrendArray.length; i++) {
        let currentwightdat = outputTrendArray[i];
        for (let x = 0; x < currentwightdat.metric.length; x++) {
          for (
            let j = 0;
            j < currentwightdat.metric[x].metric_value.length;
            j++
          ) {
            let custumization = JSON.parse(
              currentwightdat.customizationProperties || '{}'
            );
            if (newCustomizationData != null) {
              let customization = _.filter(
                newCustomizationData,
                (x) => x.widget_name == currentwightdat.widget_name
              );
              if (customization != null && customization.length > 0) {
                outputTrendArray[i].customizationProperties =
                  customization[0].customizationProperties;
              }
            }

            outputTrendArray[i].metric[x].metric_value[j].data = _.uniqWith(
              outputTrendArray[i].metric[x].metric_value[j].data,
              _.isEqual
            );
          }
        }
      }
      data.outputTrendArrayforExcel = JSON.stringify([outputTrendArray]);
    }

    if (this.significanceSelectedValue != 'None') {
      data.confidenceLevel = this.displayConfidenceLevel;
    } else {
      data.confidenceLevel = 'None';
    }
    data.colorpalate = JSON.stringify(this.commonchartmodules.color1);
    let element = document.getElementById('preview_body');
    let imgString = '';
    data.significance = this._configService.getDropdownValues().significance;
    data.insightselectionSummary = JSON.stringify(this.insightsVal);
    data.userInput = this.chatPreviewBlocks.map(c => c.question);
    this.subscriptions.add(
      this.apiService
        .callPptExportSnapshot(imgString, data, isTredendDataRequired)
        .subscribe(
          (pptBlob: Blob) => {
            // Snapshot_ClientName_SnapshotName_Timestamp.pptx
            let fileName =
              this._configService.getDropdownValues().clientName +
              '_' +
              this._configService.getDropdownValues().snapshotName +
              '_' +
              this.getCurrentDateTime() +
              '.pptx';
            this.downloadPPTFile(pptBlob, fileName);
            this.usageDataLog('Editable PPT Export');
            let paginationElement = document.getElementById('pagination-div');
            if (paginationElement) {
              paginationElement.style.visibility = 'visible';
            }
            this._loaderService.hideLoader();
            // this.showExportContainer = false;
            // this.showContainer = false;
          },
          (error) => {
            // this.errorheaderTitle = 'Error';
            // this.popUpTitle = 'Error';
            // //this.showPopUp = false;
            // this.popUpMessage = 'Some Error Occured..!';
            // this.showErrorPopUp = true;
            let paginationElement = document.getElementById('pagination-div');
            if (paginationElement) {
              paginationElement.style.visibility = 'visible';
            }
            this._loaderService.hideLoader();
          }
        )
    );
  }

  // Handle new chat button click - generates a new GUID for a new conversation
  onNewChatClick(): void {
    // Generate a new GUID for the new chat
    this.guidChatId = this.generateGuid();

    // Reset selected chat
    this.selectedChatId = null;

    // Clear input and output
    this.inputValue = '';
    this.chatPreviewBlocks = [];
    this.insightsVal = '';
    this.displayTable = false;
    this.showSnapshot = false;
    this.failedCase = false;
    this.isInsightspopupOpen = false;

    // Clear output data
    this.OutputdataObject.Row = [];
    this.OutputdataObject.Column = [];
    this.CrossTabOutPutData = [];

    // Show landing page
    this.askMeLanding = true;

    console.log('New chat created with GUID:', this.guidChatId);
  }

  // Generate a GUID/UUID using the uuid library
  showToast(message: string, type: 'success' | 'error' | 'info' = 'success') {
    this.toastMessage = message;
    this.toastType = type;
    this.showToastNotification = true;

    // Auto-hide toast after 3 seconds
    setTimeout(() => {
      this.showToastNotification = false;
    }, 3000);
  }

  generateGuid(): string {
    return uuidv4();
  }

  sendKeyQuestion(question: string): void {
    this.searchText = question;
    this.navigateToChat();
    this.onSendMessage();
  }
}

function ExtractDate(Datetime: string) {
  const date = new Date(Datetime);

  // Get the date, hours, and minutes
  const formattedDate = `${date.toISOString().split('T')[0]
    } ${date.getHours()}:${date.getMinutes()}`;
  return formattedDate;
}
